/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				var _m = moreModules[moduleId];
/******/
/******/ 				// Check if module is deduplicated
/******/ 				switch(typeof _m) {
/******/ 				case "object":
/******/ 					// Module can be created from a template
/******/ 					modules[moduleId] = (function(_m) {
/******/ 						var args = _m.slice(1), templateId = _m[0];
/******/ 						return function (a,b,c) {
/******/ 							modules[templateId].apply(this, [a,b,c].concat(args));
/******/ 						};
/******/ 					}(_m));
/******/ 					break;
/******/ 				case "function":
/******/ 					// Normal module
/******/ 					modules[moduleId] = _m;
/******/ 					break;
/******/ 				default:
/******/ 					// Module is a copy of another module
/******/ 					modules[moduleId] = modules[_m];
/******/ 					break;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		1:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + ".soa/bundle/" + ({"6":"main","7":"track"}[chunkId]||chunkId) + "_" + "aff071efbd474cf21cfc" + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(15);
	__webpack_require__(13);
	__webpack_require__(182);
	__webpack_require__(43);
	__webpack_require__(16);
	module.exports = __webpack_require__(132);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CHECKOUT;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * SEO 默认TDK
	 * @type {string}
	 */
	var SEO = exports.SEO = "SEO";
	
	var IMAGES_RENDER = exports.IMAGES_RENDER = "IMAGES_RENDER";
	
	/**
	 * CONFIG 网站UI结构
	 * @type {string}
	 */
	var CONFIGURATION = exports.CONFIGURATION = "CONFIGURATION";
	
	var HOME = exports.HOME = {
	  SEARCHHISTORY: "SEARCHHISTORY",
	  SWITCHPRODUCTS: "SWITCHPRODUCTS",
	  DEFAULTPRODUCTS: "DEFAULTPRODUCTS",
	  DEFAULTMODULE: "DEFAULTMODULE",
	  BRAND: "HOME.BRAND",
	  SEARCH_TRIM: "HOME.SEARCH_TRIM",
	  TOP_CAROUSEL: "HOME.TOP_CAROUSEL",
	  TOP_MENU: "HOME.TOP_MENU",
	  CATEGORY: "HOME.CATEGORY",
	  CATEGORY_HOVER: "HOME.CATEGORY_HOVER",
	  CATEGORY_SCROLL_TOP: "HOME.CATEGORY_SCROLL_TOP",
	  FIXED_RIGHT_TOP: "HOME.FIXED_RIGHT_TOP",
	  FIXED_RIGHT_BOTTOM: "HOME.FIXED_RIGHT_BOTTOM",
	  FIXED_LEFT_CATEGORY: "HOME.FIXED_LEFT_CATEGORY",
	  NAVIGATION_ALPHABET: "HOME.NAVIGATION_ALPHABET",
	  // "SEARCH_INNER_VALUE":"HOME.SEARCH_INNER_VALUE",
	  // "SEARCH_MYTIMER": "HOME.SEARCH_MYTIMER",
	  // "SEARCH_INNER_PLACEHOLDER": "HOME.SEARCH_INNER_PLACEHOLDER",
	  // "SEARCH_INNER_PLACEHOLDERS":'HOME.SEARCH_INNER_PLACEHOLDERS',
	  PRESS_UP_DOWN_STATIC: "HOME.PRESS_UP_DOWN_STATIC",
	  PRESS_UP_DOWN_FIXED: "HOME.PRESS_UP_DOWN_FIXED",
	
	  SEARCH_MYTIMER_STATIC: "HOME.SEARCH_MYTIMER_STATIC",
	  SEARCH_MYTIMER_FIXED: "HOME.SEARCH_MYTIMER_FIXED",
	  SEARCH_INNER_PLACEHOLDER_STATIC: "HOME.SEARCH_INNER_PLACEHOLDER_STATIC",
	  SEARCH_INNER_PLACEHOLDER_FIXED: "HOME.SEARCH_INNER_PLACEHOLDER_FIXED",
	  SEARCH_INNER_PLACEHOLDERS_STATIC: "HOME.SEARCH_INNER_PLACEHOLDERS_STATIC",
	  SEARCH_INNER_PLACEHOLDERS_FIXED: "HOME.SEARCH_INNER_PLACEHOLDERS_FIXED",
	
	  SEARCH_RESULTS_STATIC: "HOME.SEARCH_RESULTS_STATIC",
	  SEARCH_RESULTS_FIXED: "HOME.SEARCH_RESULTS_FIXED",
	  SEARCH_RESULTS_DOWN: "HOME.SEARCH_RESULTS_DOWN",
	  FIRSTORDERGIFT: "HOME.FIRSTORDERGIFT"
	};
	var USER = exports.USER = {
	  USER_TOKEN: "USER.USER_TOKEN",
	  USER_CARDNUMBER: "USER.USER_CARDNUMBER",
	  USER_PAYPOINTS: "USER.USER_PAYPOINTS",
	  MINI_CART: "USER.MINI_CART",
	  MINI_CART_NUM: "USER.MINI_CART_NUM",
	  USER_NICKNAME: "USER.USER_NICKNAME",
	  USER_CARDPOINTS: "USER.USER_CARDPOINTS",
	  USER_CARDTYPE: "USER.USER_CARDTYPE",
	  ERROR_CODE: "USER.ERROR_CODE",
	  USER_SHIPPING_ADDRESS_LIST: "USER.USER_SHIPPING_ADDRESS_LIST"
	};
	
	var GLOBAL = exports.GLOBAL = {
	  HEIGHT: "GLOBAL.HEIGHT",
	  WIDTH: "GLOBAL.WIDTH",
	  SCROLL_TOP: "GLOBAL.SCROLL_TOP",
	  SCROLL_BOTTOM: "GLOBAL.SCROLL_BOTTOM",
	  PAGESHOW: "GLOBAL.PAGESHOW",
	  CENTERMODEL: "GLOBAL.CENTERMODEL",
	  BEAUTYHREF: "GLOBAL.BEAUTYHREF",
	  TOPRIGHTMODEL: "GLOBAL.TOPRIGHTMODEL"
	};
	
	var CHECKOUT = exports.CHECKOUT = (_CHECKOUT = {
	  CHECKOUT_ATTR_STATUS: "CHECKOUT.CHECKOUT_ATTR_STATUS",
	  CHECKOUT_CUR_TYPE: "CHECKOUT.CHECKOUT_CUR_TYPE",
	  CHECKOUT_CUR_STATUS: "CHECKOUT.CHECKOUT_CUR_STATUS",
	  CHECKOUT_PHONE_STATUS: "CHECKOUT.CHECKOUT_PHONE_STATUS",
	  CHECKOUT_ADDRESS_LIST: "CHECKOUT.CHECKOUT_ADDRESS_LIST",
	  CHECKOUT_RESERVE_PROMOTION_DATA: "CHECKOUT.CHECKOUT_RESERVE_PROMOTION_DATA",
	  CHECKOUT_MISS_SKUID_BOOKING: "CHECKOUT.CHECKOUT_MISS_SKUID_BOOKING",
	  CHECKOUT_MISS_SKUID: "CHECKOUT.CHECKOUT_MISS_SKUID",
	  CHECKOUT_ORDER_DETAILS: "CHECKOUT.CHECKOUT_ORDER_DETAILS",
	  CHECKOUT_ALL_GIFT_BOOKING: "CHECKOUT.CHECKOUT_ALL_GIFT_BOOKING",
	  CHECKOUT_ALL_GIFT: "CHECKOUT.CHECKOUT_ALL_GIFT",
	  CHECKOUT_INPUTCOUPONS: "CHECKOUT.CHECKOUT_INPUTCOUPONS",
	  CHECKOUT_PHONE_DATA: "CHECKOUT.CHECKOUT_PHONE_DATA",
	  CHECKOUT_CHANGE_STATE: "CHECKOUT.CHECKOUT_CHANGE_STATE",
	  SATISFYGIFTCOMMENTS: "SATISFYGIFTCOMMENTS",
	  CHECKOUT_CHANGE_STATE_AGREEMENT: "CHECKOUT.CHECKOUT_CHANGE_STATE_AGREEMENT",
	
	  CHECKOUT_GET: "CHECKOUT.CHECKOUT_GET",
	  CHECKOUT_DEFAULT_ADDRESS: "CHECKOUT.CHECKOUT_DEFAULT_ADDRESS",
	  CHECKOUT_ORDER_ID: "CHECKOUT.CHECKOUT_ORDER_ID",
	  CHECKOUT_INFORMATION: "CHECKOUT.CHECKOUT_INFORMATION",
	  CHECKOUT_CHANGE_PAYMENT: "CHECKOUT.CHECKOUT_CHANGE_PAYMENT",
	  CHECKOUT_CHANGE_RECEIVING: "CHECKOUT.CHECKOUT_CHANGE_RECEIVING",
	  CHECKOUT_PAY_LINK: "CHECKOUT.CHECKOUT_PAY_LINK",
	  CHECKOUT_TAB: "CHECKOUT.CHECKOUT_TAB",
	
	  CHECKOUT_TAB_GUESSYOULIKE: "CHECKOUT.CHECKOUT_TAB_GUESSYOULIKE",
	  CHECKOUT_TAB_MYFAVORITE: "CHECKOUT.CHECKOUT_TAB_MYFAVORITE",
	  CHECKOUT_TAB_MYBROWSERHISTORY: "CHECKOUT.CHECKOUT_TAB_MYBROWSERHISTORY",
	  CHECKOUT_TAB_ACTIVE: "CHECKOUT.CHECKOUT_TAB_ACTIVE",
	
	  CHECKOUT_ORDER_TYPE: "CHECKOUT.CHECKOUT_ORDER_TYPE",
	
	  CHECKOUT_DELETE_POSITION_FIRST: "CHECKOUT.CHECKOUT_DELETE_POSITION_FIRST",
	  CHECKOUT_DELETE_POSITION_SECOND: "CHECKOUT.CHECKOUT_DELETE_POSITION_SECOND",
	  CHECKOUT_DELETE_POSITION_THIRD: "CHECKOUT.CHECKOUT_DELETE_POSITION_THIRD",
	
	  CHECKOUT_DELIVERY_INFO: "CHECKOUT.CHECKOUT_DELIVERY_INFO",
	  CHECKOUT_ADDRESS_COD: "CHECKOUT.CHECKOUT_ADDRESS_COD",
	  CHECKOUT_ADDRESS_EXPRESS: "CHECKOUT.CHECKOUT_ADDRESS_EXPRESS",
	
	  CHECKOUT_PURCHASED: "CHECKOUT.CHECKOUT_PURCHASED",
	  CHECKOUT_CARTINFO: "CHECKOUT.CHECKOUT_CARTINFO",
	  CHECKOUT_CARTINFO_BOOKING: "CHECKOUT.CHECKOUT_CARTINFO_BOOKING",
	
	  CHECKOUT_CLOSE_ALERT: "CHECKOUT.CHECKOUT_CLOSE_ALERT",
	  CHECKOUT_SAVE_ALERT_DATA: "CHECKOUT.CHECKOUT_SAVE_ALERT_DATA",
	  CHECKOUT_NOTICE: "CHECKOUT.CHECKOUT_NOTICE",
	  CHECKOUT_NOTICE_CLOSE: "CHECKOUT.CHECKOUT_NOTICE_CLOSE",
	  CHECKOUT_NOTICE_OPEN_SUCCESS: "CHECKOUT.CHECKOUT_NOTICE_OPEN_SUCCESS",
	  CHECKOUT_ADD_REMOVE: "CHECKOUT.CHECKOUT_ADD_REMOVE",
	  CHECKOUT_CLOSE_DELETE: "CHECKOUT.CHECKOUT_CLOSE_DELETE",
	  CHECKOUT_GET_SKU_STANDARD: "CHECKOUT.CHECKOUT_GET_SKU_STANDARD",
	  CHECKOUT_SAVE_ALL_SKU: "CHECKOUT.CHECKOUT_SAVE_ALL_SKU",
	  CHECKOUT_SAVE_TOTAL_DELETE: "CHECKOUT.CHECKOUT_SAVE_TOTAL_DELETE",
	  CHECKOUT_COLLECT_ITEM_ALL: "CHECKOUT.CHECKOUT_COLLECT_ITEM_ALL",
	  CHECKOUT_CLEAR_LOSE_SKU: "CHECKOUT.CHECKOUT_CLEAR_LOSE_SKU",
	  CHECKOUT_ORDER_INFORMATION: "CHECKOUT.CHECKOUT_ORDER_INFORMATION",
	  CHECKOUT_OPEN_THIRD_ALERT_PAY: "CHECKOUT.CHECKOUT_OPEN_THIRD_ALERT_PAY",
	  CHECKOUT_CLOSE_THIRD_ALERT_PAY: "CHECKOUT.CHECKOUT_CLOSE_THIRD_ALERT_PAY",
	  CHECKOUT_GET_ORDER_STATUS: "CHECKOUT.CHECKOUT_GET_ORDER_STATUS",
	  CHECKOUT_CLEAR_SKU_STANDARD: "CHECKOUT.CHECKOUT_CLEAR_SKU_STANDARD",
	  CHECKOUT_CLEAR_POSITION_DELETE: "CHECKOUT.CHECKOUT_CLEAR_POSITION_DELETE",
	  PXCOUPONS: "CHECKOUT.PXCOUPONS",
	  PROMOTIONCODEMAP: "CHECKOUT.PROMOTIONCODEMAP",
	  ORDER_DETAIL: "CHECKOUT.ORDER_DETAIL", //MyAccount订单详情中已拆走，此处未删除，Hallie
	  CHECKOUT_SELECT_TAB: "CHECKOUT.CHECKOUT_SELECT_TAB", //checkout  tab切换,
	  CHECKOUT_SAVE_ALL_SKU_LOSE: "CHECKOUT.CHECKOUT_SAVE_ALL_SKU_LOSE" }, _defineProperty(_CHECKOUT, "CHECKOUT_MISS_SKUID", "CHECKOUT.CHECKOUT_MISS_SKUID"), _defineProperty(_CHECKOUT, "CHECKOUT_CORRESPOND_SKUID_BOOKING", "CHECKOUT.CHECKOUT_CORRESPOND_SKUID_BOOKING"), _defineProperty(_CHECKOUT, "CHECKOUT_CORRESPOND_SKUID", "CHECKOUT.CHECKOUT_CORRESPOND_SKUID"), _defineProperty(_CHECKOUT, "CHECKOUT_RESERVE_DATA", "CHECKOUT.CHECKOUT_RESERVE_DATA"), _defineProperty(_CHECKOUT, "CHECKOUT_SINGLE_SKUID_BOOKING", "CHECKOUT.CHECKOUT_SINGLE_SKUID_BOOKING"), _defineProperty(_CHECKOUT, "CHECKOUT_SINGLE_SKUID", "CHECKOUT.CHECKOUT_SINGLE_SKUID"), _defineProperty(_CHECKOUT, "CHECKOUT_RESERVE_SINGLE_DATA", "CHECKOUT.CHECKOUT_RESERVE_SINGLE_DATA"), _defineProperty(_CHECKOUT, "CHECKOUT_GOODS_STATUS", "CHECKOUT.CHECKOUT_GOODS_STATUS"), _defineProperty(_CHECKOUT, "CHECKOUT_SILK_CARD_LIST", "CHECKOUT.CHECKOUT_SILK_CARD_LIST"), _defineProperty(_CHECKOUT, "CHECKOUT_URL_PARMTER", "CHECKOUT.CHECKOUT_URL_PARMTER"), _defineProperty(_CHECKOUT, "CHECKOUT_SILK_PAY_ONOFF", "CHECKOUT.CHECKOUT_SILK_PAY_ONOFF"), _defineProperty(_CHECKOUT, "CHECKOUT_CHANGE_TAB_SORT", "CHECKOUT.CHECKOUT_CHANGE_TAB_SORT"), _defineProperty(_CHECKOUT, "CHECKOUT_CART_TIME_STAMP", "CHECKOUT.CHECKOUT_CART_TIME_STAMP"), _defineProperty(_CHECKOUT, "CHECKOUT_TIMEING_CHECKED", "CHECKOUT.CHECKOUT_TIMEING_CHECKED"), _defineProperty(_CHECKOUT, "CHECKOUT_REMEMBER_CHOOSE", "CHECKOUT.CHECKOUT_REMEMBER_CHOOSE"), _defineProperty(_CHECKOUT, "CHECKOUT_KEEP_PARAMETER", "CHECKOUT.CHECKOUT_KEEP_PARAMETER"), _defineProperty(_CHECKOUT, "CHECKOUT_SAVE_PARAMETER", "CHECKOUT.CHECKOUT_SAVE_PARAMETER"), _defineProperty(_CHECKOUT, "GETOPTIONALGIFT", "CHECKOUT.GETOPTIONALGIFT"), _defineProperty(_CHECKOUT, "CHECKOUT_INVOICE_STATUS", "CHECKOUT_INVOICE_STATUS"), _defineProperty(_CHECKOUT, "CHECKOUT_INVOICE_DEFAULTTITLE", "CHECKOUT_INVOICE_DEFAULTTITLE"), _defineProperty(_CHECKOUT, "CHECKOUT_INVOICE_INDIVIDUAL_SAVE", "CHECKOUT_INVOICE_INDIVIDUAL_SAVE"), _defineProperty(_CHECKOUT, "CHECKOUT_INVOICE_ENTERPRISE_SAVE", "CHECKOUT_INVOICE_ENTERPRISE_SAVE"), _defineProperty(_CHECKOUT, "CHECKOUT_INVOICE_ENTERPRISE_OPEN", "CHECKOUT_INVOICE_ENTERPRISE_OPEN"), _defineProperty(_CHECKOUT, "CHECKOUT_INVOICE_TITLEID", "CHECKOUT_INVOICE_TITLEID"), _defineProperty(_CHECKOUT, "CHECKOUT_INVOICE_DATA", "CHECKOUT_INVOICE_DATA"), _defineProperty(_CHECKOUT, "DEPOSIT_COMMENT", "CHECKOUT.DEPOSIT_COMMENT"), _defineProperty(_CHECKOUT, "SHOULDPAY", "CHECKOUT.SHOULDPAY"), _defineProperty(_CHECKOUT, "CANCEL_ORDER_TIME_LEFT", "CHECKOUT.CANCEL_ORDER_TIME_LEFT"), _defineProperty(_CHECKOUT, "CHECKOUT_AFTER_INFORMATION", "CHECKOUT_AFTER_INFORMATION"), _defineProperty(_CHECKOUT, "EXTRABUYACTID", "CHECKOUT.EXTRABUYACTID"), _defineProperty(_CHECKOUT, "EXTRABUYTITLE", "CHECKOUT.EXTRABUYTITLE"), _defineProperty(_CHECKOUT, "EXTRALBUYSHOWSTATUS", "CHECKOUT.EXTRALBUYSHOWSTATUS"), _defineProperty(_CHECKOUT, "EXCHANGEPRODUCTLIST", "CHECKOUT.EXCHANGEPRODUCTLIST"), _defineProperty(_CHECKOUT, "CART_TIPSMSG", "CHECKOUT.CART_TIPSMSG"), _defineProperty(_CHECKOUT, "DELETEPRODUCTTYPE", "CHECKOUT.DELETEPRODUCTTYPE"), _CHECKOUT);
	
	var LOCATIONS = exports.LOCATIONS = {
	  LOCATIONS_PARAMS: "LOCATIONS.LOCATIONS_PARAMS",
	  ORDER_DETAIL: "LOCATIONS.ORDER_DETAIL",
	  LOGISTIC_INFO: "LOCATIONS.LOGISTIC_INFO",
	  IS_SPLIT_PACKAGE: "LOCATIONS.IS_SPLIT_PACKAGE",
	  AD_TEXT: "LOCATIONS.AD_TEXT"
	};
	
	var ADDRESSPOPUP = exports.ADDRESSPOPUP = {
	  GET_POPUP_PROVINCE_PROTOTYPE: "ADDRESSPOPUP.GET_POPUP_PROVINCE_PROTOTYPE",
	  OPEN_POPUP: "ADDRESSPOPUP.OPEN_POPUP",
	  CLOSE_POPUP: "ADDRESSPOPUP.CLOSE_POPUP",
	  OPEN_ADDRESS_LIST: "ADDRESSPOPUP.OPEN_ADDRESS_LIST"
	  // "SET_POPUP_MODULE": 'POPUP.SET_POPUP_MODULE',
	  // "SET_POPUP_STATE": 'POPUP.SET_POPUP_STATE',
	
	  // "GET_POPUP_PROVINCE_LIST": 'POPUP.GET_POPUP_PROVINCE_LIST',
	  // "GET_POPUP_PROVINCE_COD": 'POPUP.GET_POPUP_PROVINCE_COD',
	
	  // "GET_POPUP_CITY_PROTOTYPE": 'POPUP.GET_POPUP_CITY_PROTOTYPE',
	  // "GET_POPUP_CITY_LIST": 'POPUP.GET_POPUP_CITY_LIST',
	  // "GET_POPUP_CITY_COD": 'POPUP.GET_POPUP_CITY_COD',
	
	  // "GET_POPUP_AREA_PROTOTYPE": 'POPUP.GET_POPUP_AREA_PROTOTYPE',
	  // "GET_POPUP_AREA_LIST": 'POPUP.GET_POPUP_AREA_LIST',
	  // "GET_POPUP_AREA_COD": 'POPUP.GET_POPUP_AREA_COD',
	
	  // "SET_POPUP_PROVINCE_CHANGE_PROVINCE": 'POPUP.SET_POPUP_PROVINCE_CHANGE_PROVINCE',
	  // "SET_POPUP_PROVINCE_CHANGE_CITY": 'POPUP.SET_POPUP_PROVINCE_CHANGE_CITY',
	  // "SET_POPUP_PROVINCE_CHANGE_AREA": 'POPUP.SET_POPUP_PROVINCE_CHANGE_AREA',
	
	  // "SET_POPUP_PROVINCE_ADDRESS_IS_DEFAULT": 'POPUP.SET_POPUP_PROVINCE_ADDRESS_IS_DEFAULT',
	  // "SET_POPUP_PROVINCE_ZIP_CODE": 'POPUP.SET_POPUP_PROVINCE_ZIP_CODE',
	  // "SET_POPUP_PROVINCE_USER_NAME": 'POPUP.SET_POPUP_PROVINCE_USER_NAME',
	  // "SET_POPUP_PROVINCE_ADDRESS_DETAIL": 'POPUP.SET_POPUP_PROVINCE_ADDRESS_DETAIL',
	  // "SET_POPUP_PROVINCE_COD": 'POPUP.SET_POPUP_PROVINCE_COD',
	  // "SET_POPUP_PROVINCE_TELEPHONE": 'POPUP.SET_POPUP_PROVINCE_TELEPHONE',
	  // "SET_POPUP_PROVINCE_MOBILE_PHONE": 'POPUP.SET_POPUP_PROVINCE_MOBILE_PHONE',
	
	  // "GET_POPUP_PROTOTYPE_ADDRESS_DETAIL": 'POPUP.GET_POPUP_PROTOTYPE_ADDRESS_DETAIL',
	  // "GET_POPUP_PROTOTYPE_ADDRESS_ID": 'POPUP.GET_POPUP_PROTOTYPE_ADDRESS_ID',
	
	  // "CLEAR_POPUP_ITEMS": 'POPUP.CLEAR_POPUP_ITEMS'
	};
	
	var CATEGORY = exports.CATEGORY = {
	  FILTER_STATUS: "CATEGORY.FILTER_STATUS", // v
	  TOGGLE_SHOW_ALL: "CATEGORY.TOGGLE_SHOW_ALL", // v
	  CONTROL_BOTTOM: "CATEGORY.CONTROL_BOTTOM", // v
	  GET_BRANDS: "CATEGORY.GET_BRANDS", //v
	  SAVE_VALUE: "CATEGORY.SAVE_VALUE", //v
	
	  POPUP_REQUEST: "CATEGORY.POPUP_REQUEST", // v
	  CATEGORY_POPUP: "CATEGORY.CATEGORY_POPUP", // v
	  POPUP_ORDER_NUM: "CATEGORY.POPUP_ORDER_NUM", // v
	  HIDE_FIXED_TOP: "CATEGORY.HIDE_FIXED_TOP", // v
	  LACK_INV: "CATEGORY.LACK_INV", // v
	  SHOW_SUCCESS: "CATEGORY.SHOW_SUCCESS", // v
	  GETADBANNER: "CATEGORY.GETADBANNER", // v
	
	  // "SELECT_SINGLE" : "CATEGORY.SELECT_SINGLE",
	  // "TOGGLE_LIST_ITEM" : "CATEGORY.TOGGLE_LIST_ITEM",
	  // "ADD_LIST_ITEM_STATUS" : "CATEGORY.ADD_LIST_ITEM_STATUS",
	  // "ADD_SELECT_MORE_STATUS" : "CATEGORY.ADD_SELECT_MORE_STATUS",
	  // "ADD_SHOW_MORE_STATUS" : "CATEGORY.ADD_SHOW_MORE_STATUS" ,
	  // "SHOW_MORE" : "CATEGORY.SHOW_MORE",
	  // "SELECT_MORE" : "CATEGORY.SELECT_MORE",
	  // "CANCEL_SELECT_MORE" : "CATEGORY.CANCEL_SELECT_MORE",
	  // "DROP_MENU" : "CATEGORY.DROP_MENU",
	  // "LIFT_MENU" : "CATEGORY.LIFT_MENU",
	  // "ADD_BRAND" : "CATEGORY.ADD_BRAND",
	  // "TOGGLE_ONE_BRAND" : "CATEGORY.TOGGLE_ONE_BRAND",
	  // "REMOVE_SELECTED" : "CATEGORY.REMOVE_SELECTED",
	  // "DELETE_ALL_BRAND" : "CATEGORY.DELETE_ALL_BRAND",
	  // "CONFIRM_SELECT_BRAND" : "CATEGORY.CONFIRM_SELECT_BRAND",
	  // "SHOW_MORE_CATEGORY_LIST" : "CATEGORY.SHOW_MORE_CATEGORY_LIST",
	  // "CHANGE_LIST_BOTTOM" : "CATEGORY.CHANGE_LIST_BOTTOM",
	  SORT_PRODUCT: "CATEGORY.SORT_PRODUCT",
	  // "SHOW_BUY_NOW" : "CATEGORY.SHOW_BUY_NOW",
	  // "HIDE_BUY_NOW" : "CATEGORY.HIDE_BUY_NOW",
	  // "CLOESE_POPUP" : "CATEGORY.CLOESE_POPUP",
	  // "SAVE_LEFT_VALUE" : "CATEGORY.SAVE_LEFT_VALUE",
	  SET_OFFSETTOP: "CATEGORY.SET_OFFSETTOP",
	  IFSHOW: "CATEGORY.IFSHOW"
	};
	
	var BRANDWALL = exports.BRANDWALL = {
	  GET_BRAND_WALL_INFO: "BRANDWALL.GET_BRAND_WALL_INFO",
	  SET_OFFSETTOP: "BRANDWALL.SET_OFFSETTOP",
	  SET_TOP: "BRANDWALL.SET_TOP",
	  CHANGE_CURRENT_LETTER_BG: "BRANDWALL.CHANGE_CURRENT_LETTER_BG",
	
	  GET_AD_IMG: "BRANDWALL.GET_AD_IMG",
	  GET_AD_TEXT: "BRANDWALL.GET_AD_TEXT",
	  SET_HOT_BRAND_OFFSETTOP: "BRANDWALL.SET_HOT_BRAND_OFFSETTOP"
	  // 'BRAND_STORY_LINK' : 'BRANDWALL.BRAND_STORY_LINK'
	};
	
	/**
	 * 所有同步模块异步化数据入口
	 * @type {{GET_SEARCH_PLACEHOLDER: string, GET_SEARCH_HOT_WORLD: string, GET_NAVIGATION_GROUP: string, GET_NAVIGATION_BRAND_GROUP: string}}
	 */
	var ASYNC = exports.ASYNC = {
	  GET_SEARCH_PLACEHOLDER: "ASYNC.GET_SEARCH_PLACEHOLDER",
	  GET_SEARCH_HOT_WORLD: "ASYNC.GET_SEARCH_HOT_WORLD",
	  GET_NAVIGATION_GROUP: "ASYNC.GET_NAVIGATION_GROUP",
	  GET_NAVIGATION_BRAND_GROUP: "ASYNC.GET_NAVIGATION_BRAND_GROUP"
	};
	
	/**
	 * 弹出层 => 组件类
	 * @type {{POPUP_STATE: string}}
	 */
	var POPUP_COMPONENT = exports.POPUP_COMPONENT = {
	  POPUP_STATE: "POPUP_COMPONENT.POPUP_STATE",
	  POPUP_MODULE: "POPUP_COMPONENT.POPUP_MODULE",
	
	  POPUP_PUBLIC_STEP: "POPUP_COMPONENT.POPUP_PUBLIC_STEP",
	  POPUP_PUBLIC_KEY: "POPUP_COMPONENT.POPUP_PUBLIC_KEY",
	  POPUP_PUBLIC_CALLBACK: "POPUP_COMPONENT.POPUP_PUBLIC_CALLBACK"
	};
	
	/**
	 * 弹出层 => 组件类 -- V2
	 * @type {{POPUP_STATE: string}}
	 */
	var POPUP_ADDRESS = exports.POPUP_ADDRESS = {
	  POPUP_STATE: "POPUP_ADDRESS.POPUP_STATE",
	  POPUP_MODULE: "POPUP_ADDRESS.POPUP_MODULE"
	};
	
	/**
	 * 弹出层 => 提示类
	 * @type {{POPUP_STATE: string}}
	 */
	var POPUP_ALERT = exports.POPUP_ALERT = {
	  POPUP_STATE: "POPUP_ALERT.POPUP_STATE",
	  POPUP_MODULE: "POPUP_ALERT.POPUP_MODULE"
	};
	
	var DATA = exports.DATA = {
	  DATA_ADDRESS_PROVINCE: "DATA.DATA_ADDRESS_PROVINCE"
	};
	
	/*
	 * MYACCOUNT_ORDER
	 */
	var MY_ORDER = exports.MY_ORDER = {
	  MY_ORDER_NOW_YEAR: "MY_ORDER.MY_ORDER_NOW_YEAR",
	  MY_ORDER_STATUS_TYPE_MODULE: "MY_ORDER.MY_ORDER_STATUS_TYPE_MODULE",
	  MY_ORDER_NOW_TIME_VALUE_CODE: "MY_ORDER.MY_ORDER_NOW_TIME_VALUE_CODE",
	  MY_ORDER_NOW_STATUS_CODE: "MY_ORDER.MY_ORDER_NOW_STATUS_CODE",
	  MY_ORDER_PAGE_CURRENT: "MY_ORDER.MY_ORDER_PAGE_CURRENT",
	  MY_ORDER_PAGE_TOTAL: "MY_ORDER.MY_ORDER_PAGE_TOTAL",
	  MY_ORDER_LIST_MODULE: "MY_ORDER.MY_ORDER_LIST_MODULE",
	  MY_ORDER_SHOW_COMMENTS: "MY_ORDER.MY_ORDER_SHOW_COMMENTS",
	  MY_ORDER_HISTORY: "MY_ORDER.MY_ORDER_HISTORY",
	  MY_ORDER_NEW_TIME: "MY_ORDER.MY_ORDER_NEW_TIME",
	  MY_ORDER_NEW_STATUS: "MY_ORDER.MY_ORDER_NEW_STATUS",
	  MY_ORDER_NEW_TAB: "MY_ORDER.MY_ORDER_NEW_TAB",
	  MY_ORDER_NOW_TIME_VALUE: "MY_ORDER.MY_ORDER_NOW_TIME_VALUE",
	  MY_ORDER_TIME_MODULE_SHOW: "MY_ORDER.MY_ORDER_TIME_MODULE_SHOW",
	  MY_ORDER_STATUS_MODULE_SHOW: "MY_ORDER.MY_ORDER_STATUS_MODULE_SHOW",
	  MY_ORDER_STATUS_TYPE: "MY_ORDER.MY_ORDER_STATUS_TYPE",
	  MY_ORDER_NOW_STATUS_VALUE: "MY_ORDER.MY_ORDER_NOW_STATUS_VALUE",
	  MY_ORDER_COMMENTS_NOW_OP: "MY_ORDER.MY_ORDER_COMMENTS_NOW_OP",
	  MY_ORDER_COMMENTS_NOW_ORDER_ID: "MY_ORDER.MY_ORDER_COMMENTS_NOW_ORDER_ID",
	  MY_ORDER_COMMENTS_NOW_SKUID: "MY_ORDER.MY_ORDER_COMMENTS_NOW_SKUID",
	  MY_ORDER_NOW_PAY_ORDER_ID: "MY_ORDER.MY_ORDER_NOW_PAY_ORDER_ID",
	  MY_ORDER_NOW_PAY_MONEY: "MY_ORDER.MY_ORDER_NOW_PAY_MONEY",
	  MY_ORDER_DOWN_PAY_BOX_SHOW: "MY_ORDER.MY_ORDER_DOWN_PAY_BOX_SHOW",
	  MY_ORDER_CANCEL_REASON_STATUS: "MY_ORDER.MY_ORDER_CANCEL_REASON_STATUS",
	  MY_ORDER_CANCEL_REASON_SHOW: "MY_ORDER.MY_ORDER_CANCEL_REASON_SHOW",
	  MY_ORDER_CANCEL_REASON_LIST: "MY_ORDER.MY_ORDER_CANCEL_REASON_LIST",
	  MY_ORDER_CANCEL_REASON_TYPE: "MY_ORDER.MY_ORDER_CANCEL_REASON_TYPE",
	  MY_ORDER_ORDER_ID: "MY_ORDER.MY_ORDER_ORDER_ID",
	  MY_ORDER_LOGISTIC_SHOW: "MY_ORDER.MY_ORDER_LOGISTIC_SHOW",
	  MY_ORDER_LOGISTIC_MODEL: "MY_ORDER.MY_ORDER_LOGISTIC_MODEL",
	  MY_ORDER_LOGISTIC_INDEX: "MY_ORDER.MY_ORDER_LOGISTIC_INDEX",
	  PAY_TOGETHER_POPUP_TOOGLE: "MY_ORDER.PAY_TOGETHER_POPUP_TOOGLE", //合并支付pop开关 
	  MERGE_ORDERS: "MY_ORDER.MERGE_ORDERS", //合并支付的订单
	  MY_ORDER_ORDER_CHECK: "MY_ORDER.MY_ORDER_ORDER_CHECK" //定金预售时, 选中订单号
	
	};
	
	/*
	 * MYACCOUNT_ONLINE_RETURN
	 */
	var MY_ONLINE_RETURN = exports.MY_ONLINE_RETURN = {
	  MY_ONLINE_RETURN_NOW_YEAR: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NOW_YEAR",
	  MY_ONLINE_RETURN_STATUS_TYPE_MODULE: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_STATUS_TYPE_MODULE",
	  MY_ONLINE_RETURN_NOW_TIME_VALUE_CODE: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NOW_TIME_VALUE_CODE",
	  MY_ONLINE_RETURN_NOW_STATUS_CODE: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NOW_STATUS_CODE",
	  MY_ONLINE_RETURN_PAGE_CURRENT: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_PAGE_CURRENT",
	  MY_ONLINE_RETURN_PAGE_TOTAL: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_PAGE_TOTAL",
	  MY_ONLINE_RETURN_LIST_MODULE: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_LIST_MODULE",
	  MY_ONLINE_RETURN_SHOW_COMMENTS: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_SHOW_COMMENTS",
	  MY_ONLINE_RETURN_HISTORY: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_HISTORY",
	  MY_ONLINE_RETURN_NEW_TIME: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NEW_TIME",
	  MY_ONLINE_RETURN_NEW_STATUS: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NEW_STATUS",
	  MY_ONLINE_RETURN_NEW_TAB: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NEW_TAB",
	  MY_ONLINE_RETURN_NOW_TIME_VALUE: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NOW_TIME_VALUE",
	  MY_ONLINE_RETURN_TIME_MODULE_SHOW: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_TIME_MODULE_SHOW",
	  MY_ONLINE_RETURN_STATUS_MODULE_SHOW: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_STATUS_MODULE_SHOW",
	  MY_ONLINE_RETURN_STATUS_TYPE: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_STATUS_TYPE",
	  MY_ONLINE_RETURN_NOW_STATUS_VALUE: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NOW_STATUS_VALUE",
	  MY_ONLINE_RETURN_COMMENTS_NOW_OP: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_COMMENTS_NOW_OP",
	  MY_ONLINE_RETURN_COMMENTS_NOW_ORDER_ID: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_COMMENTS_NOW_ORDER_ID",
	  MY_ONLINE_RETURN_COMMENTS_NOW_SKUID: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_COMMENTS_NOW_SKUID",
	  MY_ONLINE_RETURN_NOW_PAY_ORDER_ID: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NOW_PAY_ORDER_ID",
	  MY_ONLINE_RETURN_NOW_PAY_MONEY: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NOW_PAY_MONEY",
	  MY_ONLINE_RETURN_DOWN_PAY_BOX_SHOW: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_DOWN_PAY_BOX_SHOW",
	  MY_ONLINE_RETURN_CANCEL_REASON_STATUS: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_CANCEL_REASON_STATUS",
	  MY_ONLINE_RETURN_CANCEL_REASON_SHOW: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_CANCEL_REASON_SHOW",
	  MY_ONLINE_RETURN_ORDER_ID: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_ORDER_ID",
	  MY_ONLINE_RETURN_LOGISTIC_SHOW: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_LOGISTIC_SHOW",
	  MY_ONLINE_RETURN_LOGISTIC_MODEL: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_LOGISTIC_MODEL",
	  MY_ONLINE_RETURN_LOGISTIC_INDEX: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_LOGISTIC_INDEX",
	  MY_ONLINE_RETURN_USER_PROFILE: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_USER_PROFILE"
	};
	
	/*
	 * PDP所有需要的数据参数
	 * */
	var PDP = exports.PDP = {
	  PRODUCT_DETAIL_ERROR: "PDP.PRODUCT_DETAIL_ERROR",
	  PRODUCT_DETAIL_MAIN: "PDP.PRODUCT_DETAIL_MAIN",
	  PRODUCT_SKU_DETAIL_INFO: "PDP.PRODUCT_SKU_DETAIL_INFO",
	  PRODUCT_SKU_HTML: "PDP.PRODUCT_SKU_HTML",
	  PRODUCT_DETAIL_IMAGE: "PDP.PRODUCT_DETAIL_IMAGE",
	  PRODUCT_DETAIL_IMAGE_NOW: "PDP.PRODUCT_DETAIL_NOW",
	  PRODUCT_DETAIL_IMAGE_NOW_TAG: "PDP.PRODUCT_DETAIL_IMAGE_NOW_TAG",
	
	  PRODUCT_DETAIL_IMAGE_NOW_INDEX: "PDP.Magnifier_NOW_INDEX",
	  PRODUCT_BREADCRUMB: "PDP.PRODUCT_BREADCRUMB",
	  PRODUCT_QA_LIST: "PDP.PRODUCT_QA_LIST",
	  PRODUCT_QA_LIST_PAGE: "PDP.PRODUCT_QA_LIST_PAGE",
	  PRODUCT_COLLOCATION: "PDP.PRODUCT_COLLOCATION",
	  PRODUCT_COMMENTS_LIST: "PDP.PRODUCT_COMMENTS_LIST",
	  PRODUCT_COMMENTS_LIST_PAGE: "PDP.PRODUCT_COMMENTS_LIST_PAGE",
	  PRODUCT_USER_BUY_ONE_YEAR: "PDP.PRODUCT_USER_BUY_ONE_YEAR",
	  PRODUCT_SKU_PROMOTION_INFO: "PDP.PRODUCT_SKU_PROMOTION_INFO",
	  PRODUCT_SKU_PROMOTION_INFO_SHOW_MORE: "PDP.PRODUCT_SKU_PROMOTION_INFO_SHOW_MORE",
	  PRODUCT_SKU_PROMOTION_COLOR_SHOW_MORE: "PDP.PRODUCT_SKU_PROMOTION_COLOR_SHOW_MORE",
	  PRODUCT_SKU_PROMOTION_COLOR_SELECTOR_SHOW_MORE: "PDP.PRODUCT_SKU_PROMOTION_COLOR_SELECTOR_SHOW_MORE",
	  PRODUCT_AD_GUESS: "PDP.PRODUCT_AD_GUESS",
	  PRODUCT_AD_MAIN: "PDP.PRODUCT_AD_MAIN",
	  PRODUCT_INVENTORY: "PDP.PRODUCT_INVENTORY",
	  PRODUCT_GUESS_LIKE: "PDP.PRODUCT_GUESS_LIKE",
	  PRODUCT_HTML_DOM: "PDP.PRODUCT_HTML_DOM",
	  PRODUCT_COLOR_ITEM: "PDP.PRODUCT_COLOR_ITEM",
	  PRODUCT_COLOR_GATHER: "PDP.PRODUCT_COLOR_GATHER",
	  PRODUCT_COLOR_NESTED_INFO: "PDP.PRODUCT_COLOR_NESTED_INFO",
	  PRODUCT_CHARACTER_ITEM: "PDP.PRODUCT_CHARACTER_ITEM",
	  PRODUCT_SAVE_DATA: "PDP.PRODUCT_SAVE_DATA",
	  PRODUCT_SAVE_DEFULT_SKUID: "PDP.PRODUCT_SAVE_DEFULT_SKUID",
	  PRODUCT_CHARACTER_LIST: "PDP.PRODUCT_CHARACTER_LIST",
	  PRODUCT_SAVE_END_DATA: "PDP.PRODUCT_SAVE_END_DATA",
	  PRODUCT_FILTER_CONDITION_DATA: "PRODUCT_FILTER_CONDITION_DATA",
	  PRODUCT_FILTER_CONDITION_CHARACTER_DATA: "PRODUCT_FILTER_CONDITION_CHARACTER_DATA",
	  PRODUCT_STORAGE_COUNT: "PRODUCT_STORAGE_COUNT",
	  PRODUCT_BOOKING_STAUTUS: "PRODUCT_BOOKING_STAUTUS",
	  PRODUCT_SKU_PROMOTION_INFO_HANDLE_CLICK: "PDP.PRODUCT_SKU_PROMOTION_INFO_HANDLE_CLICK",
	  PRODUCT_SKU_PROMOTION_INFO_GIFTS_DATA: "PDP.PRODUCT_SKU_PROMOTION_INFO_GIFTS_DATA",
	  PRODUCT_SKU_PROMOTION_INFO_GIFT_ID: "PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_ID",
	  PRODUCT_SKU_PROMOTION_INFO_GIFT_FIRST_PX: "PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_FIRST_PX",
	  PRODUCT_SKU_PROMOTION_INFO_GIFT_SECOND_PX: "PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_SECOND_PX",
	  PRODUCT_SKU_PROMOTION_INFO_GIFT_THIRD_PX: "PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_THIRD_PX",
	  PRODUCT_SKU_PROMOTION_INFO_GIFT_FOUR_PX: "PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_FOUR_PX",
	  PRODUCT_SKU_PROMOTION_INFO_GIFT_FIFTH_PX: "PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_FIFTH_PX",
	  PRODUCT_SKU_PROMOTION_INFO_GIFT_PX_EMPTY: "PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_PX_EMPTY",
	  PRODUCT_SKU_PROMOTION_INFO_RECORD_TIME: "PDP.PRODUCT_SKU_PROMOTION_INFO_RECORD_TIME",
	  PRODUCT_GUERLAIN_ROUGE_OFFSET: "PDP.PRODUCT_GUERLAIN_ROUGE_OFFSET",
	  PRODUCT_GUERLAIN_ENTER: "PDP.PRODUCT_GUERLAIN_ENTER",
	  PRODUCT_GUERLAIN_INFO: "PDP.PRODUCT_GUERLAIN_INFO",
	  PRODUCT_GUERLAIN_INFO_URL: "PDP.PRODUCT_GUERLAIN_INFO_URL",
	  PRODUCT_GUERLAIN_INFO_CAP: "PDP.PRODUCT_GUERLAIN_INFO_CAP",
	  PRODUCT_GUERLAIN_INFO_COLOR_PITCH_ON: "PDP.PRODUCT_GUERLAIN_INFO_COLOR_PITCH_ON",
	  PRODUCT_GUERLAIN_INFO_CAP_PITCH_ON: "PDP.PRODUCT_GUERLAIN_INFO_CAP_PITCH_ON",
	  PRODUCT_MIUMIU_INFO: "PDP.PRODUCT_MIUMIU_INFO", //miumiu数据源
	  PRODUCT_MIUMIU_INFO_URL: "PDP.PRODUCT_MIUMIU_INFO_URL", //miumiu香水路由
	  PRODUCT_MIUMIU_INFO_ODOR_PITCH_ON: "PDP.PRODUCT_MIUMIU_INFO_ODOR_PITCH_ON",
	  PRODUCT_MIUMIU_INFO_CAP_PITCH_ON: "PDP.PRODUCT_MIUMIU_INFO_CAP_PITCH_ON",
	  PRODUCT_MIUMIU_INFO_TWO: "PDP.PRODUCT_MIUMIU_INFO_TWO",
	  PRODUCT_MIUMIU_INFO_THREE: "PDP.PRODUCT_MIUMIU_INFO_THREE",
	  PRODUCT_MIUMIU_INFO_LID_ON: "PDP.PRODUCT_MIUMIU_INFO_LID_ON",
	  PRODUCT_MIUMIU_INFO_BODY_ON: "PDP.PRODUCT_MIUMIU_INFO_BODY_ON",
	  PRODUCT_MIUMIU_ENTER: "PDP.PRODUCT_MIUMIU_ENTER",
	
	  PRODUCT_SKU_PROMOTION_INFO_GWP: "PDP.PRODUCT_SKU_PROMOTION_INFO_GWP",
	  PRODUCT_VB_GIFT_LIST: "PDP.PRODUCT_VB_GIFT_LIST",
	  PRODUCT_SKU_PROMOTION_INFO_THE_POSTS: "PDP.PRODUCT_SKU_PROMOTION_INFO_THE_POSTS",
	
	  PRODUCT_POSTS_LIST: "PDP.PRODUCT_POSTS_LIST",
	  PRODUCT_POSTS_LIST_PAGE: "PDP.PRODUCT_POSTS_LIST_PAGE",
	
	  PRODUCT_COMMENTS_REASON: "PDP.PRODUCT_COMMENTS_REASON",
	
	  PRODUCT_COMMENTS_SWITCH: "PDP.PRODUCT_COMMENTS_SWITCH",
	  PRODUCT_GET_STANDING: "PRODUCT_GET_STANDING"
	};
	
	/*
	 * 我的QA
	 * */
	var MY_QA = exports.MY_QA = {
	  MY_QA_LIST_PAGE: "PDP.MY_QA_LIST_PAGE"
	};
	
	/*
	 * myAccount-address
	 * */
	var MY_AD = exports.MY_AD = {
	  MY_AD_LISTS: "MY_AD.MY_AD_LISTS",
	  MY_AD_DEFAULT: "MY_AD.MY_AD_DEFAULT"
	};
	
	var MY_COUPON = exports.MY_COUPON = {
	  MY_COUPON_RESULTS: "MY_COUPON.MY_COUPON_RESULTS",
	  MY_COUPON_LISTS: "MY_COUPON.MY_COUPON_LISTS"
	};
	
	/*
	 * CATEGORYONELEVEL所有需要的数据参数
	 * */
	
	var CATEGORYONELEVEL = exports.CATEGORYONELEVEL = {
	  GET_AD_IMG: "CATEGORYONELEVEL.GET_AD_IMG",
	  GET_CRUMBS: "CATEGORYONELEVEL.GET_CRUMBS",
	  GET_PATH: "CATEGORYONELEVEL.GET_PATH",
	  GET_CONTENTS: "CATEGORYONELEVEL.GET_CONTENTS"
	};
	
	/*
	 * Campaign data
	 * */
	var CAMPAIGN = exports.CAMPAIGN = {
	  GET_CAMPAIGN_HTML: "CAMPAIGN.GET_CAMPAIGN_HTML",
	  GET_CAMPAIGN_NAME: "CAMPAIGN.GET_CAMPAIGN_NAME"
	};
	
	/*
	 * Content data
	 * */
	var CONTENT = exports.CONTENT = {
	  GET_CONTENT_HTML: "CONTENT.GET_CONTENT_HTML",
	  GET_CONTENT_NAME: "CONTENT.GET_CONTENT_NAME"
	};
	
	/*
	 * 门店会员首次登录
	 * */
	var LOGIN_MEMBER = exports.LOGIN_MEMBER = {
	  LOGIN_MEMBER_RESULTS: "LOGIN_MEMBER.LOGIN_MEMBER_RESULTS",
	  LOGIN_MEMBER_UI: "LOGIN_MEMBER.LOGIN_MEMBER_UI"
	};
	
	/*
	 * GA
	 * */
	var GA = exports.GA = {
	  GA_DATA: "GA.GA_DATA",
	  GA_DATA_PAGE: "GA.GA_DATA_PAGE",
	  USER: "GA.USER"
	};
	
	var EMARSYS = exports.EMARSYS = {
	  SAVE_DATA_STATUS: "EMARSYS.SAVE_DATA_STATUS"
	};
	
	var DEPENDENCY = exports.DEPENDENCY = {
	  GOOGLE_ANALYTICS: "DEPENDENCY.GOOGLE_ANALYTICS",
	  SENSOR: "DEPENDENCY.SENSOR"
	};
	
	var NICHEFRAGRANCE = exports.NICHEFRAGRANCE = {
	  // "CAROUSEL_ORDER": "NICHEFRAGRANCE.CAROUSEL_ORDER",
	  // "ENTRANCPRELOADED": "NICHEFRAGRANCE.ENTRANCPRELOADED",
	  // "CURRENTBRANDPRELOADED": "NICHEFRAGRANCE.CURRENTBRANDPRELOADED",
	  // "CURRENT_SCENE": "NICHEFRAGRANCE.CURRENT_SCENE",
	  PRELOADSTATUS: "NICHEFRAGRANCE.PRELOADSTATUS",
	  SCENESTATUS: "NICHEFRAGRANCE.SCENESTATUS",
	
	  MORE_PRODUCTS: "NICHEFRAGRANCE.MORE_PRODUCTS",
	  MYSOURCEDATA: "NICHEFRAGRANCE.MYSOURCEDATA",
	  MYVIDEO: "NICHEFRAGRANCE.MYVIDEO",
	  DRAWER: "NICHEFRAGRANCE.DRAWER",
	  PAGINATION: "NICHEFRAGRANCE.PAGINATION"
	};
	
	var PURCHASERECORD = exports.PURCHASERECORD = {
	  PURCHASERECORD: "PURCHASERECORD.PURCHASERECORD"
	};
	
	var ONLINERETURN = exports.ONLINERETURN = {
	  RETURN_APPLY: "ONLINERETURN.RETURN_APPLY",
	  RETURN_INFO: "ONLINERETURN.RETURN_INFO",
	  RETURN_PAY_INFO: "ONLINERETURN.RETURN_PAY_INFO",
	  ORDER_PRD_DETAIL: "ONLINERETURN.ORDER_PRD_DETAIL"
	};
	
	var MESSAGECENTER = exports.MESSAGECENTER = {
	  MESSAGECENTER_TYPE: "MESSAGECENTER_TYPE",
	  PAGINATION_TOTAL: "PAGINATION_TOTAL",
	  PAGINATION_CURRENT: "PAGINATION_CURRENT",
	  MYMESSAGE_DATASOURCE: "MYMESSAGE_DATASOURCE",
	  INFO_DATASOURCE: "INFO_DATASOURCE",
	  HASNEWMESSAGE: "HASNEWMESSAGE",
	  HASNEWINFO: "HASNEWINFO"
	};
	
	var INVOICELIST = exports.INVOICELIST = {
	  INVOICELIST_DATASOURCE: "INVOICELIST_DATASOURCE"
	};
	
	var ISSUEINVOICE = exports.ISSUEINVOICE = {
	  DEFAULTTITLEDATA: "ISSUEINVOICE_DEFAULTTITLEDATA",
	  INVOICEDATA: "ISSUEINVOICE_INVOICEDATA",
	  INVOICEMSG: "ISSUEINVOICE_INVOICEMSG"
	};

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

	module.exports = React;

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(184);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(522);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(521);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(520);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(183);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(185);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(30);
	
	var _interopRequireWildcard = __webpack_require__(88);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireWildcard(__webpack_require__(504));
	
	exports.Provider = _Provider.default;
	exports.createProvider = _Provider.createProvider;
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(174));
	
	exports.connectAdvanced = _connectAdvanced.default;
	
	var _connect = _interopRequireDefault(__webpack_require__(505));
	
	exports.connect = _connect.default;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOfflineOrderList = exports.returnPayInformation = exports.returnDetailByOrderId = exports.getReturnItemPrice = exports.returnDetailInformation = exports.getReturnReasonList = exports.getPurchaseRecord = exports.getCCVideo = exports.uploadCustomHead = exports.postUploadImage = undefined;
	exports.getMarketingAvailability = getMarketingAvailability;
	exports.getAdvertisingText = getAdvertisingText;
	exports.getAdvertisingTextNew = getAdvertisingTextNew;
	exports.getAdvertisingImage = getAdvertisingImage;
	exports.getErrorMessage = getErrorMessage;
	exports.getLimitPurchaseList = getLimitPurchaseList;
	exports.poc = poc;
	exports.getUaParser = getUaParser;
	exports.getUserCardInfo = getUserCardInfo;
	exports.getUserInformation = getUserInformation;
	exports.getNavigationBrandGroup = getNavigationBrandGroup;
	exports.setAdPositionCategory = setAdPositionCategory;
	exports.getAdPositionCategory = getAdPositionCategory;
	exports.getSubCategory = getSubCategory;
	exports.getCheckoutDelete = getCheckoutDelete;
	exports.getAdvertising = getAdvertising;
	exports.getNavigationGroup = getNavigationGroup;
	exports.getOptionalGift = getOptionalGift;
	exports.checkOptionalGift = checkOptionalGift;
	exports.getUserOptionalCard = getUserOptionalCard;
	exports.getSingleAddress = getSingleAddress;
	exports.getAddressList = getAddressList;
	exports.postDefaultAddress = postDefaultAddress;
	exports.postRemoveAddress = postRemoveAddress;
	exports.postAddAddress = postAddAddress;
	exports.putEditAddress = putEditAddress;
	exports.postQueryCardsByMobile = postQueryCardsByMobile;
	exports.postLoginsms = postLoginsms;
	exports.postBindUserCard = postBindUserCard;
	exports.postBindUserCardV2 = postBindUserCardV2;
	exports.postSetPasswordAndLogin = postSetPasswordAndLogin;
	exports.getPersonalinfo = getPersonalinfo;
	exports.putPersonalinfo = putPersonalinfo;
	exports.successfulPayment = successfulPayment;
	exports.changeOrderAddress = changeOrderAddress;
	exports.updateOrderAddress = updateOrderAddress;
	exports.addOrderAddress = addOrderAddress;
	exports.getOrderStatus = getOrderStatus;
	exports.getOrderInformation = getOrderInformation;
	exports.createOrderUrl = createOrderUrl;
	exports.getMiniCart = getMiniCart;
	exports.getMiniCartNum = getMiniCartNum;
	exports.getGiftsByProm = getGiftsByProm;
	exports.getUserAddressInfo = getUserAddressInfo;
	exports.getCheckOrderInformation = getCheckOrderInformation;
	exports.getCheckOrderInformationOld = getCheckOrderInformationOld;
	exports.getSkuStandard = getSkuStandard;
	exports.checkTouristOrderType = checkTouristOrderType;
	exports.getProvinceList = getProvinceList;
	exports.updateAddressExtend = updateAddressExtend;
	exports.addCneeInfoAndSave = addCneeInfoAndSave;
	exports.addOrderNote = addOrderNote;
	exports.postLive800Msg = postLive800Msg;
	exports.clearErrorSkuItem = clearErrorSkuItem;
	exports.collectItemAll = collectItemAll;
	exports.removeAllShopSku = removeAllShopSku;
	exports.changeProductCheckedAll = changeProductCheckedAll;
	exports.changeSkuStandard = changeSkuStandard;
	exports.changeProductChecked = changeProductChecked;
	exports.appendProductQuantity = appendProductQuantity;
	exports.postListAddToCart = postListAddToCart;
	exports.checkoutNoticeSubmit = checkoutNoticeSubmit;
	exports.saveCheckoutProduct = saveCheckoutProduct;
	exports.removeCheckoutProduct = removeCheckoutProduct;
	exports.getCartInfoDisplaying = getCartInfoDisplaying;
	exports.removeUserAddressInfo = removeUserAddressInfo;
	exports.setUserAddressDefault = setUserAddressDefault;
	exports.setReceivingAddress = setReceivingAddress;
	exports.setDeliveryInfo = setDeliveryInfo;
	exports.createOrderId = createOrderId;
	exports.setPayment = setPayment;
	exports.setReceivingInformation = setReceivingInformation;
	exports.getCheckoutTabMyFavorite = getCheckoutTabMyFavorite;
	exports.getCheckoutTabMyBrowserHistory = getCheckoutTabMyBrowserHistory;
	exports.setCheckoutGift = setCheckoutGift;
	exports.getAccountPhone = getAccountPhone;
	exports.getPhoneMessage = getPhoneMessage;
	exports.checkoutSilkPayInfo = checkoutSilkPayInfo;
	exports.getSilkCardList = getSilkCardList;
	exports.PopupRequest = PopupRequest;
	exports.GetBrands = GetBrands;
	exports.getBrandWallInfo = getBrandWallInfo;
	exports.getCheckoutData = getCheckoutData;
	exports.getCrumbs = getCrumbs;
	exports.getContents = getContents;
	exports.getWeeklyspecialsContent = getWeeklyspecialsContent;
	exports.getContentContent = getContentContent;
	exports.getDownloadContent = getDownloadContent;
	exports.getContentTitle = getContentTitle;
	exports.postUserMessageRegister = postUserMessageRegister;
	exports.postLogin = postLogin;
	exports.postLoginV2 = postLoginV2;
	exports.socialLogin = socialLogin;
	exports.orderDetailInformation = orderDetailInformation;
	exports.getLogisticInfoV3 = getLogisticInfoV3;
	exports.postSaveUserAccessChannel = postSaveUserAccessChannel;
	exports.postDeleteMyOrder = postDeleteMyOrder;
	exports.cancelProcessingOrder = cancelProcessingOrder;
	exports.getMyAccountUserCardInfo = getMyAccountUserCardInfo;
	exports.getCardBaseInfo = getCardBaseInfo;
	exports.getCardPointsFlow = getCardPointsFlow;
	exports.getMyAccountIntegralFlow = getMyAccountIntegralFlow;
	exports.getMyAccountFiveOrder = getMyAccountFiveOrder;
	exports.getMyAccountAllOrder = getMyAccountAllOrder;
	exports.getMyAccountFiveHistory = getMyAccountFiveHistory;
	exports.getMyAccountExpress = getMyAccountExpress;
	exports.getMyAccountMyCoupon = getMyAccountMyCoupon;
	exports.getCouponResults = getCouponResults;
	exports.postAddToCart = postAddToCart;
	exports.getAddToCart = getAddToCart;
	exports.getOrderNumber = getOrderNumber;
	exports.getRestFirstCard = getRestFirstCard;
	exports.getUserAuthenticate = getUserAuthenticate;
	exports.putUserAuthenticate = putUserAuthenticate;
	exports.postIsPhoneValid = postIsPhoneValid;
	exports.getPassword = getPassword;
	exports.postPassword = postPassword;
	exports.putPassword = putPassword;
	exports.updateDefultHead = updateDefultHead;
	exports.putUserProfileV2 = putUserProfileV2;
	exports.getPrivateAllowModify = getPrivateAllowModify;
	exports.getPrivateInfo = getPrivateInfo;
	exports.getUserProfile = getUserProfile;
	exports.getMobileValid = getMobileValid;
	exports.getEmailSmsCode = getEmailSmsCode;
	exports.getPhoneSmsCode = getPhoneSmsCode;
	exports.getPhoneSmsCodeV2 = getPhoneSmsCodeV2;
	exports.getPasswordUserCodeValidate = getPasswordUserCodeValidate;
	exports.getCheckEmailLink = getCheckEmailLink;
	exports.postCreateUserValidate = postCreateUserValidate;
	exports.postCreateUserValidateV2 = postCreateUserValidateV2;
	exports.getUserCardMessage = getUserCardMessage;
	exports.postCardBindOperation = postCardBindOperation;
	exports.postPhoneMessage = postPhoneMessage;
	exports.postEmailRegister = postEmailRegister;
	exports.getEmailVerification = getEmailVerification;
	exports.getVildation = getVildation;
	exports.postLoginOut = postLoginOut;
	exports.postVildation = postVildation;
	exports.postCaptcha = postCaptcha;
	exports.checkCaptcha = checkCaptcha;
	exports.getQaAndCommentsShow = getQaAndCommentsShow;
	exports.getAllShowPro = getAllShowPro;
	exports.getProdAllColor = getProdAllColor;
	exports.getColorNestedInfo = getColorNestedInfo;
	exports.getOptionalSkuSpec = getOptionalSkuSpec;
	exports.getProductImage = getProductImage;
	exports.getBreadcrumb = getBreadcrumb;
	exports.getQAList = getQAList;
	exports.getCommentsList = getCommentsList;
	exports.getValidateUserBuyOneYear = getValidateUserBuyOneYear;
	exports.getCommentYes = getCommentYes;
	exports.getCollocation = getCollocation;
	exports.productPromotionsGifts = productPromotionsGifts;
	exports.getSKUPromotionInfo = getSKUPromotionInfo;
	exports.postQA = postQA;
	exports.sendComment = sendComment;
	exports.postSkuDetailInfo = postSkuDetailInfo;
	exports.ProductSkuCustomMade = ProductSkuCustomMade;
	exports.sendVbGifts = sendVbGifts;
	exports.getProductPosts = getProductPosts;
	exports.getProductNinePostDetail = getProductNinePostDetail;
	exports.getProductImagePostDetail = getProductImagePostDetail;
	exports.getExchangeOptionalCard = getExchangeOptionalCard;
	exports.postCardBindingOperation = postCardBindingOperation;
	exports.getUserBindCardNo = getUserBindCardNo;
	exports.getPointsHistoryFlow = getPointsHistoryFlow;
	exports.postIndexReservation = postIndexReservation;
	exports.getProductsByIds = getProductsByIds;
	exports.getSearchResultsV2 = getSearchResultsV2;
	exports.postSkuHtml = postSkuHtml;
	exports.getCampaignContent = getCampaignContent;
	exports.getCampaignTitle = getCampaignTitle;
	exports.MyAccountAdvertisingText = MyAccountAdvertisingText;
	exports.getOrderHistory = getOrderHistory;
	exports.getMyAccountAllOnlineReturnOrder = getMyAccountAllOnlineReturnOrder;
	exports.uploadApplyImg = uploadApplyImg;
	exports.getOnlineReturnOrderNumber = getOnlineReturnOrderNumber;
	exports.getReturnAvailableQty = getReturnAvailableQty;
	exports.onlineReturnApplication = onlineReturnApplication;
	exports.editOnlineReturnApplication = editOnlineReturnApplication;
	exports.onlineReturnlogisticsInfo = onlineReturnlogisticsInfo;
	exports.myMsgList = myMsgList;
	exports.msgUnreadCount = msgUnreadCount;
	exports.readNewMsg = readNewMsg;
	exports.InfoList = InfoList;
	exports.infoUnreadCount = infoUnreadCount;
	exports.readNewInfo = readNewInfo;
	exports.getDefaultTitle = getDefaultTitle;
	exports.addInvoiceTitle = addInvoiceTitle;
	exports.editInvoiceTitle = editInvoiceTitle;
	exports.getInvoiceTitleList = getInvoiceTitleList;
	exports.getInvoiceList = getInvoiceList;
	exports.issueInvoice = issueInvoice;
	exports.deleteInvoiceTitle = deleteInvoiceTitle;
	exports.getOrderInfoV3 = getOrderInfoV3;
	exports.postRecord = postRecord;
	exports.getStandings = getStandings;
	exports.getStandingList = getStandingList;
	exports.postPhoneMessage_quondam = postPhoneMessage_quondam;
	exports.booleanUserExist = booleanUserExist;
	exports.checkSmsCode = checkSmsCode;
	exports.sendEmail = sendEmail;
	exports.socBindMobile = socBindMobile;
	exports.putAuthenticate = putAuthenticate;
	exports.telephoneMember = telephoneMember;
	exports.bindPhone = bindPhone;
	exports.emailBindPhone = emailBindPhone;
	exports.getCountdown = getCountdown;
	exports.commitOrderForImmediatelyBuy = commitOrderForImmediatelyBuy;
	exports.getVbs = getVbs;
	exports.getBannerforTop = getBannerforTop;
	exports.getValidation = getValidation;
	exports.PostCooperation = PostCooperation;
	exports.stepTwoForImmediatelyBuy = stepTwoForImmediatelyBuy;
	exports.getMiuMiuStep1 = getMiuMiuStep1;
	exports.getMiuMiuStep2 = getMiuMiuStep2;
	exports.getMiuMiuStep3 = getMiuMiuStep3;
	exports.getOrderInformations = getOrderInformations;
	exports.afterPaidUsingGET = afterPaidUsingGET;
	exports.afterPayGET = afterPayGET;
	exports.getRecommendProducts = getRecommendProducts;
	exports.isDefaultUse = isDefaultUse;
	exports.getCardList = getCardList;
	exports.getSilkpayCardListInfo = getSilkpayCardListInfo;
	exports.sendMsg = sendMsg;
	exports.cartSubtract = cartSubtract;
	exports.silkPayment = silkPayment;
	exports.highRisk = highRisk;
	exports.multiLogin = multiLogin;
	exports.getPopInfo = getPopInfo;
	exports.getProductInventory = getProductInventory;
	exports.getExchangeProductList = getExchangeProductList;
	exports.extraBuy = extraBuy;
	exports.offlineCouponList = offlineCouponList;
	exports.updateSwitchInPrivacySetting = updateSwitchInPrivacySetting;
	exports.getSwitchInPrivacySetting = getSwitchInPrivacySetting;
	exports.getFindRecommend = getFindRecommend;
	exports.getGuestCartInfoDisplaying = getGuestCartInfoDisplaying;
	exports.getGuestQueryAllSkuBySkuId = getGuestQueryAllSkuBySkuId;
	exports.postPhoneMessageV2 = postPhoneMessageV2;
	exports.postGuestLogin = postGuestLogin;
	exports.getGuestShopcartStepTwo = getGuestShopcartStepTwo;
	exports.guestCommitOrderForImmediatelyBuy = guestCommitOrderForImmediatelyBuy;
	exports.guestGetOrderById = guestGetOrderById;
	exports.editGuestAddressOrderById = editGuestAddressOrderById;
	exports.getIsHomeGrey = getIsHomeGrey;
	exports.getFirstOrder = getFirstOrder;
	exports.getAd = getAd;
	exports.getTongdunSwitch = getTongdunSwitch;
	exports.getPcConfig = getPcConfig;
	
	var _Tools = __webpack_require__(24);
	
	var _Fetch = __webpack_require__(237);
	
	var _cookieUtil = __webpack_require__(38);
	
	var utilCookieUtil = _interopRequireWildcard(_cookieUtil);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var WCSParams = __webpack_require__(492);
	
	
	/*
	 * 页面429接口处理
	 */
	function getMarketingAvailability(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/marketing/availability"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/*
	 * 公共的广告位 -- 文字 -- global
	 */
	
	function getAdvertisingText(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/marketing/MktSimpleGroupController/simpleTextGroup",
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/*
	 ** 公共的广告位 -- 文字 -- global
	 */
	function getAdvertisingTextNew(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/marketing/MktHomePageController/recommendPcGroup",
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/*
	 * 公共的广告位 -- 图片 -- global
	 */
	function getAdvertisingImage(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/marketing/MktSimpleGroupController/simpleImageGroup",
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/*
	 * 公共 -- 处理errcode对应的errormessage
	 */
	function getErrorMessage(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/myaccount/message/errorMessage?errorCode=" + params.code
	  }, function (json) {
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/*
	 * limitpurchase - 清理限购
	 */
	function getLimitPurchaseList(callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/shopcart/shopcart/quick-list/1"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * RESEARCH
	 */
	function poc(callback) {
	  $.get("/api/SOA/research/poc", function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  }, "json");
	}
	
	/*
	 * 获取用户设备信息
	 */
	/**
	 * RESEARCH
	 */
	function getUaParser(params, callback) {
	  $.get("/api/SOA/myaccount/getUaParser", function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  }, "json");
	}
	
	/**
	 * CRM
	 */
	/**
	 * Ignore
	 * @param params
	 * @param callback
	 */
	function getUserCardInfo(params, callback) {
	  $.post("/api/SOA/crm/getUserCardInfo", params, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  }, "json");
	}
	/**
	 * Ignore
	 * @param params
	 * @param callback
	 */
	function getUserInformation(params, callback) {
	  $.post("/api/SOA/crm/getUserInformation", params, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  }, "json");
	}
	
	/**
	 * MARKETING
	 */
	
	function getNavigationBrandGroup(callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/es/brandWall/queryAllBrands",
	    type: "POST"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function setAdPositionCategory(value) {
	  var match = [{ id: "hot_rec", locationLabel: "PC:HOMEPAGE:POPULAR_CATALOG" }, {
	    id: "eb_exclusive",
	    locationLabel: "PC:HOMEPAGE:OFFICIALEXCLUSIVE_CATALOG"
	  }, { id: "60001", locationLabel: "PC:HOMEPAGE:SKINCARE_CATALOG" }, { id: "60002", locationLabel: "PC:HOMEPAGE:MAKEUP_CATALOG" }, { id: "60003", locationLabel: "PC:HOMEPAGE:BATHBODYCARE_CATALOG" }, { id: "60004", locationLabel: "PC:HOMEPAGE:TOOL_CATALOG" }, { id: "60005", locationLabel: "PC:HOMEPAGE:MANSKINCARE_CATALOG" }, { id: "60006", locationLabel: "PC:HOMEPAGE:HAIRCARE_CATALOG" }, { id: "60007", locationLabel: "PC:HOMEPAGE:PERFUME_CATALOG" }, { id: "60008", locationLabel: "PC:HOMEPAGE:FOOD_CATALOG" }];
	  for (var i in match) {
	    if (value === match[i].id) {
	      return {
	        locationLabel: match[i].locationLabel
	      };
	    }
	  }
	  return false;
	}
	
	function getAdPositionCategory(value, callback) {
	  var matchCategory = setAdPositionCategory(value);
	  if (matchCategory) {
	    (0, _Fetch.AJAX)({
	      type: "POST",
	      url: "/v1/marketing/MktHomePageController/categoryTreeForEbAndHot",
	      data: { queryBody: { locationLabel: matchCategory.locationLabel } }
	    }, function (json) {
	      if (json && json.results) {
	        json.results._key = value;
	      }
	      callback(json);
	    });
	  }
	}
	
	function getSubCategory(value, callback) {
	  var matchCategory = setAdPositionCategory(value);
	  if (matchCategory) {
	    (0, _Fetch.AJAX)({
	      type: "POST",
	      url: "/v1/marketing/MktHomePageController/subCategoryGroup",
	      data: { queryBody: { locationLabel: matchCategory.locationLabel } }
	    }, function (json) {
	      if (json && json.results) {
	        json.results._key = value;
	      }
	      callback(json);
	    });
	  }
	}
	
	function getCheckoutDelete(callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/marketing/MktSimpleGroupController/simpleTextGroup",
	    data: {
	      queryBody: {
	        locationLabel: "PC:SHOPPING:CART:BULLETIN"
	      }
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/*购物车第二步广告位接口*/
	function getAdvertising(callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/marketing/MktSimpleGroupController/simpleTextGroup",
	    data: {
	      queryBody: {
	        locationLabel: "PC:CHECK_ORDER:MESSAGE"
	      }
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getNavigationGroup(callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/marketing/MktHomePageController/categoryGroup",
	    data: { queryBody: { locationLabel: "PC:HOMEPAGE:CATEGORY" } }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/**组赠 自选商品 */
	function getOptionalGift(data, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/shopcart/shopcart/getOptionalGift",
	    data: { queryBody: data }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/** 组赠 提交赠品 */
	
	function checkOptionalGift(data, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/shopcart/shopcart/checkOptionalGift",
	    data: { queryBody: data }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/**
	 * MyAccount-profile
	 */
	//个人信息页上传图片
	function postUploadImage(params, callback) {
	  $.ajax({
	    method: "POST",
	    processData: false,
	    contentType: false,
	    url: "https://" + (0, _Tools.GetEnvValue)(process.title, "api") + "/v1/pimBackend/image/uploadImage",
	    data: params,
	    success: function success(json) {
	      console.log("Upload success");
	      callback((0, _Tools.GetConfirmation)(json));
	    },
	    error: function error(_error) {
	      console.log("Upload error", _error);
	    }
	  });
	}
	exports.postUploadImage = postUploadImage;
	function uploadCustomHead(params, callback) {
	  $.ajax({
	    method: "POST",
	    processData: false,
	    contentType: false,
	    headers: {
	      UID: $.cookie("UID"),
	      Token: $.cookie("Token")
	    },
	    url: "https://" + (0, _Tools.GetEnvValue)(process.title, "api") + "/v1/myaccount/image/avatar/upload",
	    data: params,
	    success: function success(json) {
	      console.log("Upload success");
	      callback((0, _Tools.GetConfirmation)(json));
	    },
	    error: function error(_error2) {
	      console.log("Upload error", _error2);
	    }
	  });
	}
	
	exports.uploadCustomHead = uploadCustomHead;
	function getUserOptionalCard(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/card/multipleUserOptionalCard?mobile=" + params.mobile + "&email=" + params.email
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	  // $.get('/api/SOA/myaccount/getUserOptionalCard', params, json => {
	  //   callback( GetConfirmation( json ) );
	  // }, 'json');
	}
	
	/*
	 * myAccount-address
	 */
	
	//查询收货地址
	function getSingleAddress(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/addressManagement/address?addrId=" + params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	//查询收货地址列表
	function getAddressList(callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/addressManagement/addressListPC"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	//设置默认地址
	function postDefaultAddress(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/myaccount/addressManagement/defaultAddress",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	//删除收货地址
	function postRemoveAddress(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/myaccount/addressManagement/removeAddress",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	//新建收获地址
	function postAddAddress(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/myaccount/addressManagement/addAddress",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	//编辑收获地址
	function putEditAddress(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/myaccount/addressManagement/editAddress",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/*
	 * member-login
	 */
	//查询会员卡
	function postQueryCardsByMobile(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/myaccount/user/queryCardsByMobile",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	//查询会员卡v2
	function postLoginsms(params, callback) {
	  // AJAX(
	  //   {
	  //     type: "POST",
	  //     url: `/v1/usercenter/weblogin/sms`,
	  //     headers: { channel: "PC" },
	  //     data: params,
	  //   },
	  //   (json) => {
	  //     callback(GetConfirmation(json));
	  //   }
	  // );
	
	  $.post("/api/SOA/myaccount/postMobilevalicodelogon", params, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  }, "json");
	}
	
	//绑定会员卡
	function postBindUserCard(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/myaccount/user/bindUserCard",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	//绑定会员卡v2
	function postBindUserCardV2(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v2/myaccount/user/bind/card",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	//设置密码并登陆 --- 需要设置cookie
	function postSetPasswordAndLogin(params, callback) {
	  $.post("/api/SOA/myaccount/postSetPasswordAndLogin", params, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  }, "json");
	}
	
	//门店会员完善个人信息 -- 获取个人信息
	function getPersonalinfo(callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/user/mobilevalicodelogon/personalinfo"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	//门店会员完善个人信息 -- 完善个人信息
	function putPersonalinfo(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/myaccount/user/mobilevalicodelogon/personalinfo?birthday=" + params.birthday + "&name=" + params.name + "&gender=" + params.gender
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function successfulPayment(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v3/es/order/detail/pc/" + params.orderId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function changeOrderAddress(params, callback) {
	  $.post("/api/SOA/order/changeOrderAddress", params, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  }, "json");
	}
	function updateOrderAddress(params, callback) {
	  $.post("/api/SOA/order/updateOrderAddress", params, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  }, "json");
	}
	function addOrderAddress(params, callback) {
	  $.post("/api/SOA/order/addOrderAddress", params, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  }, "json");
	}
	//export function updateOrderAddress (params, callback) {
	//$.post('/api/SOA/order/updateOrderAddress', params, json => {
	//  callback(GetConfirmation(json));
	//}, 'json');
	//}
	
	function getOrderStatus(params, callback) {
	  if (sessionStorage.guestToken) {
	    var headers = { token: sessionStorage.guestToken };
	    console.log('headers=====', headers);
	
	    (0, _Fetch.AJAX)({
	      url: "/v1/order/orderInfo/orderstatu/" + params.orderId,
	      headers: headers
	    }, function (json) {
	      callback && callback((0, _Tools.GetConfirmation)(json));
	    });
	  } else {
	    (0, _Fetch.AJAX)({
	      url: "/v1/order/orderInfo/orderstatu/" + params.orderId
	    }, function (json) {
	      callback((0, _Tools.GetConfirmation)(json));
	    });
	  }
	}
	function getOrderInformation(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/order/orderInfo/orderInformation/" + params.orderId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function createOrderUrl(params, callback) {
	  var headers = { token: params.guestToken };
	  delete params.guestToken;
	  (0, _Fetch.AJAX)({
	    url: "/v1/order/pay/payInfo/" + params.orderId + "/" + params.channel + "/" + params.type + "?paymentCode=" + params.paymentCode,
	    headers: headers
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * SHOPCART
	 */
	
	// 获取迷你购物车数据( ITEM接口 ) -- Jimmy
	function getMiniCart(callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v3/shopcart/shopcart/miniShopcartInfo?channel=PC"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/* 单独获取数量的接口 */
	function getMiniCartNum(callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/shopcart/shopcart/mini-shop-cart-count"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getGiftsByProm(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v2/shopcart/shopcart/getGiftsByProms/" + params.platform + "?queryList=" + params.queryList
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getUserAddressInfo(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/shopcart/cneeinfo/queryCneeInfoList",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getCheckOrderInformation(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v3/shopcart/shopcart/getShopcartStepTwo",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getCheckOrderInformationOld(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/shopcart/shopcart/getShopcartStepTwo",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getSkuStandard(params, callback) {
	  if (true) {
	    //游客模式切换规格
	    (0, _Fetch.AJAX)({
	      type: "GET",
	      url: "/v3/shopcart/shopcart/guest/model/queryAllSkuBySkuId?skuId=" + params.skuId + "&channel=PC&orderType=1"
	    }, function (json) {
	      json.errorMessage && alert(json.errorMessage);
	      callback && callback((0, _Tools.GetConfirmation)(json));
	    });
	  } else {
	    (0, _Fetch.AJAX)({
	      url: "/v3/shopcart/shopcart/queryAllSkuBySkuId?skuId=" + params.skuId + "&channel=PC&orderType=1"
	    }, function (json) {
	      callback((0, _Tools.GetConfirmation)(json));
	    });
	  }
	}
	
	// 游客模式:查询订单是否为游客订单
	function checkTouristOrderType(params, callback) {
	  var headers = { token: params.guestToken };
	  delete params.guestToken;
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    headers: headers,
	    url: "/v3/es/order/detail/orderType/" + params.orderId
	  }, function (json) {
	    json.errorMessage && alert(json.errorMessage);
	    callback && callback((0, _Tools.GetConfirmation)(json.results));
	  });
	}
	
	function getProvinceList(callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/shopcart/cneeinfo/initProvinceList"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	//编辑
	function updateAddressExtend(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/shopcart/shopcart/updateCneeInfoUse",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	//新建收货地址并使用
	function addCneeInfoAndSave(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/shopcart/shopcart/addCneeInfoAndSave",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function addOrderNote(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/shopcart/shopcart/addOrderNote",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function postLive800Msg(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/product/consulation/userInfo",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function clearErrorSkuItem(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    headers: { channel: "PC" },
	    url: "/v1/shopcart/shopcart/removeFromCart",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function collectItemAll(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/shopcart/favorite/addToFavorite",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function removeAllShopSku(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    headers: { channel: "PC" },
	    url: "/v1/shopcart/shopcart/removeFromCart",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function changeProductCheckedAll(params, callback) {
	  // console.log(params,'params-------');
	  var _params = params.value || [];
	  var _query = _params.filter(function (item) {
	    if (item.skuId) {
	      return item;
	    }
	  });
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/shopcart/shopcart/saveProdChkedStat",
	    // data: { queryBody: params.value },
	    data: { queryBody: _query }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function changeSkuStandard(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    headers: { channel: "PC" },
	    url: "/v1/shopcart/shopcart/updateSku",
	    data: { queryBody: [params] }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function changeProductChecked(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/shopcart/shopcart/saveProdChkedStat",
	    data: { queryBody: [params] }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function appendProductQuantity(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/shopcart/shopcart/updateQuantity",
	    headers: { channel: "PC" },
	    data: { queryBody: [params] }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/**
	 *购物车批量加购
	 *
	 * @export
	 * @param {*} params
	 * @param {*} callback
	 */
	function postListAddToCart(params, callback) {
	  console.log('par=======', params);
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v3/shopcart/shopcart/addToCart",
	    data: { queryBody: params.value }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function checkoutNoticeSubmit(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/shopcart/reminder/saveArrivalReminderUserData",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function saveCheckoutProduct(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/shopcart/favorite/addToFavorite",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	//export function saveCheckoutProduct (params, callback) {
	//$.post('/api/SOA/shopcart/saveCheckoutProduct', params, json => {
	//  callback(GetConfirmation(json));
	//}, 'json');
	//}
	
	function removeCheckoutProduct(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    headers: { channel: "PC" },
	    url: "/v1/shopcart/shopcart/removeFromCart",
	    data: { queryBody: [params] }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getCartInfoDisplaying(params, callback) {
	
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v3/shopcart/shopcart/cartInfoDisplaying",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function removeUserAddressInfo(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/shopcart/cneeinfo/removeCneeInfo",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function setUserAddressDefault(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/shopcart/cneeinfo/setDefaultCneeInfo",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function setReceivingAddress(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/shopcart/shopcart/addReceivingInformation",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function setDeliveryInfo(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/shopcart/shopcart/distributionInformation",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function createOrderId(params, rid, callback) {
	  (0, _Fetch.AJAX)({
	    headers: { fengkongrid: rid },
	    type: "POST",
	    url: "/v3/shopcart/order/commitOrderExtend",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function setPayment(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/shopcart/payment/changePayment",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function setReceivingInformation(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/shopcart/shopcart/addReceivingInformation",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	//export function setReceivingInformation (parameter, callback) {
	//$.post('/api/SOA/shopcart/setReceivingInformation', parameter, json => {
	//  callback(GetConfirmation(json));
	//});
	//}
	function getCheckoutTabMyFavorite(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/shopcart/favorite/addToFavorite",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	//export function getCheckoutTabMyFavorite (params, callback) {
	//$.post('/api/SOA/shopcart/getCheckoutTabMyFavorite', params, json => {
	//  callback(GetConfirmation(json));
	//}, 'json');
	//}
	function getCheckoutTabMyBrowserHistory(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/shopcart/shopcart/saveBrsProd",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	//export function getCheckoutTabMyBrowserHistory (params, callback) {
	//$.post('/api/SOA/shopcart/getCheckoutTabMyBrowserHistory', params, json => {
	//  callback(GetConfirmation(json));
	//}, 'json');
	//}
	
	function setCheckoutGift(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/shopcart/shopcart/addGiftPackaging",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getAccountPhone(callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/order/orderInfo/obtain/phone"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getPhoneMessage(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/order/orderInfo/verificationcode/" + params.mobile
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function checkoutSilkPayInfo(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/order/pay/silkpayinfo",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getSilkCardList(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/order/orderInfo/silkpaycardlist/" + params.phone + "/" + params.phoneCode + "/" + params.orderId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * CATEGORY
	 */
	function PopupRequest(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/product/sku/optionalSkuSpec?productId=" + params["productId"] + "&skuId=" + params["skuId"] + "&channel=" + params["channel"] + "&isPromotion=" + params["isPromotion"]
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function GetBrands(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/search-service/brand/keyword?categoryId=" + params.categoryId + "&filters=" + params.filters + "&hasInventory=" + params.hasInventory + "&keyWord=" + params.keyWord + "&searchBrandKeyWord=" + params.searchBrandKeyWord + "&hotWords=" + params.hotWords + "&searchType=" + params.searchType + "&funWords=" + params.funWords + "&attrWords=" + params.attrWords + "&categoryIds=" + params.categoryIds
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/**
	 * BRAND WALL
	 *
	 */
	
	function getBrandWallInfo(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/es/brandWall/queryAllBrands",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	  // $.post('/api/SOA/brand/getBrandWallInfo', params, json => {
	  //   callback(GetConfirmation(json));
	  // }, 'json');
	}
	
	/**
	 * MISS
	 */
	function getCheckoutData(userId, callback) {
	  $.post("/api/SOA/getCheckoutData", { userId: userId }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/*
	 *CATEGORYONELEVEL
	 */
	
	function getCrumbs(params, callback) {
	  // bodyStringify_Crumbs = JSON.stringify( body.catId )
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/es/groupCategory/getGroupCategory",
	    data: {
	      queryBody: params.catId
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getContents(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/es/product/getTopCategory/soa_pim/" + params.categroyid,
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getWeeklyspecialsContent(params, callback) {
	  $.get("/api/SOA/change/getWeeklyspecialsContent", params, function (json) {
	    callback(json);
	  });
	}
	
	function getContentContent(params, callback) {
	  $.get("/api/SOA/change/getContentContent", params, function (json) {
	    callback(json);
	  });
	}
	
	function getDownloadContent(params, callback) {
	  $.get("/api/SOA/change/getDownloadContent", params, function (json) {
	    callback(json);
	  });
	}
	
	function getContentTitle(params, callback) {
	  $.get("/api/SOA/change/getContentTitle", params, function (json) {
	    callback(json);
	  });
	}
	
	/*register--begin*/
	function postUserMessageRegister(params, callback) {
	  $.post("/api/SOA/myaccount/postUserMessageRegister", params, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  }, "json");
	}
	/*register--end*/
	
	/*Login--begin*/
	function postLogin(params, callback) {
	  var password = params.password,
	      loginId = params.loginId;
	
	  if (window) {
	    params.password = window.btoa(password);
	    params.loginId = window.btoa(loginId);
	  }
	  $.post("/api/SOA/myaccount/postLogin", params, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  }, "json");
	}
	function postLoginV2(params, callback) {
	  var password = params.password,
	      loginId = params.loginId;
	
	  if (window) {
	    params.password = window.btoa(password);
	    params.loginId = window.btoa(loginId);
	  }
	  $.post("/api/SOA/myaccount/postLoginV2", params, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  }, "json");
	}
	/**
	 *第三方登录
	 *
	 * @export
	 * @param {*} params
	 * @param {*} callback
	 */
	function socialLogin(params, callback) {
	  $.ajax({
	    url: "/api/SOA/myaccount/socialLogin",
	    async: false,
	    type: "POST",
	    data: params,
	    success: function success(json) {
	      callback((0, _Tools.GetConfirmation)(json));
	    }
	  });
	}
	/*productDetail--end*/
	
	/*orderDetail--begin*/
	function orderDetailInformation(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v3/es/order/detail/pc/" + params.orderId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getLogisticInfoV3(_ref, callback) {
	  var orderId = _ref.orderId;
	
	  (0, _Fetch.AJAX)({
	    url: "/v3/es/deliveryInfo/getDelivery/" + orderId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/*orderDetail--end*/
	
	/*myAccount--begin*/
	function postSaveUserAccessChannel(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/myaccount/user/saveUserAccessChannel?createTime=" + params.date + "&channel=" + params.channel
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function postDeleteMyOrder(params, callback) {
	  var headers = { token: params.guestToken };
	  delete params.guestToken;
	
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/order/orderInfo/cancelOrder",
	    headers: headers,
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function cancelProcessingOrder(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/order/orderInfo/cancelInProcessOrder",
	    headers: {
	      channel: "PC"
	    },
	    data: params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getMyAccountUserCardInfo(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/portal/member/homepage/info",
	    headers: {
	      channel: "PC"
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getCardBaseInfo(callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/portal/card/base/info",
	    headers: {
	      channel: "PC"
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getCardPointsFlow(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/portal/card/points-flow?pageNo=" + params.pageNo,
	    headers: {
	      channel: "PC"
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getMyAccountIntegralFlow(params, callback) {
	  (0, _Fetch.AJAX)({
	    //url: `/v1/myaccount/user/validate/userGroup`
	    url: "/v2/myaccount/user/view/control/points-history"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getMyAccountFiveOrder(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v2/myaccount/order/myOrder"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getMyAccountAllOrder(params, callback) {
	  var url = "/v3/es/orders/paging/" + params.pageNo + "/" + params.pageSize + "?orderTime=" + params.orderTime;
	  if (params.orderStatus) {
	    url += "&orderStatus=" + params.orderStatus;
	  }
	  (0, _Fetch.AJAX)({
	    headers: {
	      "sx-tenant-id": 1
	    },
	    /* url: `/v2/myaccount/order/orderList/${params.pageNo}/${params.pageSize}?orderTime=${params.orderTime}&orderStatus=${params.orderStatus}` */
	    url: "/v3/es/orders/paging/" + params.pageNo + "/" + params.pageSize + "?orderTime=" + params.orderTime + "&orderStatus=" + params.orderStatus
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getMyAccountFiveHistory(params, callback) {
	  /*$.get('/api/SOA/myaccount/getMyAccountFiveHistory', params, json => {
	    callback(GetConfirmation(json));
	  }, 'json');*/
	
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/order/buyRecord"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getMyAccountExpress(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/express/express/" + params.orderId + "/" + params.itemNum
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getMyAccountMyCoupon(params, callback) {
	  var valid = params.valid;
	  if (typeof valid !== "undefined") {
	    valid = "?valid=" + valid;
	  } else {
	    valid = "?valid=1";
	  }
	  (0, _Fetch.AJAX)({
	    headers: { channel: "PC" },
	    url: "/v2/myaccount/coupon/list/" + params.pageNo + "/" + params.pageSize + valid
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	//我的优惠券页面获取优惠券V2
	function getCouponResults(params, callback) {
	  var valid = params.valid;
	  if (typeof valid !== "undefined") {
	    valid = "?valid=" + valid;
	  } else {
	    valid = "";
	  }
	  (0, _Fetch.AJAX)({
	    headers: { channel: "PC" },
	    url: "/v2/myaccount/coupon/list/" + params.pageNo + "/" + params.pageSize + valid
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function postAddToCart(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v3/shopcart/shopcart/addToCartForSingleProduct",
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    if (json.jQueryStatus.status === 401) {
	      //AuthRedirect(window.location);
	    }
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getAddToCart(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/order/buyAgain/" + params.orderId + "?subOrderId=" + params.subOrderId,
	    headers: { channel: "PC" }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getOrderNumber(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/order/orderQuantity?orderTime=" + params.orderTime
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getRestFirstCard(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/card/validateUserExchangedCard"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getUserAuthenticate(callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/user/authenticate"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function putUserAuthenticate(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/myaccount/user/authenticate?mobile=" + params.mobile + "&smsCode=" + params.smsCode + "&smsModule=" + params.smsModule
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/*myAccount--end*/
	
	/*myAccountRestMyPassword--begin*/
	function postIsPhoneValid(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/myaccount/user/loginIdUseableValid",
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getPassword(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/password/password"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function postPassword(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/myaccount/password/password",
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function putPassword(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/myaccount/password/password",
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/**
	 * @description spring37 改动
	 * @todo 修改用户推荐头像
	 */
	function updateDefultHead(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/myaccount/user/profile/default/avatar?defaultAvatarUrl=" + params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function putUserProfileV2(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/portal/member/profile/info",
	    headers: {
	      channel: "PC"
	    },
	    data: params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getPrivateAllowModify(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/user/profile/allow-modify"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getPrivateInfo(params, callback) {
	  if (params) {
	    (0, _Fetch.AJAX)({
	      type: "GET",
	      url: "/v1/portal/member/profile/info",
	      headers: {
	        channel: "PC",
	        convertMobile: params // convertMobile是否对手机号脱敏，默认为不脱敏，true脱敏，false不脱敏
	      }
	    }, function (json) {
	      callback((0, _Tools.GetConfirmation)(json));
	    });
	  } else {
	    (0, _Fetch.AJAX)({
	      type: "GET",
	      url: "/v1/portal/member/profile/info",
	      headers: {
	        channel: "PC"
	      }
	    }, function (json) {
	      callback((0, _Tools.GetConfirmation)(json));
	    });
	  }
	}
	/* 客服专属 */
	function getUserProfile(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/portal/member/profile/info",
	    headers: {
	      channel: "PC"
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getMobileValid(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/user/mobileValid?mobile=" + params.mobile
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/*myAccountRestMyPassword--end*/
	
	/*searchPassword--begin*/
	function getEmailSmsCode(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/email/email?email=" + params.email
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getPhoneSmsCode(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/sms/smsCode/" + params.mobile + "/" + params.module + "/" + params.valiCode
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getPhoneSmsCodeV2(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v2/myaccount/password/mobile/valid/smsCode/" + params.mobile + "/" + params.module + "/" + params.valiCode
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getPasswordUserCodeValidate(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/password/userCodeValidate?loginId=" + params.loginId + "&valiCode=" + params.valiCode + "&valiCodeToken=" + params.valiCodeToken
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getCheckEmailLink(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/email/checkEmailLink?email=" + params.loginId + "&active=" + params.active
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function postCreateUserValidate(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/myaccount/password/userValidate",
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function postCreateUserValidateV2(params, callback) {
	  var _header = {
	    channel: "PC"
	  };
	  if (params.NDFingerPrint) {
	    _header["NDFingerPrint"] = params.NDFingerPrint;
	    _header["loginType"] = params.loginType;
	    _header["device"] = params.NDFingerPrint;
	  }
	  delete params.NDFingerPrint;;
	  var _active = decodeURIComponent(params.active);
	  params.active = _active.replace(/\s/g, '+');
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v2/myaccount/password/forgot",
	    headers: _header,
	    data: params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/*searchPassword--end*/
	
	/*register--begin*/
	function getUserCardMessage(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/card/optionalCardInfo?loginId=" + params.loginId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function postCardBindOperation(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/myaccount/card/cardBindOperation",
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function postPhoneMessage(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    headers: { channel: "PC", Accept: "*/*" },
	    url: "/v1/usercenter/verification/smsCode?rToken=" + params.rtoken + "&scene=" + params.scene
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function postEmailRegister(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/myaccount/email/register?email=" + params.email
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getEmailVerification(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/email/verification?code=" + params.code
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getVildation(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/valicode/validate/" + params.inputValiCode + "/" + params.valiCodeToken
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/*register--end*/
	function postLoginOut(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/portal/logout",
	    headers: params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/*Login--begin*/
	function postVildation(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/myaccount/valicode/code",
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * @Function postCaptcha 生成图形验证码
	 */
	function postCaptcha(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/usercenter/verification/captcha?imageType=2&identification=" + params.identification,
	    headers: { channel: "PC", Accept: "*/*" }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/**
	 * @Function checkCaptcha 校验图形验证码, 返回rtoken
	 */
	function checkCaptcha(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/usercenter/verification/captcha?identification=" + params.identification + "&code=" + params.code + "&codeToken=" + params.codeToken,
	    headers: { channel: "PC" }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/*Login--end*/
	
	/*productDetail--begin*/
	function getQaAndCommentsShow(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/product/switch/comment?channel=" + params.channel
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getAllShowPro(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/pimBackend/product/getAllShowPro?productId=" + params.productId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getProdAllColor(parameter, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/product/sku/allColorProperty/" + parameter
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getColorNestedInfo(params, callback) {
	  var productId = params.productId,
	      colorValue = params.colorValue,
	      colorType = params.colorType;
	
	  if (productId) {
	    (0, _Fetch.AJAX)({
	      url: "/v1/product/sku/concreteColor?productId=" + productId + "&colorValue=" + colorValue + "&colorMaterial=" + colorType
	    }, function (json) {
	      callback((0, _Tools.GetConfirmation)(json));
	    });
	  }
	}
	function getOptionalSkuSpec(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/product/sku/optionalSkuSpec?productId=" + params.productId + "&skuId=" + params.skuId + "&channel=PC&isPromotion=" + params.isPromotion
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getProductImage(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/product/sku/skuImagePath?skuId=" + params.skuId + "&productId=" + params.productId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getBreadcrumb(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/product/sku/breadcrumb?productId=" + params.productId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getQAList(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/product/consulation/consulationListForPC?productId=" + params.productId + "&pageNo=" + params.pageNo + "&pageSize=" + params.pageSize
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getCommentsList(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/product/comment/commentListForPC?productId=" + params.productId + "&pageNo=" + params.pageNo + "&pageSize=" + params.pageSize
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getValidateUserBuyOneYear(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/product/comment/validateUserBuyOneYear"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getCommentYes(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v3/product/comment/commodity-details/validate-send-comment/" + params.productId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getCollocation(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/product/product/recommend/" + params.productId + "/" + params.pageNo + "/" + params.pageSize
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function productPromotionsGifts(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/product/sku/gifts?promotionIds=" + params.promotionId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	  // $.get('/api/SOA/product/productPromotionsGifts', params, json => {
	  //   callback(GetConfirmation(json));
	  // }, 'json');
	}
	
	function getSKUPromotionInfo(params, callback) {
	  var skuPromotionInfo_url = void 0;
	  if (params.skuId) {
	    skuPromotionInfo_url = "/v1/product/sku/skuPromotionInfo?channel=PC&productId=" + params.productId + "&skuId=" + params.skuId;
	  } else {
	    skuPromotionInfo_url = "/v1/product/sku/skuPromotionInfo?channel=PC&productId=" + params.productId;
	  }
	  (0, _Fetch.AJAX)({
	    url: skuPromotionInfo_url
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function postQA(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/product/consulation/sendConsulation",
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function sendComment(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v3/product/comment/sendComment",
	    headers: {
	      channel: "PC"
	    },
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function postSkuDetailInfo(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/product/product/skuDetailInfo",
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function ProductSkuCustomMade(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/product/sku/custom-made/" + params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function sendVbGifts(params, callback) {
	  var VbparmsUrl = void 0;
	  if (params.skuId) {
	    VbparmsUrl = "/v2/product/sku/promotion/PC/" + params.productId + "?skuId=" + params.skuId;
	  } else {
	    VbparmsUrl = "/v2/product/sku/promotion/PC/" + params.productId;
	  }
	  (0, _Fetch.AJAX)({
	    url: VbparmsUrl
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getProductPosts(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/community/posts/product/pc/" + params.productId + "/?pagingState=" + params.pagingState
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getProductNinePostDetail(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/community/post/detail/nine-block/" + params.openId + "/" + params.postId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getProductImagePostDetail(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/community/post/detail/graphic-text/" + params.authorOpenId + "/" + params.postId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/*productDetail--end*/
	
	/*MyAccountRestMyCard--begin*/
	function getExchangeOptionalCard(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/card/exchangeOptionalCard?email=" + params.email + "&mobile=" + params.mobile
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function postCardBindingOperation(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/myaccount/card/exchangeUserCard",
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/*MyAccountRestMyCard--end*/
	
	/*index--begin*/
	function getUserBindCardNo(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/user/userBindCardNo"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/*index--end*/
	
	/* integralFlow---begin */
	function getPointsHistoryFlow(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/myaccount/card/points/historyflow/" + params.pageNo + "/" + params.pageSize
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/* integralFlow---end */
	
	/* reservation---begin */
	function postIndexReservation(params, callback) {
	  $.get("/api/SOA/Util/postIndexReservation", params, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  }, "json");
	}
	/* reservation---end */
	/*
	 * 默认产品
	 */
	function getProductsByIds(value, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v2/product/product/history-browsing/products?channel=PC",
	    abort: "/v2/product/product/history-browsing/products?channel=PC",
	    data: { queryBody: value }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/*
	 * 模糊搜索
	 */
	function getSearchResultsV2(value, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/search-service/product/suggest?keyWord=" + value,
	    abort: "/v1/search-service/product/suggest"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/*
	 * UTIL获取html内容的接口
	 */
	function postSkuHtml(params, callback) {
	  $.get("/api/SOA/Util/getProductDetails", params, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  }, "json");
	}
	
	function getCampaignContent(params, callback) {
	  $.get("/api/SOA/Util/getCampaignContent", params, function (json) {
	    callback(json);
	  });
	}
	
	function getCampaignTitle(params, callback) {
	  $.get("/api/SOA/Util/getCampaignTitle", params, function (json) {
	    callback(json);
	  });
	}
	
	/*我的列表页广告位接口*/
	function MyAccountAdvertisingText(callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/marketing/MktSimpleGroupController/simpleTextGroup",
	    data: {
	      queryBody: {
	        locationLabel: "PC:ORDERLIST:TOP_TEXT_CAROUSEL"
	      }
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 *@Function 视频播放
	 *@param {string} 视频ID
	 */
	var getCCVideo = exports.getCCVideo = function getCCVideo(id, callback) {
	  $.get("https://m.sephora.cn/api/v2/SOA/proxy/getVideo?videoid=" + id, function (json) {
	    callback && callback(json);
	  });
	};
	
	/**
	 * @function getPurchaseRecord
	 */
	var getPurchaseRecord = exports.getPurchaseRecord = function getPurchaseRecord(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/es/product/tryout",
	    data: {
	      queryBody: {
	        countOnly: false,
	        filters: params.filters,
	        hasInventory: params.hasInventory,
	        pageNum: params.pageNum,
	        pageSize: 25,
	        sortField: params.sortField,
	        sortMode: params.sortMode
	      }
	    }
	  }, function (json) {
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	};
	
	//积分兑礼页面
	function getOrderHistory(callback) {
	  $.post("/api/SOA/Util/changeHistory", function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  }, "json");
	}
	
	/**
	 *@Function 获取退货理由列表
	 */
	var getReturnReasonList = exports.getReturnReasonList = function getReturnReasonList(callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/order/es/return/returnReasonSample"
	  }, function (json) {
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	};
	
	// export const getReturnReasonList = (callback) => {
	//   $.get(`http://rest.apizza.net/mock/486160cb9b27f54a1f84572d906e476f/returnReasonSample`, json => {
	//       callback && callback(GetConfirmation(json));
	//   });
	// }
	
	/**
	 *@Function 获取退货详情
	 */
	var returnDetailInformation = exports.returnDetailInformation = function returnDetailInformation(parameter, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/order/es/return/queryOrderReturn?returnId=" + parameter.returnId
	  }, function (json) {
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	};
	
	/**
	 *@Function 获取可退货数量和价格
	 */
	var getReturnItemPrice = exports.getReturnItemPrice = function getReturnItemPrice(parameter, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/order/es/return/returnItemUnit?orderId=" + parameter.orderId + "&returnSkuId=" + parameter.returnSkuId
	  }, function (json) {
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	};
	
	/**
	 *@Function 获取退货详情by订单
	 */
	var returnDetailByOrderId = exports.returnDetailByOrderId = function returnDetailByOrderId(parameter, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/order/es/return/queryOrderReturnDetail?orderId=" + parameter.orderId + "&returnSkuId=" + parameter.returnSkuId
	  }, function (json) {
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	};
	// export const returnDetailInformation = (parameter,callback) => {
	//   $.get(`http://rest.apizza.net/mock/486160cb9b27f54a1f84572d906e476f/queryOrderReturn?returnId=${parameter.returnId}`, json => {
	//       callback && callback(GetConfirmation(json));
	//   });
	// }
	
	/**
	 *@Function 获取退款单详情
	 */
	var returnPayInformation = exports.returnPayInformation = function returnPayInformation(parameter, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/order/es/return/queryOrderRefund?returnId=" + parameter.returnId
	  }, function (json) {
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	};
	// export const returnPayInformation = (parameter,callback) => {
	//   $.get(`http://rest.apizza.net/mock/486160cb9b27f54a1f84572d906e476f/queryOrderRefund?returnId=${parameter.returnId}`, json => {
	//       callback && callback(GetConfirmation(json));
	//   });
	// }
	
	/**
	 *@Function 获取退货售后单列表
	 */
	function getMyAccountAllOnlineReturnOrder(parameter, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/order/es/return/list/status",
	    data: parameter
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 *@Function 上传图片接口
	 */
	function uploadApplyImg(formData, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/order/return/applyImg/upload",
	    data: formData,
	    processData: false,
	    contentType: false
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 *@Function 获取退货售后单数量
	 */
	function getOnlineReturnOrderNumber(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/order/es/return/list/quantity?showStatus=" + params.showStatus
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 *@Function 获取退货售后单可退换商品数量
	 */
	function getReturnAvailableQty(params, callback) {
	  (0, _Fetch.AJAX)({
	    url: "/v1/order/es/return/availableQty?orderId=" + params.orderId + "&returnSkuId=" + params.returnSkuId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 *@Function 提交退货申请
	 */
	function onlineReturnApplication(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/order/return/onlineReturnApplication",
	    data: params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 *@Function 修改退货申请
	 */
	function editOnlineReturnApplication(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/order/return/onlineReturnApplication",
	    data: params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 *@Function 退换货物流单填写
	 */
	function onlineReturnlogisticsInfo(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/order/es/return/logisticsInfo",
	    data: params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/*
	 * omni接口
	 */
	/* 线下订单列表 */
	var getOfflineOrderList = exports.getOfflineOrderList = function getOfflineOrderList(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    headers: {
	      channel: "PC"
	    },
	    url: "/v1/omni/order/offlineOrder/list/" + params.pageNo + "?orderTime=" + params.orderTime
	  }, function (json) {
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	};
	
	/**
	 *@Function 查询我的消息列表
	 */
	function myMsgList(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/omni/membermsg/mymsg/list/" + params.pageNo,
	    headers: {
	      channel: "PC"
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 *@Function 查询我的消息未读数量
	 */
	function msgUnreadCount(callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/omni/membermsg/mymsg/unread/count",
	    headers: {
	      channel: "PC"
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 *@Function 我的消息状态置已读
	 */
	function readNewMsg(callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/omni/membermsg/mymsg/read",
	    headers: {
	      channel: "PC"
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 *@Function 查询美力资讯列表
	 */
	function InfoList(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/omni/membermsg/beauty/list/" + params.pageNo,
	    headers: {
	      channel: "PC"
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 *@Function 查询美力资讯未读数量
	 */
	function infoUnreadCount(callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/omni/membermsg/beauty/unread/count",
	    headers: {
	      channel: "PC"
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 *@Function 美力资讯状态置已读
	 */
	function readNewInfo(callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/omni/membermsg/beauty/read",
	    headers: {
	      channel: "PC"
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * @Function 获得默认抬头
	 */
	function getDefaultTitle(callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/portal/invoicetitle/default",
	    headers: {
	      uid: $.cookie("UID"),
	      channel: "PC"
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * @Function 新增抬头
	 */
	function addInvoiceTitle(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/portal/invoicetitle",
	    data: params,
	    headers: {
	      uid: $.cookie("UID"),
	      channel: "PC"
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * @Function 编辑抬头
	 */
	function editInvoiceTitle(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "PUT",
	    url: "/v1/portal/invoicetitle/" + params.titleId,
	    data: params,
	    headers: {
	      uid: $.cookie("UID"),
	      channel: "PC"
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * @Function 查询抬头列表
	 */
	function getInvoiceTitleList(callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/portal/invoicetitle",
	    headers: {
	      uid: $.cookie("UID"),
	      channel: "PC"
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * @Function 根据订单获得发票信息
	 */
	function getInvoiceList(orderId, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/order/invoice/list/" + orderId,
	    headers: {
	      uid: $.cookie("UID")
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * @Function 开具发票
	 */
	function issueInvoice(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/order/invoice/" + params.orderId + "/channel?invoiceId=" + params.invoiceId + "&channel=PC",
	    headers: {
	      uid: $.cookie("UID")
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * @Function 根据抬头id删除发票抬头
	 */
	function deleteInvoiceTitle(titleId, callback) {
	  (0, _Fetch.AJAX)({
	    type: "DELETE",
	    url: "/v1/portal/invoicetitle?titleId=" + titleId,
	    headers: {
	      uid: $.cookie("UID"),
	      channel: "PC"
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * 拆单的新逻辑 SPM-4451
	 */
	
	function getOrderInfoV3(_ref2, callback) {
	  var orderId = _ref2.orderId;
	
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v3/es/order/detail/pc/" + orderId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	export function discountPrice(params, callback) {
	  AJAX(
	    {
	      type: "POST",
	      url: `/v1/product/product/discount-price?channel=PC`,
	      data: {
	        queryBody: params,
	      },
	    },
	    (json) => {
	      callback(GetConfirmation(json));
	    }
	  );
	}
	 */
	/**
	 *记录用户同意隐私条款版本
	 *
	 * @export
	 * @param {*} params
	 * @param {*} callback
	 */
	function postRecord(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/myaccount/privacyClause/record",
	    data: params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 *
	 *http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=15931799
	 * @export
	 * @param {*} params
	 * @param {*} callback
	 */
	function getStandings(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/product-extend/ranking/pc/" + params.productId + "?skuId=" + (params.skuId || ""),
	    headers: {
	      uid: $.cookie("UID")
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/**
	 * http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=15931802
	 * @param {\} params
	 * @param {*} callback
	 */
	function getStandingList(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/product-extend/ranking/" + params.rankingId + "/PC/" + params.pageNum,
	    headers: {
	      uid: $.cookie("UID")
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function postPhoneMessage_quondam(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v1/myaccount/sms/smsCode",
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function booleanUserExist(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/usercenter/login/exist?rToken=" + params.rtoken + "&identification=" + params.identification,
	    headers: {
	      channel: "PC"
	    }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	// 校验短信验证码
	function checkSmsCode(params, callback) {
	  (0, _Fetch.AJAX)({
	    headers: {
	      channel: "PC"
	    },
	    type: "GET",
	    url: "/v1/usercenter/verification/smsCode?scene=" + params.scene + "&rToken=" + params.rtoken + "&telephone=" + params.telephone + "&smsCode=" + params.smsCode
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	//发送忘记密码邮件
	function sendEmail(params, callback) {
	  (0, _Fetch.AJAX)({
	    headers: {
	      channel: "PC"
	    },
	    type: "POST",
	    url: "/v1/usercenter/verification/email?scene=FORGET&rToken=" + params.rtoken
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function socBindMobile(params, callback) {
	  var _header = {
	    channel: "PC",
	    uid: $.cookie("UID")
	  };
	  if (params.NDFingerPrint) {
	    _header["NDFingerPrint"] = params.NDFingerPrint;
	  }
	
	  delete params.NDFingerPrint;
	  (0, _Fetch.AJAX)({
	    headers: _header,
	    type: "POST",
	    url: "/v1/usercenter/weblogin/bind",
	    data: params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function putAuthenticate(params, callback) {
	  (0, _Fetch.AJAX)({
	    headers: {
	      channel: "PC",
	      uid: $.cookie("UID")
	    },
	    type: "PUT",
	    url: "/v2/myaccount/user/authenticate?telephone=" + params.telephone + "&smsCode=" + params.smsCode + "&rToken=" + params.rtoken
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	//接口----用户手机号身份验证(检查手机号是否已是独立账号)
	function telephoneMember(params, callback) {
	  (0, _Fetch.AJAX)({
	    headers: {
	      channel: "PC",
	      uid: $.cookie("UID")
	    },
	    type: "POST",
	    url: "/v2/myaccount/user/telephoneMember?telephone=" + params.telephone + "&smsCode=" + params.smsCode + "&rToken=" + params.rToken
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	//接口----APP邮箱登录流程中强制绑定手机
	function bindPhone(params, callback) {
	  (0, _Fetch.AJAX)({
	    headers: {
	      channel: "PC",
	      uid: $.cookie("UID")
	    },
	    type: "POST",
	    url: "/v2/myaccount/user/telephoneMember?telephone=" + params.telephone + "&smsCode=" + params.smsCode + "&rToken=" + params.rtoken
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function emailBindPhone(params, callBack) {
	  var _header = {
	    channel: "PC",
	    uid: $.cookie("UID")
	  };
	  if (params.NDFingerPrint) {
	    _header["loginType"] = "other";
	    _header["NDFingerPrint"] = params.NDFingerPrint;
	  }
	
	  delete params.NDFingerPrint;
	  (0, _Fetch.AJAX)({
	    headers: _header,
	    type: "POST",
	    url: "/v1/usercenter/weblogin/pwd/bind",
	    data: params
	  }, function (json) {
	    callBack((0, _Tools.GetConfirmation)(json));
	  });
	}
	/**
	 * 购物车第一步:获取大促倒计时
	 * @param {*} params 
	 * @param {*} callback 
	 */
	function getCountdown(callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/product/special-activity/countdown"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * 定金预售 付定金
	 * @link http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=15932066
	 * @param {*} params 
	 * @param {*} callback 
	 */
	
	function commitOrderForImmediatelyBuy(params, rid, callback) {
	  (0, _Fetch.AJAX)({
	    headers: { fengkongrid: rid },
	    type: "POST",
	    url: "/v2/shopcart/order/commitOrderForImmediatelyBuy",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	  * 获取套装信息(可包含多个主品)
	 * @param {*} params 
	 * @param {*} callback 
	 */
	function getVbs(skucode, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v2/product/sku/vb/" + skucode
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getBannerforTop(callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/mpcms/common/banner/pc:home:popup?channel=pc"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * 品牌合作页面
	 * PC品牌合作获取验证信息
	 */
	
	function getValidation(callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/portal/brand/validation"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/**
	 * 品牌合作页面
	 * PC品牌合作获取验证信息
	 */
	/**
	 * 
	 * @param {Object} data  
	 *        validation 从getValidation 获取
	 *          brandName	String	是	品牌名称 长度限制 40
	            brandWebsite	String	是	品牌官网 长度限制 150
	            contactName	String	是	联系人姓名  长度限制  20
	            contactEmail	String	是	联系人邮箱  长度限制  50
	            leaveMessage 留言信息      长度限制  300
	 *        
	 * @param {function} callback 
	 */
	
	function PostCooperation(data, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    data: data,
	    url: "/v1/portal/brand/cooperation?validation=" + data.validation
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/**
	 * 立即购买-购物车核对订单页
	 * @link http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=15926028
	 */
	function stepTwoForImmediatelyBuy(data, callback) {
	  (0, _Fetch.AJAX)({
	    headers: {
	      "channel": "PC"
	    },
	    type: "POST",
	    data: { queryBody: data },
	    url: "/v2/shopcart/shopcart/stepTwoForImmediatelyBuy"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	// MIUMIU 香水自选组合 Step 1
	function getMiuMiuStep1(spuId, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/product/sku/groups/miumiu/detail/" + spuId + "?channel=PC"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	// MIUMIU 香水自选组合 Step 2
	function getMiuMiuStep2(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/product/sku/groups/miumiu/chose/" + params.spuId + "/" + params.odorsku + "?channel=PC"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	// MIUMIU 香水自选组合 Step 3
	function getMiuMiuStep3(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/product/sku/groups/miumiu/comb?spuId=" + params.spuId + "&mainSkuId=" + params.odorsku + "&onePartSkuId=" + params.lidSkuId + "&twoPartSkuId=" + params.bodySkuId + "&channel=PC"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getOrderInformations(orderId, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/order/orderInfo/afterOrder/" + orderId.orderId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function afterPaidUsingGET(orderId, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/order/orderInfo/afterPaid/" + orderId.orderId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function afterPayGET(orderId, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/order/orderInfo/afterPay/" + orderId.orderId
	    // url: `/v1/es/order/afterPay/123`,
	    // url: `/v1/es/order/afterPay/123`,
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function getRecommendProducts(data, callback) {
	  (0, _Fetch.AJAX)({
	    headers: {
	      "channel": "PC"
	    },
	    type: "POST",
	    data: data,
	    url: "/v1/product/product/settlement/recommend"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	// 默认是否使用私享卡/v1/portal/member/silkPay/is_default_use
	function isDefaultUse(callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/portal/member/silkPay/is_default_use"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	// 获取丝享卡列表
	function getCardList(params, callback) {
	  (0, _Fetch.AJAX)({
	    headers: { channel: "PC" },
	    type: "GET",
	    url: "/v2/order/pay/silkpay/cardlist?orderId=" + params.orderId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	// 【丝享卡】查询丝享卡列表
	function getSilkpayCardListInfo(deviceID, callback) {
	  (0, _Fetch.AJAX)({
	    headers: { device: deviceID },
	    type: "GET",
	    url: "/v1/portal/app/card/silkPay/cardList?pageNo=1&pageSize=20"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	// 用户获取动态验证码（选择丝享卡支付时发送验证码功能）
	function sendMsg(params, callback) {
	  (0, _Fetch.AJAX)({
	    headers: { channel: "PC" },
	    type: "GET",
	    url: "/v2/order/pay/silkpay/sendMsg?orderId=" + params.orderId
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function cartSubtract(data, callback) {
	  (0, _Fetch.AJAX)({
	    headers: {
	      "channel": "PC"
	    },
	    type: "POST",
	    data: data,
	    url: "/v1/shopcart/shopcart/cartSku/qty/subtract"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	// 丝享卡支付
	function silkPayment(params, callback) {
	  (0, _Fetch.AJAX)({
	    headers: { channel: "PC" },
	    type: "POST",
	    url: '/v2/order/pay/silkpay',
	    data: params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	//高风险用户带数美验证登录
	/**
	 *
	 *
	 * @export
	 * @param {*} {requestId: "数美滑动验证Id" , secLoginToken:"登录时高风险用户返回token"}
	 * @param {*} callback
	 */
	function highRisk(params, callback) {
	  (0, _Fetch.AJAX)({
	    headers: { channel: "PC" },
	    type: "POST",
	    url: '/v1/usercenter/login/second/high-risk',
	    data: params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	// 用户登录时选择允许/不允许多端登录
	function multiLogin(params, callback) {
	  (0, _Fetch.AJAX)({
	    headers: { "channel": "PC", "multiLoginToken": params.multiLoginToken },
	    // headers: { "channel": "PC", },
	    type: "POST",
	    url: '/v1/usercenter/login/multiLogin/' + params.permit
	  }, function (json) {
	    var results = json.results;
	
	
	    if (results && results.sephoraToken) {
	      var domain =  true ? ".sephora.cn" : '';
	      utilCookieUtil.SetSingleCookie2({
	        key: "Token",
	        value: results.sephoraToken,
	        domain: domain,
	        path: "/"
	      });
	    }
	    json.errorMessage && alert(json.errorMessage);
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/**
	 *
	 *获取无库存商品弹窗信息接口
	 * @export
	 * @param {*} params
	 * @param {*} callback
	 */
	function getPopInfo(skuId, callback) {
	  (0, _Fetch.AJAX)({
	    headers: { channel: "PC" },
	    type: "GET",
	    url: "/v1/product/sku/no-inv/toast?skuId=" + skuId + "&channel=PC"
	  }, function (json) {
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getProductInventory(productIdList, callback) {
	  (0, _Fetch.AJAX)({
	    headers: { channel: "PC" },
	    type: "POST",
	    url: '/v1/es/product/has-inventory',
	    data: productIdList
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	// 换购活动商品列表页
	function getExchangeProductList(activityId, callback) {
	  (0, _Fetch.AJAX)({
	    headers: { channel: "PC" },
	    type: "GET",
	    url: "/v1/product/sku/exchange/list?activityId=" + activityId + "&channel=PC"
	
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	// 添加换购活动商品到购物车
	/**
	 *@link http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=34933228
	 *
	 * @export
	 * @param {*}  {
	      "extraBuyActId": "108000001",
	      "extraSkuDtos": [
	        {
	          "skuId": 1234567,
	          "isAdd": true
	        }
	      ]
	    }
	 * @param {*} callback
	 */
	function extraBuy(params, callback) {
	  (0, _Fetch.AJAX)({
	    headers: { channel: "PC" },
	    type: "POST",
	    url: '/v1/shopcart/shopcart/extra-buy/skus',
	    data: params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	
	    json.errorMessage && alert(json.errorMessage);
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function offlineCouponList(params, callback) {
	  if (params.valid == 1) {
	    params.valid = 1;
	  } else if (params.valid == 0) {
	    params.valid = 2;
	  } else if (params.valid == 2) {
	    params.valid = 3;
	  }
	  (0, _Fetch.AJAX)({
	    headers: { channel: "PC" },
	    type: "POST",
	    url: '/v1/offlieLineExternal/coupon/list',
	    data: params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	    json.errorMessage && alert(json.errorMessage);
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * 隐私页面 (/v2/html/privacySetting)-WEB用户修改偏好开关状态
	 *
	 * @export
	 * @param {*} params 个性化推送：personalizedpush 多端登录：multilogin
	 * @param {*} callback
	 * @link http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=34942963
	 * 例子/v1/portal/web/preference/switch/personalizedpush?on=true
	 */
	function updateSwitchInPrivacySetting(params, callback) {
	  (0, _Fetch.AJAX)({
	    headers: { channel: "PC" },
	    type: "POST",
	    url: "/v1/portal/web/preference/switch/" + params.type + "?on=" + params.toogle
	  }, function (json) {
	    json.errorMessage && alert(json.errorMessage);
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/**
	 * 隐私页面 (/v2/html/privacySetting)-WEB获取用户偏好开关状态
	 *
	 * @export
	 * @param {*} params 个性化推送：personalizedpush 多端登录：multilogin
	 * @param {*} callback
	 * @link http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=34942961
	 * 例子 /v1/portal/web/preference/switch/personalizedpush
	 */
	function getSwitchInPrivacySetting(params, callback) {
	  (0, _Fetch.AJAX)({
	    headers: { channel: "PC" },
	    type: "GET",
	    url: "/v1/portal/web/preference/switch/" + params
	  }, function (json) {
	    json.errorMessage && alert(json.errorMessage);
	    callback && callback(json);
	  });
	}
	
	/**
	 * 适用于个性化推送开关关闭-推荐页面商品配置
	 *
	 * @export
	 * @param {*} params  
	 * @param {*} callback
	 * @link http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=23763807
	 * 例子 /v1/product/product/find-recommend/10
	 */
	function getFindRecommend(params, callback) {
	  (0, _Fetch.AJAX)({
	    headers: { channel: "PC" },
	    type: "GET",
	    url: "/v2/product/product/find-recommend?pageSize=" + (params.pageSize || 20)
	  }, function (json) {
	    json.errorMessage && alert(json.errorMessage);
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * 适用于个性化推送开关关闭-获取折扣价
	 *
	 * @export
	 * @param {*} params  
	 * @param {*} callback
	 * @link http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=23763807
	 * 例子  {  "queryBody": ["565001_565009", "1"]}
	export function getDiscountPrice(params, callback) {
	  AJAX(
	    {
	
	      type: "POST",
	      url: `/v1/product/product/discount-price?channel=PC`,
	      data: {
	        queryBody: params,
	      },
	    },
	    (json) => {
	      json.errorMessage && alert(json.errorMessage)
	      callback && callback(GetConfirmation(json));
	    }
	  );
	}
	 */
	
	/**
	 *未登录购物车信息查询
	 *
	 * @export
	 * @param {Integer} orderType 1--普通订单 2--定金订单c
	 * @param {String}  channel	 	"PC"	渠道
	 * @param {List}  shopcartSkus 
	    skuId	商品id
	    quantity	购物车中商品数量
	    checked	选中状态：1：选中，0：未选中
	 * @param {*} callback
	 */
	function getGuestCartInfoDisplaying(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    url: "/v3/shopcart/shopcart/guest/model/cartInfoDisplaying",
	    data: {
	      queryBody: params
	    }
	  }, function (json) {
	    json.errorMessage && alert(json.errorMessage);
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 *未登录购物车切换商品规格
	 *
	 * @export
	 * @param {Integer} orderType 1--普通订单 2--定金订单c
	 * @param {String}  channel	 	"PC"	渠道
	 * @param {List}  shopcartSkus 
	    skuId	商品id
	    quantity	购物车中商品数量
	    checked	选中状态：1：选中，0：未选中
	 * @param {*} callback
	 */
	function getGuestQueryAllSkuBySkuId(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v3/shopcart/shopcart/guest/model/queryAllSkuBySkuId?skuId=" + params.skuId + "&channel=PC&orderType=1"
	  }, function (json) {
	    json.errorMessage && alert(json.errorMessage);
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function postPhoneMessageV2(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    headers: { channel: "PC", Accept: "*/*" },
	    url: "/v2/usercenter/verification/smsCode",
	    data: params
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function postGuestLogin(params, callback) {
	  var register = params.register;
	  delete params.register;
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    headers: { channel: "PC", Accept: "*/*" },
	    url: "/v1/usercenter/weblogin/guest/" + register,
	    data: params
	  }, function (json) {
	
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getGuestShopcartStepTwo(params, callback) {
	  var headers = { channel: "PC", Accept: "*/*" }; // token: params.guestToken
	  delete params.guestToken;
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    headers: headers,
	    url: "/v3/shopcart/shopcart/guest/model/getShopcartStepTwo",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function guestCommitOrderForImmediatelyBuy(params, callback) {
	  var headers = { token: params.guestToken };
	  delete params.guestToken;
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    headers: headers,
	    url: "/v3/shopcart/shopcart/guest/model/commitOrderForImmediatelyBuy",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function guestGetOrderById(params, callback) {
	  var headers = { token: params.guestToken };
	  delete params.guestToken;
	  //   callback({ "timeStamp": 1650002763864, "status": 0, "results": { "orderId": "100000017661505624", "orderStatus": "DPP", "orderOriginStatus": "M", "createTime": "2022-04-15 14:06:03", "calcCancelTime": 719, "deliveryTime": null, "deliverySummary": null, "recipientName": "123", "mobile": "13122083616", "province": "江苏", "city": "常州市", "area": "钟楼区", "address": "123", "zipcode": "11111", "deliveryInfo": "1", "payMethod": "在线支付", "shouldTotalPay": "360.01", "totalPayment": "360.01", "realProducts": [{ "skuId": "411560", "skuCode": "319483", "productId": "450585", "brandNameEN": "MAKEUPFOREVER", "productNameCN": "玫珂菲保湿补水妆前乳", "sapPrice": "360.00", "defaultImagePath": "https://sslstage4.sephorastatic.cn/products/3/1/9/4/8/3/1_n_new03504_", "quantity": 1, "skuSaleAttrDto": { "spec": 30.0, "specType": "volume", "custom": "," }, "offerPrice": "360.00", "orderId": "100000017661505624", "brandNameCN": "玫珂菲", "productNameEN": "MAKE UP FOR EVER HYDRATING PRIMER", "depositPrice": null, "returnStatus": null, "currentReturnStatus": null, "isSendComment": 0, "estimatedDeliveryTime": null, "skuType": 1, "exchangeDiscount": null, "buyAgain": true, "activityType": null, "itemId": null, "integral": null, "exchangeType": 0 }], "giftProducts": [], "comments": "", "giftComments": "", "wrapPart": null, "wrapPrice": null, "realProductsCount": 1, "giftProductsCount": 0, "totalAmount": "360.00", "discountAdjustment": "0.00", "couponAdjustment": "0.00", "shipping": "0.01", "orderType": "1", "switchIsOpen": "1", "cancelTime": null, "cancelReason": null, "payInfoDtos": [], "amountPaid": null, "amountPayable": null, "processOrderCancel": false, "isSplitOrder": "2", "paymentTime": null, "shippedTime": null, "signedTime": null, "rejectedTime": null, "estimatedDeliveryTime": null, "isDeliveryTimeOut": 0, "orderDepositList": [], "preSale": false, "mergeOrders": null, "mShouldPay": null, "priorityInDelivery": false, "priorityInDeliveryMsg": null, "editAddressTips": null, "sales": false, "accumulatePoints": null, "deliveryData": null, "deliveryCompany": null, "orderInvoiceSwitch": 3, "exchangeType": 0, "telephone": "123" }, "errorCode": null, "errorMessage": null }
	  //   )
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    headers: headers,
	    url: "/v3/es/order/detail/tourist/" + params.orderId + " "
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	function editGuestAddressOrderById(params, callback) {
	  var headers = { token: params.guestToken };
	  delete params.guestToken;
	
	  (0, _Fetch.AJAX)({
	    type: "POST",
	    headers: headers,
	    url: "/v1/order/orderInfo/orderAddress/guest/" + params.orderId + " ",
	    data: { queryBody: params }
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * @param callback
	 */
	function getIsHomeGrey(callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/configuration/commonConfig"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	/**
	 * 首页-首单礼弹窗领券接口
	 * @param {*} params
	 * @param {*} callback
	 */
	function getFirstOrder(callback) {
	  (0, _Fetch.AJAX)({
	    headers: { channel: "APP" },
	    type: "GET",
	    url: "/v1/activity/coupon-event/firstOrder/popup"
	  }, function (json) {
	    json.errorMessage && alert(json.errorMessage);
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getAd(params, callback) {
	  (0, _Fetch.AJAX)({
	    type: "GET",
	    url: "/v1/mpcms/common/banner/" + params + "?channel=mobile"
	  }, function (json) {
	    callback && callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getTongdunSwitch(callback) {
	  (0, _Fetch.AJAX)({
	    type: 'GET',
	    url: "/v1/usercenter/applogin/getTongdunSwitch"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	
	function getPcConfig(callback) {
	  (0, _Fetch.AJAX)({
	    type: 'GET',
	    url: "/v1/mpcms/common/pc/config"
	  }, function (json) {
	    callback((0, _Tools.GetConfirmation)(json));
	  });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preloadImages = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.SetKeyToBase64 = SetKeyToBase64;
	exports.decodeFromBase64 = decodeFromBase64;
	exports.myBrowser = myBrowser;
	exports.check_campaign_code = check_campaign_code;
	exports.CheckCampaignCode = CheckCampaignCode;
	exports.GetEnv = GetEnv;
	exports.GetEnvLocalhost = GetEnvLocalhost;
	exports.GetEnvValue = GetEnvValue;
	exports.soaLoginOff = soaLoginOff;
	exports.loginOff = loginOff;
	exports.loginOut = loginOut;
	exports.GetSingleCookieMatch = GetSingleCookieMatch;
	exports.SetSingleCookie = SetSingleCookie;
	exports.SetForeverCookie = SetForeverCookie;
	exports.SetTimeCookie = SetTimeCookie;
	exports.RecordOrderChannel = RecordOrderChannel;
	exports.GetSingleCookie = GetSingleCookie;
	exports.GoogleTagManager = GoogleTagManager;
	exports.pushGoogleTagManager = pushGoogleTagManager;
	exports.GetNickName = GetNickName;
	exports.GetCookie = GetCookie;
	exports.GetClientCookie = GetClientCookie;
	exports.isClient = isClient;
	exports.GetConfirmation = GetConfirmation;
	exports.AuthRedirect = AuthRedirect;
	exports.AuthRedirectV2 = AuthRedirectV2;
	exports.ResolveStatusBug = ResolveStatusBug;
	exports.send360 = send360;
	exports.getStyle = getStyle;
	exports.isDesiredPage = isDesiredPage;
	exports.deepFreeze = deepFreeze;
	exports.deepClone = deepClone;
	exports.getQueryStringValue = getQueryStringValue;
	
	var _configAuth = __webpack_require__(170);
	
	var _configAuth2 = _interopRequireDefault(_configAuth);
	
	var _reactRouter = __webpack_require__(35);
	
	var _BLL = __webpack_require__(16);
	
	var _globalToast = __webpack_require__(241);
	
	var _globalToast2 = _interopRequireDefault(_globalToast);
	
	var _jsBase = __webpack_require__(86);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); } /*
	                                                                               * @Author:
	                                                                               * @Date:
	                                                                               * @Last Modified by: murphy.meng
	                                                                               * @Last Modified time: 2020-11-27 11:19:13
	                                                                               */
	
	var BASEKEY = 'x0DE7';
	function encodeToBase64(str) {
	  return _jsBase.Base64.btoa(encodeURI(encodeURIComponent(str)));
	}
	
	function SetKeyToBase64(key) {
	  // if (!window) return key;
	  if (!key) return key;
	  // let str = key.replace(/ /g, '+')
	  var basestr = encodeToBase64(key);
	  return BASEKEY + basestr;
	}
	
	function decodeFromBase64(base64Str_x0) {
	  if (typeof base64Str_x0 !== 'string') {
	    return base64Str_x0;
	  }
	  if (base64Str_x0.slice(0, BASEKEY.length) != BASEKEY) {
	    return base64Str_x0;
	  }
	  var base64Str = base64Str_x0.slice(BASEKEY.length, base64Str_x0.length);
	  try {
	    var str = decodeURIComponent(decodeURI(_jsBase.Base64.atob(base64Str)));
	    if (str && /^[ -\uD7FF\uE000-\uFFFF]*$/.test(str)) {
	      return str;
	    } else {
	      return base64Str;
	    }
	  } catch (e) {
	    // 解码失败，返回原始字符串
	    return base64Str;
	  }
	}
	
	function myBrowser() {
	  if (!-[1]) {
	    if (console) {
	      console.log("<=IE8");
	    }
	    return true;
	  }
	}
	/**
	 * 用来校验传入的url 是否配置 track code
	 * @param {string} url 后台传入的url
	 * zoneTian
	 */
	function check_campaign_code(url) {
	  return (/intcmp=|kwrec=|prodlink=/.test(url)
	  );
	}
	function CheckCampaignCode(link, omniture) {
	  if (/intcmp=|kwrec=|prodlink=/.test(link)) {
	    return link;
	  }
	  if (!omniture || omniture === "") {
	    return link;
	  }
	  var hashNum = "";
	  var query = link.split("?")[1] || null;
	  var omni = omniture.split("?")[1] || omniture.split("?")[0];
	  omni = omni.split("&")[1] || omni.split("&")[0];
	  var domain = link.split("?")[0];
	  if (/#/.test(link) || /#/.test(omniture)) {
	    var linkHash = link.split("#")[1] || "";
	    var omnitureHash = omniture.split("#")[1] || "";
	    domain = domain.split("#")[0];
	    hashNum = linkHash && omnitureHash ? "#" + linkHash + "&" + omnitureHash : "#" + linkHash + omnitureHash;
	    query = link.match(/\?(\S*)\#/) && link.match(/\?(\S*)\#/)[1] || null;
	  }
	  return query ? domain + "?" + query + "&" + omni + hashNum : domain + "?" + omni + hashNum;
	}
	function GetEnv(title) {
	  switch (title) {
	    case "node":
	      return JSON.parse(process.env.GlobalEnv)["localhost"][title];
	    case "browser":
	      return window.__INITIAL_ENV__["localhost"][title];
	  }
	}
	function GetEnvLocalhost(title) {
	  switch (title) {
	    case "node":
	      return JSON.parse(process.env.GlobalEnv)["localhost"];
	    case "browser":
	      return window.__INITIAL_ENV__["localhost"];
	  }
	}
	function GetEnvValue(title, values, protocol) {
	  switch (title) {
	    case "node":
	      if (protocol === "https") {
	        return JSON.parse(process.env.GlobalEnv)[values].replace("http", "https");
	      } else {
	        return JSON.parse(process.env.GlobalEnv)[values];
	      }
	    case "browser":
	      if (protocol === "https") {
	        return window.__INITIAL_ENV__[values].replace("http", "https");
	      } else {
	        return window.__INITIAL_ENV__[values];
	      }
	  }
	}
	
	function soaLoginOff() {
	  var exp = new Date();
	  exp.setTime(exp.getTime() - 1);
	  document.cookie = "UID=; expires=" + exp.toGMTString() + "; path=/";
	  document.cookie = "Token=; expires=" + exp.toGMTString() + "; path=/" + "; domain=.sephora.cn";
	  location.href = "/";
	}
	
	function loginOff(callback) {
	  var wcsLoginState = GetSingleCookie("user_name");
	
	  if (wcsLoginState) {
	    var exp = new Date();
	    exp.setTime(exp.getTime() - 1);
	    document.cookie = "WC_LOGINSTART=; expires=" + exp.toGMTString() + "; path=/";
	    document.cookie = "WC_WC=; expires=" + exp.toGMTString() + "; path=/";
	    document.cookie = "WC_EMAIL=; expires=" + exp.toGMTString() + "; path=/";
	    document.cookie = "UID=; expires=" + exp.toGMTString() + "; path=/";
	    document.cookie = "Token=; expires=" + exp.toGMTString() + "; path=/";
	
	    document.cookie = "user_name=; domain=.sephora.cn; expires=" + exp.toGMTString() + "; path=/";
	    document.cookie = "user_id=; domain=.sephora.cn; expires=" + exp.toGMTString() + "; path=/";
	  }
	
	  location.href = "/webapp/wcs/stores/servlet/Logoff?catalogId=10052&langId=-7&storeId=10001&URL=TopCategoriesDisplayView";
	  var expiresDate = new Date();
	  expiresDate.setTime(expiresDate.getTime() + 90 * 24 * 60 * 60 * 1000);
	  $.cookie("orderItem", "", { path: "/", expires: expiresDate });
	  callback();
	}
	function loginOut() {
	  var data = {
	    channel: "WEB"
	  };
	  try {
	    (0, _BLL.postLoginOut)(data, function () {
	      soaLoginOff();
	    });
	  } catch (error) {
	    soaLoginOff();
	  }
	}
	function GetSingleCookieMatch(cookies) {
	  var returnCookie = null;
	  if (!document.cookie) {
	    return returnCookie;
	  }
	  document.cookie.split("; ").map(function (data, index) {
	    if (data.indexOf(cookies) > -1) {
	      returnCookie = data;
	    }
	  });
	  return returnCookie;
	}
	
	function SetSingleCookie(documentCookies, cookie, value) {
	  documentCookies = cookie + "=" + escape(value);
	}
	
	function SetForeverCookie(cookie, value) {
	  var Times = 60 * 24 * 365 * 20;
	  var exp = new Date();
	  exp.setTime(exp.getTime() + Times * 60 * 1000);
	  window.document.cookie = cookie + "=" + escape(value) + ";expires=" + exp.toGMTString() + "; domain=.sephora.cn; path=/";
	}
	
	function SetTimeCookie(cookie, value) {
	  var Times = 30;
	  var exp = new Date();
	  exp.setTime(exp.getTime() + Times * 60 * 1000);
	  window.document.cookie = cookie + "=" + escape(value) + ";expires=" + exp.toGMTString() + "; domain=.sephora.cn; path=/";
	}
	
	function RecordOrderChannel() {
	  var utm_source = _reactRouter.browserHistory.getCurrentLocation().query.utm_source;
	  var utm_medium = _reactRouter.browserHistory.getCurrentLocation().query.utm_medium;
	  var utm_campaign = _reactRouter.browserHistory.getCurrentLocation().query.utm_campaign;
	  var utm_content = _reactRouter.browserHistory.getCurrentLocation().query.utm_content;
	  var utm_term = _reactRouter.browserHistory.getCurrentLocation().query.utm_term;
	  if (utm_source || utm_medium || utm_campaign || utm_content || utm_term) {
	    var j = {};
	    j.utm_source = encodeURIComponent(utm_source);
	    j.utm_medium = encodeURIComponent(utm_medium);
	    j.utm_campaign = encodeURIComponent(utm_campaign);
	    j.utm_content = encodeURIComponent(utm_content);
	    j.utm_term = encodeURIComponent(utm_term);
	    j.currentTime = moment().format("X");
	    var stringjson = JSON.stringify(j);
	    SetTimeCookie("order_source", stringjson);
	
	    if (!$.cookie("first_touch_source")) {
	      SetForeverCookie("first_touch_source", stringjson);
	    }
	  }
	}
	
	function GetSingleCookie(documentCookies, cookie) {
	  var arr = documentCookies.match(new RegExp("(^| )" + cookie + "=([^;]*)(;|$)"));
	  if (arr != null) return unescape(arr[2]);
	  return null;
	}
	
	function GoogleTagManager(dataLayer) {
	  var _dataLayer, _dataLayer2;
	
	  window.dataLayer = (_dataLayer = dataLayer, _dataLayer2 = _toArray(_dataLayer), _dataLayer);
	  (function (w, d, s, l, i) {
	    w[l] = w[l] || [];
	    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
	    var f = d.getElementsByTagName(s)[0],
	        j = d.createElement(s),
	        dl = l != "dataLayer" ? "&l=" + l : "";
	    j.async = true;
	    j.src = "//www.googletagmanager.com/gtm.js?id=" + i + dl;
	    f.parentNode.insertBefore(j, f);
	  })(window, document, "script", "dataLayer", "GTM-N57TLT");
	}
	
	/*
	 * GoogleTagManager  Event
	 * @param dataLayer window.dataLayer
	 * @param parameter window.dataLayer.event
	 * @constructor
	 */
	function pushGoogleTagManager(parameter) {
	  //console.log( window.dataLayer );
	  //console.log( parameter );
	  if (window.dataLayer) {
	    window.dataLayer.push(parameter);
	  }
	}
	
	function GetNickName(value) {
	  if (!value || value.split("@").length > 2) {
	    return null;
	  }
	  return value.split("@")[0];
	}
	
	function GetCookie(params, callback) {
	  // prototype 设定默认CookieId 和 CookieToken
	  //let relCookieID = 'ghost';
	  var relCookieID = null;
	  var relCookieToken = null;
	
	  if (!params.Cookie) {
	    // NO Cookie Callback Ghost
	    return callback(relCookieID, relCookieToken);
	  }
	
	  if (GetSingleCookie(params.Cookie, "Token")) {
	    relCookieToken = GetSingleCookie(params.Cookie, "Token");
	  }
	
	  if (GetSingleCookie(params.Cookie, "UID")) {
	    relCookieID = GetSingleCookie(params.Cookie, "UID");
	  }
	
	  // NO match Callback Ghost
	  return callback(relCookieID, relCookieToken);
	}
	
	function GetClientCookie(params, callback) {
	  var relCookieID = null;
	  var relCookieToken = null;
	
	  if (!params.Cookie) {
	    // NO Cookie Callback Ghost
	    return callback(relCookieID, relCookieToken);
	  }
	
	  if (GetSingleCookie(params.Cookie, "Token")) {
	    relCookieToken = GetSingleCookie(params.Cookie, "Token");
	  }
	
	  if (GetSingleCookie(params.Cookie, "UID")) {
	    relCookieID = GetSingleCookie(params.Cookie, "UID");
	  }
	
	  // NO match Callback Ghost
	  return callback(relCookieID, relCookieToken);
	}
	
	function isClient() {
	  return typeof window !== "undefined" && window.document;
	}
	
	/**
	 * A.如果API返回STATUS == 401 重定向到 登录页
	 * B.如果路由在安全区，并且无Token 重定向到 登录页
	 * @param json
	 * @returns {*}
	 * @constructor
	 *
	 */
	function GetConfirmation(json) {
	  var _AuthList = _configAuth2.default.url,
	      _AuthUser = _configAuth2.default.user,
	      _PathName = window.location.pathname,
	      _Token = GetSingleCookie(window.document.cookie, "Token"),
	      ajaxOptions = json.ajaxOptions,
	      tpId = GetSingleCookie(window.document.cookie, "tpId"),
	      bindId = GetSingleCookie(window.document.cookie, "bind");
	  // FLAG => 页面级别
	  var match = false;
	
	  // USER => 接口级别
	  var user = false;
	
	  // IS_CLIENT && WHITE
	  if (isClient()) {
	    _AuthList.map(function (data, index) {
	      if (window.location.pathname.match(new RegExp(data))) {
	        match = true;
	      }
	    });
	  }
	
	  // 当前接口公共页面 但是必须有Token 才能够被访问
	  if (ajaxOptions) {
	    _AuthUser.map(function (data, index) {
	      if (ajaxOptions.url.indexOf(data) > -1) {
	        user = true;
	      }
	    });
	  }
	
	  if (json && json.jQueryStatus && json.jQueryStatus.status === 429 || json.status === 429) {
	    AuthRedirectV2(window.location);
	  }
	
	  if (json && json.jQueryStatus && json.jQueryStatus.status === 423) {
	    (0, _globalToast2.default)(JSON.parse(json.errResponseText));
	  }
	  if (!match && !user) {
	    return json;
	  }
	
	  // jQuery 接口 || nodeFetch 接口 401 Token 过期逻辑
	  if (json && json.jQueryStatus && json.jQueryStatus.status === 401 && !tpId && !bindId || json.status === 401 && !tpId && !bindId) {}
	  //AuthRedirect(window.location);
	
	
	  // 安全类页面没有Token
	  if (_AuthList.indexOf(_PathName) > -1 && !_Token && !tpId && !bindId) {
	    AuthRedirect(window.location);
	  }
	  return json;
	}
	
	function AuthRedirect(WL) {
	  var tpId = GetSingleCookie(window.document.cookie, "tpId"),
	      bindId = GetSingleCookie(window.document.cookie, "bindId");
	  var wl1 = WL.href;
	
	  // WL.href = `/login?historyLocation=${encodeURI((WL.pathname).replace('/', ''))}`;
	  // WL.href = `/login?historyLocation=${encodeURI((WL.pathname).replace('/', '') + (WL.search))}`;
	  if (wl1.indexOf('cart') == -1 && wl1.indexOf('myAccount') == -1) {
	    WL.href = "/login?historyLocation=" + (WL.pathname.replace("/", "") + WL.search);
	  } else {
	    if ((tpId == null || tpId === '') && (bindId == null || bindId === '')) {
	      WL.href = "/login?historyLocation=" + (WL.pathname.replace("/", "") + WL.search);
	    }
	  }
	}
	
	function AuthRedirectV2(WL) {
	  if (!WL.pathname.includes("v2/html/currentLimiting.html")) {
	    WL.href = "/v2/html/currentLimiting.html?historyLocation=" + (WL.pathname.replace("/", "") + WL.search);
	  }
	}
	
	/*which status err*/
	function ResolveStatusBug(statusNumber, documentName, apiName) {
	  if (statusNumber && statusNumber == 1) {
	    console.log("action\u4E0B\u7684\u6587\u4EF6:" + documentName + "\u7684" + apiName + "\u63A5\u53E3\u8FD4\u56DEstatus\u4E3A1");
	    return false;
	  }
	}
	
	/*360*/
	function send360(parameters, parameters2) {
	  if (window && window._qha) {
	    if (typeof window._qha === "function") {
	      window._qha(parameters, parameters2);
	    } else {
	      (window._qha.c = window._qha.c || []).push(parameters, parameters2);
	    }
	  }
	}
	
	/*
	 * Get style by dom or class
	 */
	function getStyle(selector, style) {
	  if (!style) return;
	
	  if (window && document && window.getComputedStyle && document.querySelector) {
	    if (typeof selector === "string") {
	      return window.getComputedStyle(document.querySelector(selector))[style];
	    } else {
	      return window.getComputedStyle(selector)[style];
	    }
	  }
	}
	
	/**
	 * @Function 是否是要做逻辑的页面
	 * @param {Object} regExp 正则表达式
	 */
	function isDesiredPage(regExp) {
	  if (typeof window == "undefined") return;
	  return regExp.test(window.location.pathname);
	}
	
	/**
	 *@Function preloadImages 图片预加载
	 *@param {array} images 图片数组
	 *@return {object} object.done是一个函数,链式调用,done方法接受一个函数参数,[func]非必需
	 */
	var preloadImages = exports.preloadImages = function preloadImages(images) {
	  if (!(images instanceof Array)) return;
	  var count = 0,
	      doSomething = void 0; // 加载完成后执行的函数
	  for (var i = 0; i < images.length; i++) {
	    var oImg = new Image();
	    oImg.src = images[i];
	    // 不管加载成功与否
	    oImg.onload = checkStatus;
	    oImg.onerror = checkStatus;
	  }
	  function checkStatus() {
	    count++;
	    if (count >= images.length) doSomething && doSomething();
	  }
	  return {
	    done: function done(func) {
	      doSomething = func;
	    }
	  };
	};
	
	/**
	 * @Function isArray 是否是数组
	 * @param {*} obj 数据
	 */
	function isArray(obj) {
	  return Object.prototype.toString.call(obj) == "[object Array]";
	}
	
	/**
	 * @Function deepFreeze 深度冻结( 只冻结实例自身属性 ) 对象 || 数组
	 * @param {Array|Object} obj 要冻结的数组或者对象
	 * [ { a:{ e: 111 },b:[ { f:222 }, { g: 333} ] },{ c:{ h: 444 } } ]
	 * { a:{ e: 111 },b:[ { f:222 }, { g: 333 } ] }
	 * [ 0,1,2,3,4,5 ]
	 */
	
	function deepFreeze(obj) {
	  Object.freeze(obj); // 对象属性 数据值属性 和 访问器属性  都不可更改
	
	  for (var property in obj) {
	    if (!obj.hasOwnProperty(property) && !(typeof obj === "undefined" ? "undefined" : _typeof(obj)) != "object") continue;
	
	    deepFreeze(obj[property]);
	  }
	}
	
	/**
	 * @Function deepClone 深度克隆( 只克隆实例自身属性 ) 对象 || 数组
	 * @param {Array|Object} obj 要深拷贝的数据  对象 || 数组
	 */
	function deepClone(obj) {
	  var temp = new obj.constructor();
	
	  for (var property in obj) {
	    if (obj.hasOwnProperty(property)) {
	      if (_typeof(obj[property]) != "object") {
	        temp[property] = obj[property];
	
	        continue;
	      }
	
	      temp[property] = deepClone(obj[property]);
	    }
	  }
	
	  return temp;
	}
	
	/**
	 * @Function getQueryStringValue 获取url参数
	 * @param {string} key url参数名
	 */
	function getQueryStringValue(key) {
	  return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports) {

	function _interopRequireDefault(e) {
	  return e && e.__esModule ? e : {
	    "default": e
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports) {

	module.exports = ReactRouter;

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GetSingleCookieMatch = GetSingleCookieMatch;
	exports.SetSingleCookie = SetSingleCookie;
	exports.GetSingleCookie = GetSingleCookie;
	exports.GetSingleCookie2 = GetSingleCookie2;
	exports.SetSingleCookie2 = SetSingleCookie2;
	exports.SetSingleCookieV2 = SetSingleCookieV2;
	exports.GetSingleCookieV2 = GetSingleCookieV2;
	exports.DelSingleCookie2 = DelSingleCookie2;
	exports.DelSingleCookie3 = DelSingleCookie3;
	exports.delToken = delToken;
	function GetSingleCookieMatch(cookies) {
	  var returnCookie = null;
	  if (!document.cookie) {
	    return returnCookie;
	  }
	  document.cookie.split('; ').map(function (data, index) {
	    if (data.indexOf(cookies) > -1) {
	      returnCookie = data;
	    }
	  });
	  return returnCookie;
	}
	
	function SetSingleCookie(documentCookies, cookie, value) {
	  documentCookies = cookie + '=' + escape(value);
	}
	
	function GetSingleCookie(documentCookies, cookie) {
	  var arr = documentCookies.match(new RegExp('(^| )' + cookie + '=([^;]*)(;|$)'));
	  if (arr !== null) return unescape(arr[2]);
	  return false;
	}
	
	function GetSingleCookie2(_ref) {
	  var _ref$key = _ref.key,
	      key = _ref$key === undefined ? false : _ref$key;
	
	  if (!window) return false;
	  if (!window.document) return false;
	  if (!window.document.cookie) return false;
	  if (!key) return false;
	
	  var List = void 0,
	      Reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");
	  if (List = document.cookie.match(Reg)) return List[2];else return false;
	}
	
	function SetSingleCookie2(_ref2) {
	  var _ref2$key = _ref2.key,
	      key = _ref2$key === undefined ? false : _ref2$key,
	      _ref2$value = _ref2.value,
	      value = _ref2$value === undefined ? false : _ref2$value,
	      _ref2$time = _ref2.time,
	      time = _ref2$time === undefined ? false : _ref2$time,
	      _ref2$domain = _ref2.domain,
	      domain = _ref2$domain === undefined ? false : _ref2$domain,
	      _ref2$path = _ref2.path,
	      path = _ref2$path === undefined ? "/" : _ref2$path;
	
	  if (!window) return false;
	  if (!window.document) return false;
	  if (!window.document.cookie) return false;
	  if (!key) return false;
	  if (!value) return false;
	
	  var _str_second = time || 0;
	  var _exp = new Date();
	  _exp.setTime(_exp.getTime() + _str_second * 1);
	
	  var _set_cookie = key + '=' + escape(value) + ";";
	  if (time) _set_cookie += "expires=" + _exp.toUTCString() + ";";
	  if (domain) _set_cookie += "domain=" + domain + ";";
	  _set_cookie += "path=" + path + ";";
	  console.log(_set_cookie, '_set_cookie');
	  window.document.cookie = _set_cookie;
	}
	function SetSingleCookieV2(_ref3) {
	  var _ref3$key = _ref3.key,
	      key = _ref3$key === undefined ? false : _ref3$key,
	      _ref3$value = _ref3.value,
	      value = _ref3$value === undefined ? false : _ref3$value,
	      _ref3$time = _ref3.time,
	      time = _ref3$time === undefined ? false : _ref3$time,
	      _ref3$domain = _ref3.domain,
	      domain = _ref3$domain === undefined ? false : _ref3$domain,
	      _ref3$path = _ref3.path,
	      path = _ref3$path === undefined ? "/" : _ref3$path;
	
	  if (typeof window == 'undefined' || typeof window.document == 'undefined' || typeof window.document.cookie == 'undefined' || !key) return false;
	  var _str_millisecond = time || 0;
	  var _exp = new Date();
	  _exp.setTime(_exp.getTime() + _str_millisecond * 1);
	
	  var _set_cookie = key + '=' + escape(value) + ";";
	  if (key == 'keywordsHistoryV2') {
	    _set_cookie = key + '=' + encodeURIComponent(value) + ";";
	  }
	  if (time) _set_cookie += "expires=" + _exp.toUTCString() + ";";
	  if (domain) _set_cookie += "domain=" + domain + ";";
	  _set_cookie += "path=" + path + ";";
	  window.document.cookie = _set_cookie;
	}
	function GetSingleCookieV2(_ref4) {
	  var _ref4$key = _ref4.key,
	      key = _ref4$key === undefined ? false : _ref4$key;
	
	  if (typeof window == 'undefined' || typeof window.document == 'undefined' || typeof window.document.cookie == 'undefined' || !key) return false;
	  var List = void 0,
	      Reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");
	  if (List = document.cookie.match(Reg)) {
	    if (key == 'keywordsHistoryV2') {
	      return decodeURIComponent(List[2]);
	    }
	    return unescape(List[2]);
	  }
	  return false;
	}
	
	function DelSingleCookie2(_ref5) {
	  var _ref5$key = _ref5.key,
	      key = _ref5$key === undefined ? false : _ref5$key;
	  // 此方法有误
	  if (!window) return false;
	  if (!window.document) return false;
	  if (!window.document.cookie) return false;
	  if (!key) return false;
	
	  var _exp = new Date();
	  _exp.setTime(_exp.getTime() - 1);
	
	  var _cval = GetSingleCookie2({ key: key });
	  if (_cval) window.document.cookie = key + '=' + _cval + ";expirse=" + _exp.toUTCString();
	}
	
	function DelSingleCookie3(_ref6) {
	  var _ref6$key = _ref6.key,
	      key = _ref6$key === undefined ? false : _ref6$key,
	      _ref6$domain = _ref6.domain,
	      domain = _ref6$domain === undefined ? false : _ref6$domain,
	      _ref6$path = _ref6.path,
	      path = _ref6$path === undefined ? "/" : _ref6$path;
	
	  if (!window) return false;
	  if (!window.document) return false;
	  if (!window.document.cookie) return false;
	  if (!key) return false;
	
	  var _exp = new Date();
	  _exp.setTime(_exp.getTime() - 1);
	  var _set_cookie = key + '=; expires=' + _exp.toUTCString() + ";";
	  if (domain) _set_cookie += " domain=" + domain + ";";
	  _set_cookie += " path=" + path + ";";
	  window.document.cookie = _set_cookie;
	}
	
	function delToken() {
	  var exp = new Date();
	  exp.setTime(exp.getTime() - 1);
	  document.cookie = "Token=; expires=" + exp.toGMTString() + "; path=/";
	}

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPcConfig = exports.getFirstOrder = exports.getIsHomeGrey = exports.setMiniCart = exports.handleKeyDown = exports.handleClick = exports.handleMouseLeave = exports.handleKeyUp = exports.handleChange = exports.handleBlur = exports.handleFocus = exports.removeHistory = exports.switchProducts = exports.handleSearchHistory = exports.initSearchData = exports.openTimer = exports.skip = exports.getSearchHref = exports.getAssociativeHref = exports.setKeywords = exports.matchBrand = exports.getDefaultModule = exports.getType = exports.clearMyTimer = exports.dealWithData = exports.postIndexReservation = exports.postLive800Msg = exports.getCategoryFixed = exports.getNavigationBrandGroup = exports.getNavigationGroup = exports.getSearchHotWorld = exports.getSearchPlaceHolder = exports.setScrollTop = exports.getCarouselText = exports.setSearchTrim = exports.getMiniCartNum = exports.getMiniCart = exports.getUserInformation = exports.getSingleCookie = exports.loginOff = exports.setNickName = exports.getSubCategory = exports.setSubCategoryHover = exports.getFixedRightBottom = exports.getFixedRightTop = exports.getTopMenu = exports.setAlphabet = exports.getUserCardInfo = exports.socialLogin = undefined;
	
	var _ActionTypes = __webpack_require__(3);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _Tools = __webpack_require__(24);
	
	var tools = _interopRequireWildcard(_Tools);
	
	var _ToolsExpr = __webpack_require__(71);
	
	var expr = _interopRequireWildcard(_ToolsExpr);
	
	var _BLL = __webpack_require__(16);
	
	var action = _interopRequireWildcard(_BLL);
	
	var _dateSortUtils = __webpack_require__(198);
	
	var _navigationHoverSort = __webpack_require__(204);
	
	var _Utils = __webpack_require__(55);
	
	var _Sensor = __webpack_require__(126);
	
	var _Sensor2 = _interopRequireDefault(_Sensor);
	
	var _GoogleAnalytics = __webpack_require__(125);
	
	var _GoogleAnalytics2 = _interopRequireDefault(_GoogleAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /*
	                                                                                                                                                                                                     * @Author:
	                                                                                                                                                                                                     * @Date:
	                                                                                                                                                                                                     * @Last Modified by: mikey.zhaopeng
	                                                                                                                                                                                                     * @Last Modified time: 2023-08-24 15:58:13
	                                                                                                                                                                                                     */
	
	function sensorEvent(href, content, omniture, type, type_detail, area) {
	  //神策 -- 搜索运营位
	  _Sensor2.default.go("clickBanner_web", {
	    $lib_detail: "PC_Search##sensorEvent##action/index.js##14",
	    banner_type: "search",
	    banner_content: content,
	    banner_belong_area: area || "searchview",
	    banner_to_url: href,
	    banner_to_page_type: href,
	    banner_ranking: "",
	    belong_team: "Search",
	    campaign_code: omniture || "",
	    key_word_tpye: type,
	    key_word_tpye_details: type_detail
	  });
	
	  _GoogleAnalytics2.default.add({
	    event: "search",
	    recommendContent: "",
	    searchCategory: "自然搜索",
	    searchTerm: content,
	    cat55: "自然搜索",
	    kw55: content
	  });
	}
	
	var socialLogin = exports.socialLogin = function socialLogin(params, callback) {
	  return function (dispatch, getState) {
	    _GoogleAnalytics2.default.add({
	      event: "accountLogin"
	    });
	
	    action.socialLogin(params, function (json) {
	      callback(json);
	    });
	  };
	};
	
	var getUserCardInfo = exports.getUserCardInfo = function getUserCardInfo(callback) {
	  return function (dispatch, getState) {
	    action.getUserCardInfo(function (json) {
	      (0, _Tools.ResolveStatusBug)(json.status, "index", "getUserCardInfo");
	      if (json.status === 0) {
	        callback(json);
	      }
	    });
	  };
	};
	var setAlphabet = exports.setAlphabet = function setAlphabet(value) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: types.HOME.NAVIGATION_ALPHABET,
	      NAVIGATION_ALPHABET: value
	    });
	  };
	};
	
	var getTopMenu = exports.getTopMenu = function getTopMenu() {
	  return function (dispatch, getState) {
	    action.getAdvertisingText({
	      locationLabel: "PC:HOMEPAGE:TOP_TEXT"
	    }, function (json) {
	      (0, _Tools.ResolveStatusBug)(json.status, "index", "getTopMenu");
	      if (json && json.results && json.status == 0) {
	        dispatch({
	          type: types.HOME.TOP_MENU,
	          TOP_MENU: json.results
	        });
	      }
	    });
	  };
	};
	
	var getFixedRightTop = exports.getFixedRightTop = function getFixedRightTop() {
	  return function (dispatch, getState) {
	    action.getAdvertisingText({
	      locationLabel: "PC:HOMEPAGE:SIDEBARTOP"
	    }, function (json) {
	      (0, _Tools.ResolveStatusBug)(json.status, "index", "getFixedRightTop");
	      if (json && json.results && json.status == 0) {
	        dispatch({
	          type: types.HOME.FIXED_RIGHT_TOP,
	          FIXED_RIGHT_TOP: json.results
	        });
	      }
	    });
	  };
	};
	
	var getFixedRightBottom = exports.getFixedRightBottom = function getFixedRightBottom() {
	  return function (dispatch, getState) {
	    action.getAdvertisingText({
	      locationLabel: "PC:HOMEPAGE:SIDEBARBOTTOM"
	    }, function (json) {
	      (0, _Tools.ResolveStatusBug)(json.status, "index", "getFixedRightBottom");
	      if (json && json.results && json.status == 0) {
	        dispatch({
	          type: types.HOME.FIXED_RIGHT_BOTTOM,
	          FIXED_RIGHT_BOTTOM: json.results
	        });
	      }
	    });
	  };
	};
	
	var setSubCategoryHover = exports.setSubCategoryHover = function setSubCategoryHover(value, nickname) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: types.HOME.CATEGORY_HOVER,
	      CATEGORY_HOVER: value,
	      CATEGORY_NICKNAME: nickname
	    });
	  };
	};
	
	var getSubCategory = exports.getSubCategory = function getSubCategory(prototypeList, value) {
	  return function (dispatch, getState) {
	    var categoryItem = expr.exprInt(value * 1);
	
	    // 本地缓存
	    var HAS = 0;
	    for (var i in prototypeList) {
	      if (prototypeList[i].ID === value) {
	        HAS = 1;
	      }
	    }
	
	    if (HAS === 1) {
	      return;
	    }
	
	    if (categoryItem) {
	      action.getSubCategory(value, function (json) {
	        if (json) {
	          var rule = (0, _navigationHoverSort.navigationSort)(json);
	          dispatch({
	            type: types.HOME.CATEGORY,
	            CATEGORY_ID: value,
	            CATEGORY_RESPONSE: json,
	            CATEGORY_RESPONSE_RULE: rule
	          });
	        }
	      });
	    } else {
	      action.getAdPositionCategory(value, function (json) {
	        if (json) {
	          var rule = (0, _navigationHoverSort.navigationSort)(json);
	          dispatch({
	            type: types.HOME.CATEGORY,
	            CATEGORY_ID: value,
	            CATEGORY_RESPONSE: json,
	            CATEGORY_RESPONSE_RULE: rule
	          });
	        }
	      });
	    }
	  };
	};
	
	var setNickName = exports.setNickName = function setNickName(dispatch, getState, cookieName) {
	  var _getSingleCookie = tools.GetSingleCookie(cookieName);
	  var _getNickName = null;
	  if (_getSingleCookie) {
	    _getNickName = tools.GetNickName(_getSingleCookie); // 获取昵称
	    dispatch({ type: types.USER.NICK_NAME, NICK_NAME: _getNickName });
	  }
	};
	
	var loginOff = exports.loginOff = function loginOff() {
	  // return (dispatch, getState) => {
	  // tools.soaLoginOff();
	  tools.loginOut();
	  //tools.loginOff(() => {
	  //    setNickName( dispatch, getState, 'UID')
	  //})
	  // };
	};
	
	var getSingleCookie = exports.getSingleCookie = function getSingleCookie() {
	  return function (dispatch, getState) {
	    setNickName(dispatch, getState, "user_name");
	  };
	};
	
	var getUserInformation = exports.getUserInformation = function getUserInformation() {
	  return function (dispatch, getState) {
	    var userId = tools.GetSingleCookie("user_id") || "6105297";
	    if (userId) {
	      var params = {
	        storeId: "0001",
	        userId: userId
	      };
	      // has SOA_LOGIN_USER_ID
	      action.getUserInformation(params, function (json) {
	        (0, _Tools.ResolveStatusBug)(json.status, "index", "getUserInformation");
	        if (json.status === 0 && json.results) {
	          dispatch({
	            type: types.USER.USER_ID,
	            USER_TYPE: json.results.cardType || null,
	            USER_POINT: json.results.points || null
	          });
	        }
	      });
	    }
	  };
	};
	
	var getMiniCart = exports.getMiniCart = function getMiniCart(callback) {
	  return function (dispatch, getState) {
	    action.getMiniCart(function (json) {
	      if (json.status === 0) {
	        callback && callback(json.results);
	        dispatch({ type: types.USER.MINI_CART, MINI_CART: json.results });
	      }
	      if (json.errorCode === "CMN1039E") {
	        dispatch({ type: types.USER.ERROR_CODE, ERROR_CODE: json.errorCode });
	      }
	      if (json.errorCode === "2510") {
	        dispatch({ type: types.USER.ERROR_CODE, ERROR_CODE: json.errorCode });
	      }
	    });
	  };
	};
	
	var getMiniCartNum = exports.getMiniCartNum = function getMiniCartNum(callback) {
	  return function (dispatch, getState) {
	    action.getMiniCartNum(function (json) {
	      callback && callback(json.results);
	      dispatch({
	        type: types.USER.MINI_CART_NUM,
	        MINI_CART_NUM: json.results
	      });
	    });
	  };
	};
	
	/*export const getUI = () => {
	    return (dispatch, getState) => {
	        dispatch({
	            type: types.UI,
	            UI
	        });
	    };
	};*/
	
	var setSearchTrim = exports.setSearchTrim = function setSearchTrim(value) {
	  return function (dispatch, getState) {
	    dispatch({ type: types.HOME.SEARCH_TRIM, SEARCH_TRIM: value });
	  };
	};
	
	var getCarouselText = exports.getCarouselText = function getCarouselText() {
	  return function (dispatch, getState) {
	    action.getAdvertisingText({
	      locationLabel: "PC:HOMEPAGE:TOP_TEXT_CAROUSEL"
	    }, function (json) {
	      (0, _Tools.ResolveStatusBug)(json.status, "index", "getCarouselText");
	      if (json && json.results && json.status == 0) {
	        var resourceList = json.results.resourceList;
	
	        dispatch({
	          type: types.HOME.TOP_CAROUSEL,
	          TOP_CAROUSEL: resourceList
	        });
	      }
	    });
	  };
	};
	
	var setScrollTop = exports.setScrollTop = function setScrollTop(nodes, value, nickname) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: types.HOME.CATEGORY_SCROLL_TOP,
	      NODES_NAME: nodes,
	      SCROLL_TOP: value,
	      CONTENT: nickname
	    });
	  };
	};
	
	var getSearchPlaceHolder = exports.getSearchPlaceHolder = function getSearchPlaceHolder(callback) {
	  return function (dispatch, getState) {
	    action.getAdvertisingText({
	      locationLabel: "PC:HOMEPAGE:SEARCHBOX_TEXT"
	    }, function (json) {
	      dispatch({
	        type: types.ASYNC.GET_SEARCH_PLACEHOLDER,
	        GET_SEARCH_PLACEHOLDER: json
	      });
	      callback && callback(json);
	    });
	  };
	};
	
	var getSearchHotWorld = exports.getSearchHotWorld = function getSearchHotWorld() {
	  // PC:HOMEPAGE:POPULAR_TEXT
	  return function (dispatch, getState) {
	    action.getAdvertisingTextNew({
	      locationLabel: "PC:HOMEPAGE:POPULAR_TEXT"
	    }, function (json) {
	      dispatch({
	        type: types.ASYNC.GET_SEARCH_HOT_WORLD,
	        GET_SEARCH_HOT_WORLD: json
	      });
	    });
	  };
	};
	
	var getNavigationGroup = exports.getNavigationGroup = function getNavigationGroup() {
	  return function (dispatch, getState) {
	    action.getNavigationGroup(function (json) {
	      dispatch({
	        type: types.ASYNC.GET_NAVIGATION_GROUP,
	        GET_NAVIGATION_GROUP: json
	      });
	    });
	  };
	};
	
	var getNavigationBrandGroup = exports.getNavigationBrandGroup = function getNavigationBrandGroup() {
	  return function (dispatch, getState) {
	    action.getNavigationBrandGroup(function (json) {
	      dispatch({
	        type: types.ASYNC.GET_NAVIGATION_BRAND_GROUP,
	        GET_NAVIGATION_BRAND_GROUP: json
	      });
	    });
	  };
	};
	
	var getCategoryFixed = exports.getCategoryFixed = function getCategoryFixed() {
	  return function (dispatch, getState) {
	    action.getAdvertisingText({
	      locationLabel: "PC:HOMEPAGE:GUIDEFLOAT"
	    }, function (json) {
	      (0, _Tools.ResolveStatusBug)(json.status, "index", "getCategoryFixed");
	      if (json.status === 0 && json.results && json.results.resourceList) {
	        dispatch({
	          type: types.HOME.FIXED_LEFT_CATEGORY,
	          FIXED_LEFT_CATEGORY: json.results.resourceList
	        });
	      }
	    });
	  };
	};
	
	var postLive800Msg = exports.postLive800Msg = function postLive800Msg(params, callback) {
	  return function (dispatch, getState) {
	    action.postLive800Msg(params, function (json) {
	      (0, _Tools.ResolveStatusBug)(json.status, "index", "postLive800Msg");
	      if (json.status === 0 && json.results) {
	        callback(json.results);
	      }
	    });
	  };
	};
	
	/* 首页新增预约活动中心 */
	var postIndexReservation = exports.postIndexReservation = function postIndexReservation(params, callback) {
	  return function (dispatch, getState) {
	    action.postIndexReservation(params, function (json) {
	      (0, _Tools.ResolveStatusBug)(json.status, "index", "postIndexReservation");
	      if (json.status === 0 && json.results) {
	        callback(json.results);
	      }
	    });
	  };
	};
	
	/*
	 * 搜索框逻辑优化修改
	 */
	var dealWithData = exports.dealWithData = function dealWithData(dispatch, getState, dir, TYPE) {
	  // 处理搜索框placeholder广告位
	  var _getState = getState(),
	      searchPlaceHolder = _getState.searchPlaceHolder,
	      async = _getState.async,
	      keywordData = _getState.keywordData,
	      hotWordsData = _getState.hotWordsData,
	      home = _getState.home,
	      placeholders = [],
	      placeholder = "",
	      value = dir.refs.searchInput.value;
	  // 1.页面异步请求获取广告位 : 超过4个截取前4个
	
	
	  if (!searchPlaceHolder.results && async.searchPlaceHolder && async.searchPlaceHolder.results && async.searchPlaceHolder.results.resourceList.length) {
	    placeholders = async.searchPlaceHolder.results.resourceList.slice(0, 4);
	  }
	  // 2.页面同步获取广告位 : 超过4个截取前4个
	  if (searchPlaceHolder && searchPlaceHolder.results && searchPlaceHolder.results.resourceList.length) {
	    placeholders = searchPlaceHolder.results.resourceList.slice(0, 4);
	  }
	  // 3.热搜词页面 && 搜索此页面逻辑  ==> 相当于有一个广告位的情况，并且link链接到search页面
	  if (keywordData && keywordData.results || hotWordsData && hotWordsData.results) {
	    var text = keywordData && keywordData.results && keywordData.results.keyWords || hotWordsData && hotWordsData.results && hotWordsData.results.hotWords;
	    placeholders = [{ content: text, link: "/search/?k=" + (0, _Tools.SetKeyToBase64)(text), isSearch: true }];
	  }
	  if (placeholders.length == 0) {
	    placeholder = "请输入您要搜索的关键词";
	  }
	  if (placeholders.length == 1) {
	    placeholder = placeholders[0];
	  }
	  if (placeholders.length > 1) {
	    !value && openTimer(placeholders, TYPE)(dispatch, getState);
	  }
	  return {
	    placeholders: placeholders,
	    placeholder: placeholder,
	    value: value
	  };
	};
	
	var clearMyTimer = exports.clearMyTimer = function clearMyTimer(TYPE) {
	  return function (dispatch, getState) {
	    var _getState2 = getState(),
	        home = _getState2.home,
	        SearchInnerFixed = home.SearchInnerFixed,
	        SearchInnerStatic = home.SearchInnerStatic,
	        myTimerType = getType(TYPE, "MYTIMER"),
	        myTimer = void 0;
	
	    TYPE == "static" && (myTimer = SearchInnerStatic.myTimer);
	    TYPE == "fixed" && (myTimer = SearchInnerFixed.myTimer);
	    myTimer && clearInterval && clearInterval(myTimer);
	    if (myTimerType) {
	      dispatch({ type: myTimerType, myTimer: null });
	    }
	  };
	};
	
	// 按照type类型拆分状态
	var getType = exports.getType = function getType(TYPE, constant) {
	  var _type = void 0;
	  if (TYPE == "static") {
	    constant == "MYTIMER" && (_type = types.HOME.SEARCH_MYTIMER_STATIC);
	    constant == "PLACEHOLDER" && (_type = types.HOME.SEARCH_INNER_PLACEHOLDER_STATIC);
	    constant == "PLACEHOLDERS" && (_type = types.HOME.SEARCH_INNER_PLACEHOLDERS_STATIC);
	    constant == "UPDOWN" && (_type = types.HOME.PRESS_UP_DOWN_STATIC);
	  }
	  if (TYPE == "fixed") {
	    constant == "MYTIMER" && (_type = types.HOME.SEARCH_MYTIMER_FIXED);
	    constant == "PLACEHOLDER" && (_type = types.HOME.SEARCH_INNER_PLACEHOLDER_FIXED);
	    constant == "PLACEHOLDERS" && (_type = types.HOME.SEARCH_INNER_PLACEHOLDERS_FIXED);
	    constant == "UPDOWN" && (_type = types.HOME.PRESS_UP_DOWN_FIXED);
	  }
	  return _type;
	};
	
	// 默认搜索展开层逻辑
	var getDefaultModule = exports.getDefaultModule = function getDefaultModule(TYPE) {
	  return function (dispatch, getState) {
	    var productIds = [],
	        keywordsHistory = [],
	        type = TYPE == "static" ? types.HOME.SEARCH_RESULTS_STATIC : types.HOME.SEARCH_RESULTS_FIXED;
	    if ((0, _Utils.GetSingleCookieV2)({ key: "productIds" })) productIds = (0, _Utils.GetSingleCookieV2)({ key: "productIds" }).split(",");
	    if ((0, _Utils.GetSingleCookieV2)({ key: "keywordsHistoryV2" })) keywordsHistory = (0, _Utils.GetSingleCookieV2)({ key: "keywordsHistoryV2" }).split(",");
	    dispatch({ type: types.HOME.SEARCHHISTORY, SearchHistory: keywordsHistory });
	    // 默认产品获取: 不管有没有都去请求
	    action.getProductsByIds(productIds, function (json) {
	      if (json && json.status === 0) {
	        dispatch({
	          type: types.HOME.DEFAULTPRODUCTS,
	          DefaultProducts: json.results
	        });
	        dispatch({
	          type: type,
	          down: 0,
	          results: null,
	          suggestList: null,
	          suggestProductList: null,
	          DefaultModule: 1
	        });
	      }
	    });
	    return;
	  };
	};
	
	var matchBrand = exports.matchBrand = function matchBrand(brandGroup, value) {
	  if (!(brandGroup instanceof Array)) return false;
	  for (var i in brandGroup) {
	    for (var j in brandGroup[i].brandList) {
	      var brandNameEN = brandGroup[i] && brandGroup[i].brandList && brandGroup[i].brandList[j].brandNameEN && brandGroup[i].brandList[j].brandNameEN.toLowerCase();
	      var valueLowerCase = value && value.toLowerCase();
	      var brandNickNames = brandGroup[i] && brandGroup[i].brandList && brandGroup[i].brandList[j].brandNickNames && brandGroup[i].brandList[j].brandNickNames.map(function (item) {
	        return item && item.toLowerCase();
	      });
	      if (brandNameEN == valueLowerCase || brandGroup[i].brandList[j].brandNameCN == value || brandNickNames && brandNickNames.includes(valueLowerCase)) {
	        return "/brand/" + brandNameEN.replace(/\s/g, "") + "-" + brandGroup[i].brandList[j].brandId + "/";
	      }
	    }
	  }
	  return false;
	};
	
	// 关键词存入 cookie
	var setKeywords = exports.setKeywords = function setKeywords(_ref) {
	  var _ref$key = _ref.key,
	      key = _ref$key === undefined ? null : _ref$key,
	      _ref$value = _ref.value,
	      value = _ref$value === undefined ? null : _ref$value,
	      _ref$length = _ref.length,
	      length = _ref$length === undefined ? 10 : _ref$length;
	
	  if (!value || !key) return;
	  // 1.关键词已经搜索过但是被清空了: ""
	  // 2.关键词为第一次搜索: false
	  var keywordsHistory = [];
	  var time = 3 * 365 * 24 * 60 * 60 * 1000;
	  if ((0, _Utils.GetSingleCookieV2)({ key: key })) keywordsHistory = (0, _Utils.GetSingleCookieV2)({ key: key }).split(",");
	  // 3.关键词非第一次搜索
	  var keywordIndex = keywordsHistory.findIndex(function (item, index, arr) {
	    return item == value;
	  });
	  if (keywordIndex != -1) keywordsHistory.splice(keywordIndex, 1);
	
	  keywordsHistory.unshift(value);
	  // 4.关键词最多保留 n 个
	  var keywords = [].concat(_toConsumableArray(keywordsHistory));
	  if (keywordsHistory.length > length) keywords = keywordsHistory.slice(0, length);
	
	  (0, _Utils.SetSingleCookieV2)({
	    key: key,
	    value: keywords.join(","),
	    time: time,
	    path: "/"
	  });
	};
	// 联想词逻辑跳转
	var getAssociativeHref = exports.getAssociativeHref = function getAssociativeHref(TYPE) {
	  return function (dispatch, getState) {
	    var _getState3 = getState(),
	        home = _getState3.home,
	        SearchResultsStatic = home.SearchResultsStatic,
	        SearchResultsFixed = home.SearchResultsFixed,
	        UpDownKeyCodeStatic = home.UpDownKeyCodeStatic,
	        UpDownKeyCodeFixed = home.UpDownKeyCodeFixed,
	        suggestList = TYPE == "static" ? SearchResultsStatic && SearchResultsStatic.suggestList : SearchResultsFixed && SearchResultsFixed.suggestList,
	        order = TYPE == "static" ? UpDownKeyCodeStatic : UpDownKeyCodeFixed,
	        associativeHref = "";
	
	    if (order != null && suggestList && suggestList.length > 0 && suggestList[order]) {
	      if (suggestList[order].suggestKeyWord) associativeHref = "/search/?k=" + (0, _Tools.SetKeyToBase64)(suggestList[order].suggestKeyWord);
	      if (suggestList[order].suggestBrandEn) associativeHref = "/brand/" + suggestList[order].suggestBrandEn.replace(/\s/g, "") + "-" + suggestList[order].suggestBrandId + "/";
	      suggestList[order].suggestKeyWord && setKeywords({
	        key: "keywordsHistoryV2",
	        value: suggestList[order].suggestKeyWord,
	        length: 10
	      });
	      return associativeHref;
	    }
	    return false;
	  };
	};
	
	/**
	 * @Function 完成握手,A/B站跳转
	 * @param {String} value 输入词 || 历史搜索词
	 * @param {Number|Boolean} isHistory 是否是历史搜索词
	 *
	 */
	var getSearchHref = exports.getSearchHref = function getSearchHref(value) {
	  location.href = "/search/?k=" + (0, _Tools.SetKeyToBase64)(value);
	};
	// 搜索跳转
	var skip = exports.skip = function skip(e, dir, TYPE) {
	  return function (dispatch, getState) {
	    var _getState4 = getState(),
	        home = _getState4.home,
	        navigationBrandGroup = _getState4.navigationBrandGroup,
	        async = _getState4.async,
	        SearchInnerStatic = home.SearchInnerStatic,
	        SearchInnerFixed = home.SearchInnerFixed,
	        associativeHref = getAssociativeHref(TYPE)(dispatch, getState),
	        placeholder = "";
	
	    if (associativeHref) {
	      location.href = associativeHref;
	      return;
	    }
	    if (TYPE == "static") placeholder = SearchInnerStatic.placeholder;
	    if (TYPE == "fixed") placeholder = SearchInnerFixed.placeholder;
	
	    var value = dir.refs.searchInput.value,
	        brandGroup = navigationBrandGroup && navigationBrandGroup.results || async.navigationBrandGroup && async.navigationBrandGroup.results;
	    value = value.replace(/\%|\#/g, "").trim();
	
	    if (!value) {
	      // 为空
	      _GoogleAnalytics2.default.add({
	        event: "search",
	        searchCategory: "点击搜索",
	        searchTerm: value,
	        cat55: "点击搜索",
	        kw55: value
	      });
	      if (placeholder && placeholder.content && placeholder.link) {
	        var href = placeholder.link && (0, _Tools.check_campaign_code)(placeholder.link) ? placeholder.link : placeholder.omniture ? placeholder.link + placeholder.omniture : placeholder.link;
	        sensorEvent(placeholder.link, placeholder.content, placeholder.omniture, "ClickTerm", "Default");
	        location.href = href; // --- zone 埋点修改
	        return;
	      }
	      if (placeholder && placeholder.content && !placeholder.link) {
	        var _href = "/hot/?k=" + (0, _Tools.SetKeyToBase64)(placeholder.content);
	        sensorEvent(_href, placeholder.content, placeholder.omniture, "ClickTerm", "Default");
	        location.href = placeholder.omniture ? _href + placeholder.omniture : _href; // --- zone 埋点修改
	        return;
	      }
	    } else {
	      var _href2 = !!matchBrand(brandGroup, value) ? matchBrand(brandGroup, value) : "/search/?k=" + (0, _Tools.SetKeyToBase64)(value);
	      setKeywords({ key: "keywordsHistoryV2", value: value, length: 10 });
	      sensorEvent(_href2, value, "", "ManualInput", "Organic");
	      if (!!matchBrand(brandGroup, value)) {
	        location.href = matchBrand(brandGroup, value);
	        return;
	      }
	      getSearchHref(value);
	    }
	  };
	};
	
	var openTimer = exports.openTimer = function openTimer(placeholders, TYPE) {
	  return function (dispatch, getState) {
	    var order = 0,
	        placeholderType = getType(TYPE, "PLACEHOLDER"),
	        myTimerType = getType(TYPE, "MYTIMER"),
	        myTimer = null;
	    setInterval && (myTimer = setInterval(function () {
	      dispatch({ type: placeholderType, placeholder: placeholders[order] });
	      if (order < placeholders.length - 1) {
	        order++;
	      } else {
	        order = 0;
	      }
	    }, 3000));
	    dispatch({ type: myTimerType, myTimer: myTimer });
	  };
	};
	
	var initSearchData = exports.initSearchData = function initSearchData(dir, TYPE) {
	  return function (dispatch, getState) {
	    var obj = dealWithData(dispatch, getState, dir, TYPE),
	        placeholderType = getType(TYPE, "PLACEHOLDER"),
	        placeholdersType = getType(TYPE, "PLACEHOLDERS");
	    dispatch({ type: placeholdersType, placeholders: obj.placeholders });
	    dispatch({ type: placeholderType, placeholder: obj.placeholder });
	  };
	};
	
	// 历史搜索词链接跳转 : 点击历史搜索关键词( 注意区分是进“品牌页”还是“结果页” )
	var handleSearchHistory = exports.handleSearchHistory = function handleSearchHistory(item, e) {
	  return function (dispatch, getState) {
	    e && e.preventDefault();
	    _GoogleAnalytics2.default.add({
	      event: "search",
	      searchCategory: "History Search",
	      searchTerm: item,
	      cat55: "History Search",
	      kw55: item
	    });
	
	    var _getState5 = getState(),
	        navigationBrandGroup = _getState5.navigationBrandGroup,
	        async = _getState5.async,
	        keywordsHistory = [],
	        brandGroup = navigationBrandGroup && navigationBrandGroup.results || async.navigationBrandGroup && async.navigationBrandGroup.results;
	
	    var href = !!matchBrand(brandGroup, item) ? matchBrand(brandGroup, item) : "/search/?k=" + (0, _Tools.SetKeyToBase64)(item);
	    setKeywords({ key: "keywordsHistoryV2", value: item, length: 10 });
	    sensorEvent(href, item, "", "ClickTerm", "History Search");
	    if (!!matchBrand(brandGroup, item)) {
	      location.href = matchBrand(brandGroup, item);
	      return;
	    }
	    getSearchHref(item);
	    // window.location.href = href;
	  };
	};
	// 换一换
	var switchProducts = exports.switchProducts = function switchProducts() {
	  return function (dispatch, getState) {
	    var _getState6 = getState(),
	        home = _getState6.home,
	        SwitchProducts = home.SwitchProducts,
	        DefaultProducts = home.DefaultProducts;
	    //console.log('switchProducts---------->',SwitchProducts);
	
	
	    if (DefaultProducts && DefaultProducts.length > 4) {
	      dispatch({
	        type: types.HOME.SWITCHPRODUCTS,
	        SwitchProducts: !SwitchProducts
	      });
	    }
	  };
	};
	// 清空历史搜索
	var removeHistory = exports.removeHistory = function removeHistory() {
	  return function (dispatch, getState) {
	    var expiresTime = -1 * 24 * 60 * 60 * 1000;
	    (0, _Utils.SetSingleCookieV2)({
	      key: "keywordsHistoryV2",
	      value: "",
	      time: expiresTime,
	      path: "/"
	    });
	    (0, _Utils.SetSingleCookieV2)({
	      key: "productIds",
	      value: "",
	      time: expiresTime,
	      path: "/"
	    });
	    dispatch({ type: types.HOME.SEARCHHISTORY, SearchHistory: null });
	    dispatch({ type: types.HOME.DEFAULTPRODUCTS, DefaultProducts: null });
	  };
	};
	
	// 搜索框事件===================================================================
	var handleFocus = exports.handleFocus = function handleFocus(dir, TYPE) {
	  return function (dispatch, getState) {
	    clearMyTimer(TYPE)(dispatch, getState);
	    var placeholderType = getType(TYPE, "PLACEHOLDER"),
	        _getState7 = getState(),
	        home = _getState7.home,
	        SearchInnerStatic = home.SearchInnerStatic,
	        placeholder = SearchInnerStatic.placeholder;
	
	    placeholder.isSearch && (dir.refs.searchInput.value = placeholder.content); // 只是针对search页面 和 hot页面
	    sensorEvent("", dir.refs.searchInput.value, null, null, null, "searchbar");
	    dispatch({ type: placeholderType, placeholder: "" });
	  };
	};
	
	var handleBlur = exports.handleBlur = function handleBlur(dir, TYPE) {
	  return function (dispatch, getState) {
	    var obj = dealWithData(dispatch, getState, dir, TYPE),
	        placeholderType = getType(TYPE, "PLACEHOLDER");
	    dispatch({
	      type: placeholderType,
	      placeholder: obj.placeholder
	    });
	  };
	};
	
	var handleChange = exports.handleChange = function handleChange(e, dir, TYPE) {
	  return function (dispatch, getState) {
	    clearMyTimer(TYPE)(dispatch, getState);
	    var value = dir.refs.searchInput.value,
	        type = TYPE == "static" ? types.HOME.SEARCH_RESULTS_STATIC : types.HOME.SEARCH_RESULTS_FIXED;
	    if (value.trim() == "") {
	      getDefaultModule(TYPE)(dispatch, getState);
	      return;
	    }
	    action.getSearchResultsV2(value, function (json) {
	      if (json && json.status === 0) {
	        var suggestList = json.results.suggestList && json.results.suggestList.slice(0, 3),
	            // 要求最多显示3条
	        suggestBrandDtoList = json.results.suggestBrandDtoList && json.results.suggestBrandDtoList.slice(0, 3),
	            // 要求最多显示3条
	        suggestProductList = json.results.suggestProductList && json.results.suggestProductList.slice(0, 6); // 要求最多显示6条
	        suggestList = [].concat(_toConsumableArray(suggestList), _toConsumableArray(suggestBrandDtoList));
	        var keyCodeType = getType(TYPE, "UPDOWN");
	        dispatch({ type: keyCodeType, keyCode: null }); // 选择上下后选中到某个位置，然后又进行输入搜索再次去选择
	        dispatch({
	          type: type,
	          results: json.results,
	          down: 1,
	          suggestList: suggestList,
	          suggestProductList: suggestProductList,
	          DefaultModule: 0
	        });
	        _GoogleAnalytics2.default.add({
	          event: "search",
	          recommendContent: suggestProductList,
	          searchCategory: "自然搜索",
	          searchTerm: value,
	          cat55: "自然搜索",
	          kw55: value
	        });
	      }
	    });
	  };
	};
	var handleKeyUp = exports.handleKeyUp = function handleKeyUp(e, dir, TYPE) {
	  return function (dispatch, getState) {
	    // (e.keyCode == '13') && skip( e,dir )( dispatch, getState );
	    if (e.keyCode == "13") {
	      skip(e, dir, TYPE)(dispatch, getState);
	      return;
	    }
	
	    //输入框清空后偶然出现联想词的问题
	    var value = dir.refs.searchInput.value;
	    if (value.trim() == "") {
	      getDefaultModule(TYPE)(dispatch, getState);
	      return;
	    }
	  };
	};
	
	var handleMouseLeave = exports.handleMouseLeave = function handleMouseLeave(TYPE) {
	  return function (dispatch, getState) {
	    var type = TYPE == "static" ? types.HOME.SEARCH_RESULTS_STATIC : types.HOME.SEARCH_RESULTS_FIXED;
	    var keyCodeType = getType(TYPE, "UPDOWN");
	    dispatch({ type: type, down: 0, DefaultModule: 0 });
	    dispatch({ type: keyCodeType, keyCode: null });
	  };
	};
	
	var handleClick = exports.handleClick = function handleClick(e, dir, TYPE) {
	  return function (dispatch, getState) {
	    console.log(e, 'e');
	    console.log(dir, 'dir');
	    console.log(TYPE, 'TYPE');
	    skip(e, dir, TYPE)(dispatch, getState);
	  };
	};
	var handleKeyDown = exports.handleKeyDown = function handleKeyDown(e, dir, TYPE) {
	  return function (dispatch, getState) {
	    if (e.keyCode != 38 && e.keyCode != 40) return;
	    var keyCodeType = getType(TYPE, "UPDOWN"),
	        _getState8 = getState(),
	        home = _getState8.home,
	        SearchResultsStatic = home.SearchResultsStatic,
	        SearchResultsFixed = home.SearchResultsFixed,
	        UpDownKeyCodeStatic = home.UpDownKeyCodeStatic,
	        UpDownKeyCodeFixed = home.UpDownKeyCodeFixed,
	        suggestList = TYPE == "static" ? SearchResultsStatic.suggestList : SearchResultsFixed.suggestList,
	        length = suggestList && suggestList.length && suggestList.length - 1,
	        order = TYPE == "static" ? UpDownKeyCodeStatic : UpDownKeyCodeFixed;
	    // if( !length ) return; // suggestList长度是 0 || suggestList不存在的情况
	    if (length < 0 || length == undefined || length == null) return; // suggestList长度是 0 || suggestList不存在的情况
	    // 选择上下后选中到某个位置，然后又进行输入搜索再次去选择 --> 在onChange事件中做
	    // 上键: 0 || null
	    // 下键: null || 等于数据长度的时候
	    // 正常加减
	    if (e.keyCode == 38) {
	      if (order == null || order == 0) {
	        order = length;
	      } else {
	        order = order - 1;
	      }
	    }
	    if (e.keyCode == 40) {
	      if (order == null || order == length) {
	        order = 0;
	      } else {
	        order = order + 1;
	      }
	    }
	    dir.refs.searchInput.value = suggestList && suggestList[order] && (suggestList[order].suggestBrandEn || suggestList[order].suggestKeyWord);
	    dispatch({ type: keyCodeType, keyCode: order });
	  };
	};
	
	var setMiniCart = exports.setMiniCart = function setMiniCart(para, callback) {
	  var ordinaryShopCartSkus = [];
	  if (para && para.results && para.results.shopcartSkus) {
	    ordinaryShopCartSkus = para.results.shopcartSkus;
	  }
	  return function (dispatch, getState) {
	    dispatch({
	      type: types.USER.MINI_CART,
	      MINI_CART: {
	        invalidShopCartSkus: [],
	        ordinaryShopCartSkus: ordinaryShopCartSkus,
	        presaleShopCartSkus: [],
	        totalAmount: para.results.totalAmount,
	        totalItems: para.results.normalOrderItems
	      }
	    });
	  };
	};
	
	var getIsHomeGrey = exports.getIsHomeGrey = function getIsHomeGrey(callback) {
	  return function (dispatch, getState) {
	    action.getIsHomeGrey(function (json) {
	      if (json.status === 0) {
	        callback(json);
	      }
	    });
	  };
	};
	
	var getFirstOrder = exports.getFirstOrder = function getFirstOrder() {
	  return function (dispatch, getState) {
	    action.getFirstOrder(function (json) {
	      if (json && json.results && json.status == 0) {
	        dispatch({
	          type: types.HOME.FIRSTORDERGIFT,
	          FirstOrderGift: json.results
	        });
	      }
	    });
	  };
	};
	var getPcConfig = exports.getPcConfig = function getPcConfig(callback) {
	  return function (dispatch, getState) {
	    action.getPcConfig(function (json) {
	      if (json && json.results && json.status == 0) {
	        callback(json.results);
	      }
	    });
	  };
	};

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.typeofArray = __webpack_require__(56).typeofArray;
	exports.typeofFunction = __webpack_require__(56).typeofFunction;
	exports.typeofObject = __webpack_require__(56).typeofObject;
	exports.typeofString = __webpack_require__(56).typeofString;
	exports.typeofPrototype = __webpack_require__(56).typeofPrototype;
	
	exports.SetSingleCookie2 = __webpack_require__(38).SetSingleCookie2;
	exports.SetSingleCookieV2 = __webpack_require__(38).SetSingleCookieV2;
	exports.GetSingleCookieV2 = __webpack_require__(38).GetSingleCookieV2;
	exports.FixNum = __webpack_require__(202).FixNum;
	
	exports.cookieMatch = __webpack_require__(38).GetSingleCookieMatch;
	exports.cookieSet = __webpack_require__(38).SetSingleCookie;
	exports.cookieGet = __webpack_require__(38).GetSingleCookie;
	
	exports.isClient = __webpack_require__(203).isClient;
	
	exports.GoogleTagManagerV2 = __webpack_require__(69).GoogleTagManager;
	exports.pushGoogleTagManagerV2 = __webpack_require__(69).pushGoogleTagManager;
	exports.pushUserInformationGoogleTagManager = __webpack_require__(69).pushUserInformationGoogleTagManager;
	exports.getKeyWordByUrl = __webpack_require__(69).getKeyWordByUrl;
	
	exports.appendScript = __webpack_require__(127).appendScript;
	exports.appendStyleSheets = __webpack_require__(127).appendStyleSheets;
	
	exports.createNumArray = __webpack_require__(70).createNumArray;
	exports.isLeapYear = __webpack_require__(70).isLeapYear;
	exports.createMonthsArr = __webpack_require__(70).createMonthsArr;
	exports.createDaysArr = __webpack_require__(70).createDaysArr;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.typeofArray = typeofArray;
	exports.typeofObject = typeofObject;
	exports.typeofFunction = typeofFunction;
	exports.typeofString = typeofString;
	exports.typeofPrototype = typeofPrototype;
	function typeofArray(array) {
	  return typeofPrototype(array) === "[object Array]";
	}
	
	function typeofObject(object) {
	  return typeofPrototype(object) === "[object Object]";
	}
	
	function typeofFunction(fn) {
	  return typeofPrototype(fn) === "[object Function]";
	}
	
	function typeofString(string) {
	  return typeofPrototype(string) === "[object String]";
	}
	
	function typeofPrototype(parameter) {
	  return Object.prototype.toString.call(parameter);
	}

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GoogleTagManager = GoogleTagManager;
	exports.pushGoogleTagManager = pushGoogleTagManager;
	exports.pushUserInformationGoogleTagManager = pushUserInformationGoogleTagManager;
	exports.getKeyWordByUrl = getKeyWordByUrl;
	
	var _ = __webpack_require__(55);
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function GoogleTagManager(dataLayer) {
	  var _dataLayer, _dataLayer2;
	
	  window.dataLayer = (_dataLayer = dataLayer, _dataLayer2 = _toArray(_dataLayer), _dataLayer);
	  console.log(window.dataLayer);
	  (function (w, d, s, l, i) {
	    w[l] = w[l] || [];
	    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
	    var f = d.getElementsByTagName(s)[0],
	        j = d.createElement(s),
	        dl = l != 'dataLayer' ? '&l=' + l : '';
	    j.async = true;
	    j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
	    f.parentNode.insertBefore(j, f);
	  })(window, document, 'script', 'dataLayer', 'GTM-N57TLT');
	}
	
	function pushGoogleTagManager(parameter) {
	  if (window.dataLayer) {
	    window.dataLayer.push(parameter);
	  }
	}
	
	function pushUserInformationGoogleTagManager() {
	  var userInformation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var dataLayer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  if (dataLayer && (0, _.typeofArray)(dataLayer) && userInformation && (0, _.typeofObject)(userInformation)) {
	    dataLayer.push(userInformation);
	  }
	}
	
	function getKeyWordByUrl(key1, key2) {
	  if (window && window.location && window.location.href) {
	    var url = window.location.href,
	        key = null;
	    if (key1 && url.indexOf(key1) > 0) {
	      key = key1;
	    } else if (key2 && url.indexOf(key2) > 0) {
	      key = key2;
	    } else {
	      return '';
	    }
	    return decodeURIComponent(url.slice(url.indexOf(key)).replace(key, ''));
	  }
	  return null;
	}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createNumArray = createNumArray;
	exports.isLeapYear = isLeapYear;
	exports.createMonthsArr = createMonthsArr;
	exports.createDaysArr = createDaysArr;
	/**
	 * 创建数组.
	 * @param {Number} startNum 数组起始值
	 * @param {Number} length 数组长度
	 * @param {bool} 是否倒序
	 * @return {array}
	 */
	function createNumArray(startNum, length, isReverse) {
	  if (!length) return;
	  startNum = parseInt(startNum);
	  length = parseInt(length);
	
	  var arr = [];
	  for (var i = startNum; i < length + startNum; i++) {
	    arr.push(i);
	  }
	
	  if (isReverse) {
	    arr = arr.reverse();
	  }
	
	  return arr;
	}
	
	/**
	 * 判断年份是否为闰年.
	 * @param {Number} year 年份
	 * @return {bool} true：闰年；false：非闰年
	 */
	function isLeapYear(year) {
	  if (!year) return;
	  year = parseInt(year);
	  if (year % 4 !== 0) {
	    return false;
	  } else {
	    if (year % 100 === 0 && year % 400 !== 0) {
	      return false;
	    }
	    return true;
	  }
	}
	
	/**
	 * 创建月份数组.
	 * @return {array}
	 */
	function createMonthsArr() {
	  return createNumArray(1, 12);
	}
	
	/**
	 * 创建当月天数数组.
	 * @param {number} year 年份
	 * @param {number} month 月份
	 * @return {array}
	 */
	function createDaysArr(year, month) {
	  if (!month) return;
	  year = parseInt(year);
	  month = parseInt(month);
	
	  if (month > 12) return [];
	
	  if (month === 2) {
	    if (isLeapYear(year)) {
	      return createNumArray(1, 29);
	    }
	    return createNumArray(1, 28);
	  }
	
	  if ([1, 3, 5, 7, 8, 10, 12].indexOf(month) >= 0) {
	    return createNumArray(1, 31);
	  }
	
	  return createNumArray(1, 30);
	}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.exprEmail = exprEmail;
	exports.exprInt = exprInt;
	exports.arrayChangeSet = arrayChangeSet;
	exports.objectChangeArray = objectChangeArray;
	exports.UnionSet = UnionSet;
	exports.IntersectionSet = IntersectionSet;
	exports.DifferenceABSet = DifferenceABSet;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/*
	 * 增则匹配
	 * exprEmail 匹配邮箱
	 */
	function exprEmail(value) {
	    var expr = /^[a-zA-Z0-9]([a-zA-Z0-9]|_+[a-zA-Z0-9]|[a-zA-Z0-9]*\.[a-zA-Z0-9])+@\w+\.[a-zA-Z]{1,4}\.{0,1}[a-zA-Z]{0,4}$/;
	    if (value) {
	        if (expr.test(value)) {
	            return value;
	        } else {
	            return false;
	        }
	    } else {
	        return false;
	    }
	}
	
	/**
	 * exprInt 匹配数字
	 */
	function exprInt(value) {
	    var expr = /^[0-9]*$/;
	    if (value) {
	        if (expr.test(value)) {
	            return value;
	        } else {
	            return false;
	        }
	    } else {
	        return false;
	    }
	}
	
	// Array => Set
	function arrayChangeSet(set) {
	    return Array.from(set);
	}
	
	// object => array
	function objectChangeArray(object) {
	    var rel = [];
	    Object.keys(object).map(function (key) {
	        rel[key] = object[key];
	    });
	    return rel;
	}
	
	// 并集
	function UnionSet(a, b) {
	    var _unionSet = new Set([].concat(_toConsumableArray(new Set(a)), _toConsumableArray(new Set(b))));
	    return objectChangeArray(arrayChangeSet(_unionSet));
	}
	
	// 交集
	function IntersectionSet(a, b) {
	    var _intersectionSet = new Set([].concat(_toConsumableArray(new Set(a))).filter(function (x) {
	        return new Set(b).has(x);
	    }));
	    return arrayChangeSet(_intersectionSet);
	}
	
	// 差集
	function DifferenceABSet(a, b) {
	    var _differenceABSet = new Set([].concat(_toConsumableArray(new Set(a))).filter(function (x) {
	        return !new Set(b).has(x);
	    }));
	    return objectChangeArray(arrayChangeSet(_differenceABSet));
	}

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*
	 *  base64.js
	 *
	 *  Licensed under the BSD 3-Clause License.
	 *    http://opensource.org/licenses/BSD-3-Clause
	 *
	 *  References:
	 *    http://en.wikipedia.org/wiki/Base64
	 */
	;(function (global, factory) {
	     true
	        ? module.exports = factory(global)
	        : typeof define === 'function' && define.amd
	        ? define(factory) : factory(global)
	}((
	    typeof self !== 'undefined' ? self
	        : typeof window !== 'undefined' ? window
	        : typeof global !== 'undefined' ? global
	: this
	), function(global) {
	    'use strict';
	    // existing version for noConflict()
	    global = global || {};
	    var _Base64 = global.Base64;
	    var version = "2.6.4";
	    // constants
	    var b64chars
	        = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	    var b64tab = function(bin) {
	        var t = {};
	        for (var i = 0, l = bin.length; i < l; i++) t[bin.charAt(i)] = i;
	        return t;
	    }(b64chars);
	    var fromCharCode = String.fromCharCode;
	    // encoder stuff
	    var cb_utob = function(c) {
	        if (c.length < 2) {
	            var cc = c.charCodeAt(0);
	            return cc < 0x80 ? c
	                : cc < 0x800 ? (fromCharCode(0xc0 | (cc >>> 6))
	                                + fromCharCode(0x80 | (cc & 0x3f)))
	                : (fromCharCode(0xe0 | ((cc >>> 12) & 0x0f))
	                    + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
	                    + fromCharCode(0x80 | ( cc         & 0x3f)));
	        } else {
	            var cc = 0x10000
	                + (c.charCodeAt(0) - 0xD800) * 0x400
	                + (c.charCodeAt(1) - 0xDC00);
	            return (fromCharCode(0xf0 | ((cc >>> 18) & 0x07))
	                    + fromCharCode(0x80 | ((cc >>> 12) & 0x3f))
	                    + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
	                    + fromCharCode(0x80 | ( cc         & 0x3f)));
	        }
	    };
	    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
	    var utob = function(u) {
	        return u.replace(re_utob, cb_utob);
	    };
	    var cb_encode = function(ccc) {
	        var padlen = [0, 2, 1][ccc.length % 3],
	        ord = ccc.charCodeAt(0) << 16
	            | ((ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8)
	            | ((ccc.length > 2 ? ccc.charCodeAt(2) : 0)),
	        chars = [
	            b64chars.charAt( ord >>> 18),
	            b64chars.charAt((ord >>> 12) & 63),
	            padlen >= 2 ? '=' : b64chars.charAt((ord >>> 6) & 63),
	            padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
	        ];
	        return chars.join('');
	    };
	    var btoa = global.btoa && typeof global.btoa == 'function'
	        ? function(b){ return global.btoa(b) } : function(b) {
	        if (b.match(/[^\x00-\xFF]/)) throw new RangeError(
	            'The string contains invalid characters.'
	        );
	        return b.replace(/[\s\S]{1,3}/g, cb_encode);
	    };
	    var _encode = function(u) {
	        return btoa(utob(String(u)));
	    };
	    var mkUriSafe = function (b64) {
	        return b64.replace(/[+\/]/g, function(m0) {
	            return m0 == '+' ? '-' : '_';
	        }).replace(/=/g, '');
	    };
	    var encode = function(u, urisafe) {
	        return urisafe ? mkUriSafe(_encode(u)) : _encode(u);
	    };
	    var encodeURI = function(u) { return encode(u, true) };
	    var fromUint8Array;
	    if (global.Uint8Array) fromUint8Array = function(a, urisafe) {
	        // return btoa(fromCharCode.apply(null, a));
	        var b64 = '';
	        for (var i = 0, l = a.length; i < l; i += 3) {
	            var a0 = a[i], a1 = a[i+1], a2 = a[i+2];
	            var ord = a0 << 16 | a1 << 8 | a2;
	            b64 +=    b64chars.charAt( ord >>> 18)
	                +     b64chars.charAt((ord >>> 12) & 63)
	                + ( typeof a1 != 'undefined'
	                    ? b64chars.charAt((ord >>>  6) & 63) : '=')
	                + ( typeof a2 != 'undefined'
	                    ? b64chars.charAt( ord         & 63) : '=');
	        }
	        return urisafe ? mkUriSafe(b64) : b64;
	    };
	    // decoder stuff
	    var re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
	    var cb_btou = function(cccc) {
	        switch(cccc.length) {
	        case 4:
	            var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
	                |    ((0x3f & cccc.charCodeAt(1)) << 12)
	                |    ((0x3f & cccc.charCodeAt(2)) <<  6)
	                |     (0x3f & cccc.charCodeAt(3)),
	            offset = cp - 0x10000;
	            return (fromCharCode((offset  >>> 10) + 0xD800)
	                    + fromCharCode((offset & 0x3FF) + 0xDC00));
	        case 3:
	            return fromCharCode(
	                ((0x0f & cccc.charCodeAt(0)) << 12)
	                    | ((0x3f & cccc.charCodeAt(1)) << 6)
	                    |  (0x3f & cccc.charCodeAt(2))
	            );
	        default:
	            return  fromCharCode(
	                ((0x1f & cccc.charCodeAt(0)) << 6)
	                    |  (0x3f & cccc.charCodeAt(1))
	            );
	        }
	    };
	    var btou = function(b) {
	        return b.replace(re_btou, cb_btou);
	    };
	    var cb_decode = function(cccc) {
	        var len = cccc.length,
	        padlen = len % 4,
	        n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0)
	            | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0)
	            | (len > 2 ? b64tab[cccc.charAt(2)] <<  6 : 0)
	            | (len > 3 ? b64tab[cccc.charAt(3)]       : 0),
	        chars = [
	            fromCharCode( n >>> 16),
	            fromCharCode((n >>>  8) & 0xff),
	            fromCharCode( n         & 0xff)
	        ];
	        chars.length -= [0, 0, 2, 1][padlen];
	        return chars.join('');
	    };
	    var _atob = global.atob && typeof global.atob == 'function'
	        ? function(a){ return global.atob(a) } : function(a){
	        return a.replace(/\S{1,4}/g, cb_decode);
	    };
	    var atob = function(a) {
	        return _atob(String(a).replace(/[^A-Za-z0-9\+\/]/g, ''));
	    };
	    var _decode = function(a) { return btou(_atob(a)) };
	    var _fromURI = function(a) {
	        return String(a).replace(/[-_]/g, function(m0) {
	            return m0 == '-' ? '+' : '/'
	        }).replace(/[^A-Za-z0-9\+\/]/g, '');
	    };
	    var decode = function(a){
	        return _decode(_fromURI(a));
	    };
	    var toUint8Array;
	    if (global.Uint8Array) toUint8Array = function(a) {
	        return Uint8Array.from(atob(_fromURI(a)), function(c) {
	            return c.charCodeAt(0);
	        });
	    };
	    var noConflict = function() {
	        var Base64 = global.Base64;
	        global.Base64 = _Base64;
	        return Base64;
	    };
	    // export Base64
	    global.Base64 = {
	        VERSION: version,
	        atob: atob,
	        btoa: btoa,
	        fromBase64: decode,
	        toBase64: encode,
	        utob: utob,
	        encode: encode,
	        encodeURI: encodeURI,
	        btou: btou,
	        decode: decode,
	        noConflict: noConflict,
	        fromUint8Array: fromUint8Array,
	        toUint8Array: toUint8Array
	    };
	    // if ES5 is available, make Base64.extendString() available
	    if (typeof Object.defineProperty === 'function') {
	        var noEnum = function(v){
	            return {value:v,enumerable:false,writable:true,configurable:true};
	        };
	        global.Base64.extendString = function () {
	            Object.defineProperty(
	                String.prototype, 'fromBase64', noEnum(function () {
	                    return decode(this)
	                }));
	            Object.defineProperty(
	                String.prototype, 'toBase64', noEnum(function (urisafe) {
	                    return encode(this, urisafe)
	                }));
	            Object.defineProperty(
	                String.prototype, 'toBase64URI', noEnum(function () {
	                    return encode(this, true)
	                }));
	        };
	    }
	    //
	    // export Base64 to the namespace
	    //
	    if (global['Meteor']) { // Meteor.js
	        Base64 = global.Base64;
	    }
	    // module.exports and AMD are mutually exclusive.
	    // module.exports has precedence.
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports.Base64 = global.Base64;
	    }
	    else if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){ return global.Base64 }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    // that's it!
	    return {Base64: global.Base64}
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	function _extends() {
	  return (module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
	    for (var e = 1; e < arguments.length; e++) {
	      var t = arguments[e];
	      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
	    }
	    return n;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _extends.apply(null, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(190)["default"];
	function _getRequireWildcardCache(e) {
	  if ("function" != typeof WeakMap) return null;
	  var r = new WeakMap(),
	    t = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
	    return e ? t : r;
	  })(e);
	}
	function _interopRequireWildcard(e, r) {
	  if (!r && e && e.__esModule) return e;
	  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
	    "default": e
	  };
	  var t = _getRequireWildcardCache(r);
	  if (t && t.has(e)) return t.get(e);
	  var n = {
	      __proto__: null
	    },
	    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
	  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
	    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
	    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
	  }
	  return n["default"] = e, t && t.set(e, n), n;
	}
	module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(r, e) {
	  if (null == r) return {};
	  var t = {};
	  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
	    if (e.includes(n)) continue;
	    t[n] = r[n];
	  }
	  return t;
	}
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = warning;
	function warning(message) {
	    if (typeof console !== 'undefined' && typeof console.error === 'function') {
	        console.error(message);
	    }
	    try {
	        throw new Error(message);
	    } catch (e) {}
	}

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(501)();
	}


/***/ }),
/* 123 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(189);
	function _inheritsLoose(t, o) {
	  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _src = __webpack_require__(199);
	
	var _src2 = _interopRequireDefault(_src);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _src2.default)({ debug: true }); /*
	                                                        *
	                                                        * Producer -- Alvin
	                                                        * Time -- 2018/7/26
	                                                        * Function -- Entry for creating Google analytics wrapper
	                                                        *
	                                                        */

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _src = __webpack_require__(206);
	
	var _src2 = _interopRequireDefault(_src);
	
	var _autoCompleteEnhancer = __webpack_require__(197);
	
	var _autoCompleteEnhancer2 = _interopRequireDefault(_autoCompleteEnhancer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fields = __webpack_require__(491);
	var eventFieldsMap = __webpack_require__(490);
	
	exports.default = (0, _src2.default)(eventFieldsMap, fields, _autoCompleteEnhancer2.default, {
	    debug: true
	});

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.appendObject = appendObject;
	exports.verifyUrl = verifyUrl;
	exports.appendScript = appendScript;
	exports.appendStyleSheets = appendStyleSheets;
	function appendObject(document) {
	  var wrap = ['body', 'head'];
	  if (!document) {
	    return "head";
	  }
	
	  if (wrap.indexOf(document) === -1) {
	    document = 'head';
	  }
	
	  return document;
	}
	
	function verifyUrl(url, etc) {
	  if (!url) {
	    return false;
	  }
	
	  if (etc === "css" && !url.match(/^https?\:\/\/.+\.css$/)) {
	    return false;
	  }
	
	  if (etc === "js" && !url.match(/^https?\:\/\/.+\.js$/)) {
	    return false;
	  }
	
	  return url;
	}
	
	function appendScript(url, documentScript, callback) {
	
	  var _documentScript = appendObject(documentScript);
	  var _url = verifyUrl(url);
	
	  if (!_documentScript || !_url) {
	    return false;
	  }
	
	  var script = document.createElement("script");
	  script.type = "text/javascript";
	  script.text = _url;
	  document.getElementsByTagName(_documentScript)[0].appendChild(script);
	
	  if (callback) {
	    callback();
	  }
	}
	
	function appendStyleSheets(url, documentStyle) {
	
	  var _documentStyle = appendObject(documentStyle);
	  var _url = verifyUrl(url);
	
	  if (!_documentStyle || !_url) {
	    return false;
	  }
	
	  var link = document.createElement('link');
	  link.type = 'text/css';
	  link.rel = 'stylesheet';
	  link.href = _url;
	  document.getElementsByTagName(_documentStyle)[0].appendChild(link);
	}

/***/ }),
/* 128 */
56,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.urlGetParams = urlGetParams;
	exports.urlGetAllParams = urlGetAllParams;
	exports.urlGetParamsV0 = urlGetParamsV0;
	function urlGetParams(location, name) {
	
	    return urlGetAllParams(location)[name] || false;
	}
	
	function urlGetAllParams(location) {
	    var qs = location.search.length > 0 ? location.search.substring(1) : "",
	        args = {},
	        items = qs.length ? qs.split("&") : [],
	        item = null,
	        name = null,
	        value = null,
	        i = 0,
	        len = items.length;
	    for (i = 0; i < len; i++) {
	        item = items[i].split("=");
	        name = decodeURIComponent(item[0]);
	        value = decodeURIComponent(item[1]);
	        if (name.length && value) {
	            args[name] = value;
	        }
	    }
	    return args;
	}
	
	function urlGetParamsV0(name) {
	    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	    var r = window.location.search.substr(1).match(reg);
	    if (r != null) {
	        return r[2];
	    }
	    return null;
	}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(13);
	
	var _reactRouterRedux = __webpack_require__(179);
	
	var _Props = __webpack_require__(247);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _seo = __webpack_require__(277);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _user = __webpack_require__(278);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _global = __webpack_require__(257);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _addressPopup = __webpack_require__(248);
	
	var _addressPopup2 = _interopRequireDefault(_addressPopup);
	
	var _home = __webpack_require__(258);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _checkout = __webpack_require__(253);
	
	var _checkout2 = _interopRequireDefault(_checkout);
	
	var _productDetail = __webpack_require__(275);
	
	var _productDetail2 = _interopRequireDefault(_productDetail);
	
	var _myAccountOrder = __webpack_require__(267);
	
	var _myAccountOrder2 = _interopRequireDefault(_myAccountOrder);
	
	var _myAccountOnlineReturn = __webpack_require__(266);
	
	var _myAccountOnlineReturn2 = _interopRequireDefault(_myAccountOnlineReturn);
	
	var _myAccountQA = __webpack_require__(268);
	
	var _myAccountQA2 = _interopRequireDefault(_myAccountQA);
	
	var _locations = __webpack_require__(262);
	
	var _locations2 = _interopRequireDefault(_locations);
	
	var _category = __webpack_require__(251);
	
	var _category2 = _interopRequireDefault(_category);
	
	var _brandWall = __webpack_require__(250);
	
	var _brandWall2 = _interopRequireDefault(_brandWall);
	
	var _categoryOnelevel = __webpack_require__(252);
	
	var _categoryOnelevel2 = _interopRequireDefault(_categoryOnelevel);
	
	var _myAccountAddress = __webpack_require__(265);
	
	var _myAccountAddress2 = _interopRequireDefault(_myAccountAddress);
	
	var _CouponLists = __webpack_require__(246);
	
	var _CouponLists2 = _interopRequireDefault(_CouponLists);
	
	var _popup_address = __webpack_require__(272);
	
	var _popup_address2 = _interopRequireDefault(_popup_address);
	
	var _async = __webpack_require__(249);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _popup_component = __webpack_require__(274);
	
	var _popup_component2 = _interopRequireDefault(_popup_component);
	
	var _popup_alert = __webpack_require__(273);
	
	var _popup_alert2 = _interopRequireDefault(_popup_alert);
	
	var _popup_DeleteList = __webpack_require__(271);
	
	var _popup_DeleteList2 = _interopRequireDefault(_popup_DeleteList);
	
	var _data = __webpack_require__(254);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _imagesRender = __webpack_require__(259);
	
	var _imagesRender2 = _interopRequireDefault(_imagesRender);
	
	var _dataGA = __webpack_require__(255);
	
	var _dataGA2 = _interopRequireDefault(_dataGA);
	
	var _nicheFragrance = __webpack_require__(269);
	
	var _nicheFragrance2 = _interopRequireDefault(_nicheFragrance);
	
	var _loginMemberUI = __webpack_require__(263);
	
	var _loginMemberUI2 = _interopRequireDefault(_loginMemberUI);
	
	var _dependency = __webpack_require__(256);
	
	var _dependency2 = _interopRequireDefault(_dependency);
	
	var _purchaseRecord = __webpack_require__(276);
	
	var _purchaseRecord2 = _interopRequireDefault(_purchaseRecord);
	
	var _onLineReturn = __webpack_require__(270);
	
	var _onLineReturn2 = _interopRequireDefault(_onLineReturn);
	
	var _messageCenter = __webpack_require__(264);
	
	var _messageCenter2 = _interopRequireDefault(_messageCenter);
	
	var _invoiceList = __webpack_require__(260);
	
	var _invoiceList2 = _interopRequireDefault(_invoiceList);
	
	var _issueInvoice = __webpack_require__(261);
	
	var _issueInvoice2 = _interopRequireDefault(_issueInvoice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* 
	*   SEO对象 与独立文件区分开,并以26位字母先后顺序创建
	*/
	
	// import brandWallSync from './Props';
	var rootReducer = (0, _redux.combineReducers)({
	    homeConfig: _Props2.default,
	    homeConfig2: _Props2.default,
	    preHeat: _Props2.default,
	    bodyCare: _Props2.default,
	    brandGroup: _Props2.default,
	    breadData: _Props2.default,
	    // brandWallSync,
	    brandPageData: _Props2.default,
	    configuration: _Props2.default,
	    exclusiveSaleData: _Props2.default,
	    fragrance: _Props2.default,
	    functionData: _Props2.default,
	    hairCare: _Props2.default,
	    heroBanner: _Props2.default,
	    heroBannerGroup: _Props2.default,
	    heroBannerGroupAppointment: _Props2.default,
	    hotWordsData: _Props2.default,
	    hotSaleSetData: _Props2.default,
	    keywordData: _Props2.default,
	    SpecialOfferListData: _Props2.default,
	    purchaseRecord: _purchaseRecord2.default,
	    keywordDataV2: _Props2.default,
	    makeUp: _Props2.default,
	    manSkinCare: _Props2.default,
	    mainContent: _Props2.default,
	    navigationGroup: _Props2.default,
	    navigationBrandGroup: _Props2.default,
	    oneLevel: _Props2.default,
	    picks: _Props2.default,
	    picksImageAdd: _Props2.default,
	    productDetailImage: _Props2.default,
	    productDetailSKUPromotion: _Props2.default,
	    productInfo: _Props2.default,
	    rank: _Props2.default,
	    skinCare: _Props2.default,
	    food: _Props2.default,
	    searchPlaceHolder: _Props2.default,
	    searchHotWords: _Props2.default,
	    adHotBrand: _Props2.default,
	    tools: _Props2.default,
	    weeklySpecial: _Props2.default,
	
	    async: _async2.default,
	    addressPopup: _addressPopup2.default,
	    brandWall: _brandWall2.default,
	    checkout: _checkout2.default,
	    category: _category2.default,
	    categoryOnelevel: _categoryOnelevel2.default,
	    CouponLists: _CouponLists2.default,
	    data: _data2.default,
	    dataGA: _dataGA2.default,
	    global: _global2.default,
	    home: _home2.default,
	    imagesRender: _imagesRender2.default,
	    locations: _locations2.default,
	    loginMemberUI: _loginMemberUI2.default,
	    myAccountAddress: _myAccountAddress2.default,
	    myAccountOrder: _myAccountOrder2.default,
	    myAccountOnlineReturn: _myAccountOnlineReturn2.default,
	    myAccountQA: _myAccountQA2.default,
	    popup_component: _popup_component2.default,
	    popup_alert: _popup_alert2.default,
	    popup_DeleteList: _popup_DeleteList2.default,
	    popup_address: _popup_address2.default,
	    productDetail: _productDetail2.default,
	    seo: _seo2.default,
	    user: _user2.default,
	
	    nicheFragrance: _nicheFragrance2.default,
	    onLineReturn: _onLineReturn2.default,
	    dependency: _dependency2.default,
	    routing: _reactRouterRedux.routerReducer,
	    messageCenter: _messageCenter2.default,
	    invoiceList: _invoiceList2.default,
	    issueInvoice: _issueInvoice2.default
	});
	
	exports.default = rootReducer;

/***/ }),
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */
/***/ (function(module, exports) {

	module.exports = {"url":["^/myAccount$","^/myAccount/$","^/myOrderList","^/myOnlineReturn","^/order","^/payment","^/Research","^/myAccount/profile.html","^/myAccount/integralFlow","^/myAccount/myMemberCard","^/myAccount/changeHistory","^/myAccount/returnList","^/myAccount/returnDetails","^/myAccount/offlineOrderList","^/restMyCard","^/onlineReturn","^/myAccount/myMessage","^/myAccount/invoiceList","^/myAccount/issueInvoice"],"user":["/v3/shopcart/shopcart/addToCartForSingleProduct","/v1/shopcart/reminder/saveArrivalReminderUserData"]}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(499);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(493),
	    getPrototype = __webpack_require__(495),
	    isObjectLike = __webpack_require__(500);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(503);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(88);
	
	var _interopRequireDefault = __webpack_require__(30);
	
	exports.__esModule = true;
	exports.default = connectAdvanced;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(124));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(188));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(87));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(89));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(488));
	
	var _invariant = _interopRequireDefault(__webpack_require__(489));
	
	var _react = _interopRequireWildcard(__webpack_require__(5));
	
	var _reactIs = __webpack_require__(173);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(511));
	
	var _PropTypes = __webpack_require__(176);
	
	var prefixUnsafeLifecycleMethods = typeof _react.default.forwardRef !== "undefined";
	var hotReloadingVersion = 0;
	var dummyState = {};
	
	function noop() {}
	
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  var _contextTypes, _childContextTypes;
	
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      connectOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant.default)((0, _reactIs.isValidElementType)(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2.default)({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps
	
	      /* eslint-disable react/no-deprecated */
	
	    });
	
	    var Connect =
	    /*#__PURE__*/
	    function (_Component) {
	      (0, _inheritsLoose2.default)(Connect, _Component);
	
	      function Connect(props, context) {
	        var _this;
	
	        _this = _Component.call(this, props, context) || this;
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	        (0, _invariant.default)(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));
	
	        _this.initSelector();
	
	        _this.initSubscription();
	
	        return _this;
	      }
	
	      var _proto = Connect.prototype;
	
	      _proto.getChildContext = function getChildContext() {
	        var _ref3;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
	      };
	
	      _proto.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0
	
	
	      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      _proto.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant.default)(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
	        return this.wrappedInstance;
	      };
	
	      _proto.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      _proto.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      _proto.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription.default(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      _proto.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      _proto.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      _proto.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	
	        var withExtras = (0, _extends2.default)({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      _proto.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    if (prefixUnsafeLifecycleMethods) {
	      // Use UNSAFE_ event name where supported
	      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
	      delete Connect.prototype.componentWillReceiveProps;
	    }
	    /* eslint-enable react/no-deprecated */
	
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      // Use UNSAFE_ event name where supported
	      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';
	
	      Connect.prototype[eventName] = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	
	          this.initSubscription();
	
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(30);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(177));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject.default)(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(30);
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(122));
	
	var subscriptionShape = _propTypes.default.shape({
	  trySubscribe: _propTypes.default.func.isRequired,
	  tryUnsubscribe: _propTypes.default.func.isRequired,
	  notifyNestedSubs: _propTypes.default.func.isRequired,
	  isSubscribed: _propTypes.default.func.isRequired
	});
	
	exports.subscriptionShape = subscriptionShape;
	
	var storeShape = _propTypes.default.shape({
	  subscribe: _propTypes.default.func.isRequired,
	  dispatch: _propTypes.default.func.isRequired,
	  getState: _propTypes.default.func.isRequired
	});
	
	exports.storeShape = storeShape;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(30);
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(512));
	
	var _warning = _interopRequireDefault(__webpack_require__(123));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject.default)(value)) {
	    (0, _warning.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(180);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(178);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(515);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(514);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ }),
/* 181 */,
/* 182 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/** A function that accepts a potential "extra argument" value to be injected later,
	 * and returns an instance of the thunk middleware that uses that value
	 */
	function createThunkMiddleware(extraArgument) {
	  // Standard Redux middleware definition pattern:
	  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
	  var middleware = function middleware(_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
	        // If this "action" is really a function, call it and return the result.
	        if (typeof action === 'function') {
	          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
	          return action(dispatch, getState, extraArgument);
	        } // Otherwise, pass the action down the middleware chain as usual
	
	
	        return next(action);
	      };
	    };
	  };
	
	  return middleware;
	}
	
	var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
	// with whatever "extra arg" they want to inject into their thunks
	
	thunk.withExtraArgument = createThunkMiddleware;
	var _default = thunk;
	exports.default = _default;

/***/ }),
/* 183 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(172);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(523);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 186 */,
/* 187 */,
/* 188 */
/***/ (function(module, exports) {

	function _assertThisInitialized(e) {
	  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  return e;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	function _setPrototypeOf(t, e) {
	  return (module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
	    return t.__proto__ = e, t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _setPrototypeOf(t, e);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	function _typeof(o) {
	  "@babel/helpers - typeof";
	
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.router_matcbh = router_matcbh;
	exports.router_matcbh_v2 = router_matcbh_v2;
	exports.router_matcbh_v3 = router_matcbh_v3;
	function router_matcbh(pathname) {
	
	    if (pathname.match(/^\/$/)) return "home";
	    if (pathname.match(/^\/campaign/)) return "campaign";
	
	    if (pathname.match(/^\/brand\//)) return "brand";
	    if (pathname.match(/^\/brand\/$/)) return "brand";
	
	    if (pathname.match(/^\/hot/)) return "hot";
	    if (pathname.match(/^\/search/)) return "search";
	
	    if (pathname.match(/^\/product/)) return "product";
	
	    if (pathname.match(/^\/category/)) return "category";
	
	    return "other";
	}
	function router_matcbh_v2(pathname) {
	
	    if (pathname.match(/^\/$/)) return "home";
	    if (pathname.match(/^\/exclusive/)) return "List";
	    if (pathname.match(/^\/function/)) return "List";
	    if (pathname.match(/^\/gift_set/)) return "List";
	
	    if (pathname.match(/^\/campaign/)) return "Campaign";
	    if (pathname.match(/^\/weeklyspecials/)) return "Campaign";
	    if (pathname.match(/^\/brand\//)) return "List";
	    if (pathname.match(/^\/brand\/story$/)) return "Campaign";
	
	    if (pathname.match(/^\/hot/)) return "Search";
	    if (pathname.match(/^\/search/)) return "Search";
	    if (pathname.match(/^\/myAccount/)) return "Function";
	
	    if (pathname.match(/^\/product/)) return "product";
	
	    if (pathname.match(/^\/category/)) return "List";
	
	    return "other";
	}
	function router_matcbh_v3(url) {
	    var a = url.indexOf('/');
	    var b = url.indexOf('?');
	    var pathname = url.slice(a, b);
	    if (pathname.search(/\/exclusive/) > 0) return "List";
	    if (pathname.search(/\/function/) > 0) return "List";
	    if (pathname.search(/\/gift_set/) > 0) return "List";
	
	    if (pathname.search(/\/campaign/) > 0) return "Campaign";
	    if (pathname.search(/\/weeklyspecials/) > 0) return "Campaign";
	    if (pathname.search(/\/rank/) > 0) return "Campaign";
	
	    if (pathname.search(/\/brand\//) > 0) return "List";
	    if (pathname.search(/\/brand\/story$/) > 0) return "Campaign";
	
	    if (pathname.search(/\/hot/) > 0) return "Search";
	    if (pathname.search(/\/search/) > 0) return "Search";
	
	    if (pathname.search(/\/product/) > 0) return "product";
	
	    if (pathname.search(/\/category/) > 0) return "List";
	    if (pathname.search(/\/myAccount/) > 0) return "Function";
	
	    return "other";
	}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sensor_router_match = sensor_router_match;
	exports.sensor_router_type = sensor_router_type;
	
	var _router = __webpack_require__(193);
	
	var router = _interopRequireWildcard(_router);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function sensor_router_match(pathname) {
	    if (!pathname) return '';
	    var _router_match = router.router_matcbh(pathname);
	
	    // business logic
	    if (_router_match == "hot") _router_match = "search";
	    if (_router_match == "product") _router_match = "pdp";
	
	    // add suffix
	    if (_router_match == "search" && _router_match == "brand" && _router_match == "category") _router_match += "-search";
	    return _router_match;
	}
	
	function sensor_router_type(pathname) {
	    if (!pathname) return '';
	    var _router_match = router.router_matcbh_v2(pathname) || 'other';
	    if (_router_match == 'other') _router_match = router.router_matcbh_v3(pathname) || 'other';
	    if (_router_match == "List") _router_match = "List-page";
	    if (_router_match == "Campaign") _router_match = "Campaign-page";
	    if (_router_match == "Search") _router_match = "Search-page";
	    if (_router_match == "product") _router_match = "Product-detail-page";
	    if (_router_match == "Function") _router_match = "Function-page";
	
	    return _router_match;
	}

/***/ }),
/* 195 */,
/* 196 */,
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _sensorMap = __webpack_require__(194);
	
	var sensorMap = _interopRequireWildcard(_sensorMap);
	
	var _url2 = __webpack_require__(131);
	
	var _url = _interopRequireWildcard(_url2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function get_current_url(current_url) {
	    if (current_url) return current_url;
	
	    return window.location.href || '';
	}
	
	function get_current_page_type(current_page_type) {
	    if (current_page_type) return current_page_type;
	
	    var path_name = window.location.pathname || '';
	    return sensorMap.sensor_router_type(path_name);
	}
	
	function get_previous_url(previous_url) {
	    if (previous_url) return previous_url;
	
	    return typeof document !== 'undefined' && typeof document.referrer === 'string' ? document.referrer : '';
	}
	
	// function get_previous_url() {
	//      return window.location.search.replace(/\?historyLocation=/, window.location.origin + "/") || '';
	// }
	
	function get_previous_page_type_new(previous_page_type_new) {
	    if (previous_page_type_new) return previous_page_type_new;
	
	    var path_name = get_previous_url() || '';
	    return sensorMap.sensor_router_type(path_name);
	}
	
	// function get_previous_page_type_new() {
	//     let path_name = window.location.search.replace(/\?historyLocation=/, window.location.origin + "/") || '';
	//      return sensor.sensor_router_match(path_name);
	// }
	
	function get_sign_up_method(sign_up_method) {
	    if (sign_up_method) return sign_up_method;
	
	    if (_url.urlGetParams(window.location, "state") == "QQ") return "qq";
	    if (_url.urlGetParams(window.location, "state") == "WEIBO") return "weibo";
	    if (_url.urlGetParams(window.location, "state") == "WECHAT") return "wechat";
	
	    return '';
	}
	
	function get_campaign_code(campaign_code) {
	    var arr = campaign_code && campaign_code.split(/intcmp=|kwrec=|prodlink=/) || [];
	    return arr.length > 1 ? arr[arr.length - 1] : null;
	}
	function get_banner_current_page_type() {}
	
	function get_os() {
	    var os = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    if (os) return os;
	    return window.navigator.userAgent.indexOf("Windows") > 0 ? 'windows' : 'mac';
	}
	function get_environment_type() {
	    var web = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'web';
	
	    var type = 'other';
	    if (window.location.href.indexOf('www.sephora.cn') > 0) type = 'prod';
	    if (window.location.href.indexOf('stage.sephora.cn') > 0) type = 'stage';
	    if (window.location.href.indexOf('test.sephora.cn') > 0) type = 'test';
	
	    return type;
	}
	function get_banner_to_page_type(url) {
	    if (!url) return 'Other';
	    if (url.search('/') < 0) return url;
	    return sensorMap.sensor_router_type(url);
	}
	exports.default = {
	    get_current_url: get_current_url,
	    get_current_page_type: get_current_page_type,
	    get_previous_url: get_previous_url,
	    get_previous_page_type_new: get_previous_page_type_new,
	    get_sign_up_method: get_sign_up_method,
	    get_campaign_code: get_campaign_code,
	    get_banner_current_page_type: get_banner_current_page_type,
	    get_os: get_os,
	    get_environment_type: get_environment_type,
	    get_banner_to_page_type: get_banner_to_page_type
	};

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.dateSortUtil = dateSortUtil;
	/*
	 *
	 * Producer -- Rowe
	 * Time -- 2018/2/7
	 * Function -- 业务 数据三列最优排序
	 *
	 */
	
	function dateSortUtil(model) {
	    var f = model;
	    var a = [];
	    f.results.subCategoryList.map(function (d, i) {
	        if (d.content === "") {
	            return;
	        }
	        a.push({
	            c: d.content,
	            r: d.childCategoryList
	        });
	    });
	    var c = Math.ceil(a.reduce(function (prev, cur) {
	        return (prev && prev.r ? prev.r.length || 0 : prev) + (cur && cur.r ? cur.r.length : 0);
	    }) / 3);
	
	    var abs, f, s, t, fst, no;
	    fst = [];
	
	    for (var m = 1; m <= a.length; m++) {
	        no = a.length - m;
	        for (var n = 1; n <= no; n++) {
	            if (m == 0 || n == 0 || no - n == 0) {
	                break;
	            }
	            f = 0, s = 0, t = 0;
	            for (var i in a.slice(0, m)) {
	                f += a.slice(0, m)[i].r.length;
	            }
	            for (var i in a.slice(m, n + m)) {
	                s += a.slice(m, n + m)[i].r.length;
	            }
	            for (var i in a.slice(m + n, m + no)) {
	                t += a.slice(m + n, m + no)[i].r.length;
	            }
	            /* console.log(a.slice(0, m))
	            console.log(a.slice(m, n + m))
	            console.log(a.slice(m + n, m + no)) */
	            Math.abs(c - f) + Math.abs(c - s) + Math.abs(c - t);
	            fst.push({
	                "abs": Math.abs(c - f) + Math.abs(c - s) + Math.abs(c - t),
	                res: [a.slice(0, m), a.slice(m, n + m), a.slice(m + n, m + no)]
	            });
	        }
	    }
	
	    var t = fst.sort(function (a, b) {
	        return a.abs - b.abs;
	    })[0];
	    var rule = [];
	    rule[0] = t.res[0].length;
	    rule[1] = t.res[1].length;
	    rule[2] = t.res[2].length;
	    return rule;
	}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * Producer -- Alvin
	                                                                                                                                                                                                                                                                               * Time -- 2018/7/26
	                                                                                                                                                                                                                                                                               * Function -- Entry for creating Google analytics wrapper
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               */
	
	
	exports.default = GoogleAnalyticsWrapper;
	
	var _warning = __webpack_require__(201);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _DEV__ = __webpack_require__(200);
	
	var _DEV__2 = _interopRequireDefault(_DEV__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Avoiding repeating of event.
	 */
	function dereplication(arr, eventKey, eventValue) {
	    return arr.some(function (obj) {
	        if (obj[eventKey] == eventValue) return true;
	        return false;
	    });
	}
	
	function logCreator(debug) {
	    return function (data, status, msg) {
	        if (_DEV__2.default && debug && typeof console !== 'undefined' && typeof console.log === 'function' && typeof console.group === 'function') {
	            console.group('GA event \'' + data.event + '\'');
	            console.log('%c event name: ', 'background:#aaa;color:#bada55', String(data.event));
	            console.log('%c event data: ', 'background:#aaa;color:#bada55', data);
	            console.log('%c is event success: ', 'background:#aaa;color:#bada55', status);
	            console.log('%c message: ', 'background:#aaa;color:#bada55', msg);
	            console.groupEnd();
	        }
	    };
	}
	
	/**
	 * Creates a GoogleAnalyticsWrapper.
	 *
	 * @param {Object} [options] The options to set config of the GoogleAnalyticsWrapper,
	 * E.g, set debug as true if in development environment.
	 * 
	 * @returns {initial} The initial function is used to initialize dataLayer in window, 
	 * setting and pushing pageView data when initialized, memorizing initialed status for the 
	 * exposed function push.
	 * 
	 * @returns {push} The push function will check if the dataLayer is initialized for every 
	 * implementation, avoiding block the main business flow.If the parameter contains a key of
	 * eventCallback, the function will be forced to trigger if the google analytics not implement 
	 * the eventCallback in a period of time.
	 * 
	 */
	function GoogleAnalyticsWrapper() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        debug = _ref.debug;
	
	    var _statusGTM = 'notInitialized';
	    var log = logCreator(debug, _DEV__2.default);
	    return {
	        initial: function initial() {},
	        push: function push() {},
	        pushV2: function pushV2() {},
	        add: function add() {}
	    };
	    return {
	        initial: function initial() {
	            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	                pageView = _ref2.pageView,
	                callback = _ref2.callback;
	
	            function setup(w, d, s, l, i) {
	                w[l] = w[l] || [];
	                w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
	                var f = d.getElementsByTagName(s)[0],
	                    j = d.createElement(s),
	                    dl = l != 'dataLayer' ? '&l=' + l : '';
	                j.async = true;
	                j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
	                f.parentNode.insertBefore(j, f);
	                j.onerror = function () {
	                    _statusGTM = 'failed';
	                };
	                j.onload = function () {
	                    if (Object.hasOwnProperty.call(window.dataLayer, 'push')) {
	                        _statusGTM = 'completed';
	                        callback({ results: "Completed" });
	                    } else {
	                        _statusGTM = 'failed';
	                    }
	                };
	            }
	            if (typeof window !== 'undefined') {
	                window.dataLayer = pageView instanceof Object ? [pageView] : [];
	                _statusGTM = 'initialized';
	                setup(window, document, 'script', 'dataLayer', 'GTM-N57TLT');
	                setup(window, document, 'script', 'dataLayerV2', 'GTM-PS7PMCK');
	            }
	        },
	        push: function push(data) {
	            var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                onlyOnce = _ref3.onlyOnce,
	                _ref3$timeout = _ref3.timeout,
	                timeout = _ref3$timeout === undefined ? 500 : _ref3$timeout;
	
	            if (data instanceof Object) {
	                var event = data.event,
	                    eventCallback = data.eventCallback;
	
	
	                var triggeredOnce = false;
	                var eventCallbackEnhancer = null;
	                if (typeof eventCallback === 'function') {
	                    eventCallbackEnhancer = function eventCallbackEnhancer() {
	                        if (!triggeredOnce) {
	                            triggeredOnce = true;
	                            eventCallback();
	                        }
	                    };
	                    data.eventCallback = eventCallbackEnhancer;
	                    setTimeout(eventCallbackEnhancer, timeout);
	                }
	
	                if (window.dataLayer instanceof Array && (_statusGTM === 'completed' || _statusGTM === 'initialized' && typeof eventCallbackEnhancer !== 'function')) {
	                    if (onlyOnce && dereplication(window.dataLayer, 'event', event)) {
	                        log(data, false, 'The event \'' + String(event) + '\' is setted to push only once and already exsist in dataLayer.');
	                        return false;
	                    }
	                    log(data, true, 'success');
	                    window.dataLayer.push(data);
	                } else {
	                    log(data, false, 'The event ' + String(event) + ' was failed because ' + ('the status of google tag manager is \'' + _statusGTM + '\'.'));
	                    if (typeof eventCallbackEnhancer === 'function') eventCallbackEnhancer();
	                }
	            } else if (_DEV__2.default) {
	                (0, _warning2.default)('google tag manager warn: type of event data must be \'object\' but got ' + (typeof data === 'undefined' ? 'undefined' : _typeof(data)) + '.');
	            }
	        },
	        add: function add(data) {
	            var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                onlyOnce = _ref4.onlyOnce,
	                _ref4$timeout = _ref4.timeout,
	                timeout = _ref4$timeout === undefined ? 500 : _ref4$timeout;
	
	            if (data instanceof Object) {
	                var event = data.event,
	                    eventCallback = data.eventCallback;
	
	
	                var triggeredOnce = false;
	                var eventCallbackEnhancer = null;
	                if (typeof eventCallback === 'function') {
	                    eventCallbackEnhancer = function eventCallbackEnhancer() {
	                        if (!triggeredOnce) {
	                            triggeredOnce = true;
	                            eventCallback();
	                        }
	                    };
	                    data.eventCallback = eventCallbackEnhancer;
	                    setTimeout(eventCallbackEnhancer, timeout);
	                }
	
	                if (window.dataLayer instanceof Array && (_statusGTM === 'completed' || _statusGTM === 'initialized' && typeof eventCallbackEnhancer !== 'function')) {
	                    if (onlyOnce && dereplication(window.dataLayer, 'event', event)) {
	                        log(data, false, 'The event \'' + String(event) + '\' is setted to push only once and already exsist in dataLayer.');
	                        return false;
	                    }
	                    log(data, true, 'success');
	                    window.dataLayerV2.push(data);
	                } else {
	                    log(data, false, 'The event ' + String(event) + ' was failed because ' + ('the status of google tag manager is \'' + _statusGTM + '\'.'));
	                    if (typeof eventCallbackEnhancer === 'function') eventCallbackEnhancer();
	                }
	            } else if (_DEV__2.default) {
	                (0, _warning2.default)('google tag manager warn: type of event data must be \'object\' but got ' + (typeof data === 'undefined' ? 'undefined' : _typeof(data)) + '.');
	            }
	        }
	    };
	}

/***/ }),
/* 200 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function ifDev() {
	  return !(typeof window === 'undefined' || typeof window !== 'undefined' && window.location instanceof Object && ['www.sephora.cn', 'm.sephora.cn'].includes(window.location.host));
	}();

/***/ }),
/* 201 */
90,
/* 202 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.FixNum = FixNum;
	function FixNum(value) {
	  if (value == undefined || Number(value) == NaN || (typeof value === "undefined" ? "undefined" : _typeof(value)) == "object") return null;
	  if (Number(value) || Number(value) == 0) return Number(value).toFixed(2);
	}

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isClient = isClient;
	function isClient() {
	  return typeof window !== 'undefined' && window.document;
	}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.navigationSort = navigationSort;
	
	var _typeofUtil = __webpack_require__(56);
	
	/*
	 * From Ajax, To Redux
	 * Function -- 业务 数据三列最优排序 Mic
	 */
	function navigationSort(results) {
	  var respEmpty = verifyEmpty(results);
	  var respSort = lineCount(JSON.parse(JSON.stringify(respEmpty)));
	  return respSort.res;
	}
	/**
	 * @function verifyEmpty - organize data
	 * @param {Object} request
	 * @return {Array} response - [ {content:'洗发产品',list: [{id: 230099, content: "洗发水/液" },{id: 230099, content: "洗发水/液" }] }, {content:'头皮护理',list: [{id: 230099, content: "洗发水/液" }] } ]
	 */
	function verifyEmpty(request) {
	  var response = [];
	  if (request.results) {
	    request.results.subCategoryList.map(function (data, index) {
	      if (data.content === "") return;
	      response.push({ content: data.content, list: data.childCategoryList });
	    });
	  }
	  return response;
	}
	
	/**
	 * @function sublineCount - group every single list
	 * @param {*} request
	 * @return {Array} line - [ [], [], [] ]  || [ [], [] ]
	 */
	function sublineCount(request) {
	  var list = request.list;
	  var size = 13;
	  var line = [];
	  var templine = 0;
	  var lineindex = 0;
	  for (var i = 0; i < list.length; i++) {
	    templine += list[i].content.length + 1;
	    if ((0, _typeofUtil.typeofArray)(line[lineindex]) === false) line[lineindex] = [];
	    if (templine <= 14) {
	      line[lineindex].push(list[i]);
	    } else {
	      lineindex += 1;
	      templine = 0;
	      i -= 1;
	    }
	  }
	  return line;
	}
	
	/**
	 * @function lineCount
	 * @param {*} request
	 */
	// request = [ {content:'洗发产品',list: [{id: 230099, content: "洗发水/液" },{id: 230099, content: "洗发水/液" }] }, {content:'头皮护理',list: [{id: 230099, content: "洗发水/液" }] } ]
	function lineCount(request) {
	  var tfinishresult = [];
	  var tfinishmath = 0;
	  var tfinishtotal = [];
	  var tm, tno, tn, tf, ts, tt;
	  var tfinishmathtemp = 0;
	
	  // to push grouped list to an array    tfinishresult = [ { content:'blabla', list: [ [{id: 230099, content: "洗发水/液" },{id: 230099, content: "洗发水/液" }], [{id: 230099, content: "洗发水/液" }], [{id: 230099, content: "洗发水/液" }] ] } ]
	  for (var i = 0; i < request.length; i++) {
	    tfinishresult.push({ content: request[i].content, list: sublineCount(request[i]) });
	  }
	  // tfinishmathtemp -- to record total tfinishresult.list length
	  //   debugger;
	  for (var i in tfinishresult) {
	    if (tfinishresult[i] && tfinishresult[i].list) tfinishmathtemp += tfinishresult[i].list.length;
	  }
	  // to get middle number
	  tfinishmath = tfinishmathtemp / 3;
	
	  // to get all possibilities of combination
	  for (tm = 1; tm <= tfinishresult.length; tm++) {
	    tno = tfinishresult.length - tm;
	    for (tn = 1; tn <= tno; tn++) {
	      // if (tm == 0 || tn == 0 || tno - tn == 0) break;
	      tf = 0, ts = 0, tt = 0;
	      for (var i in tfinishresult.slice(0, tm)) {
	        if (tfinishresult.slice(0, tm)[i] && tfinishresult.slice(0, tm)[i].list) tf += tfinishresult.slice(0, tm)[i].list.length + 1;
	      } // 从 0 开始
	      for (var i in tfinishresult.slice(tm, tn + tm)) {
	        if (tfinishresult.slice(tm, tn + tm)[i] && tfinishresult.slice(tm, tn + tm)[i].list) ts += tfinishresult.slice(tm, tn + tm)[i].list.length + 1;
	      } // 从 1 开始
	      for (var i in tfinishresult.slice(tm + tn, tm + tno)) {
	        if (tfinishresult.slice(tm + tn, tm + tno)[i] && tfinishresult.slice(tm + tn, tm + tno)[i].list) tt += tfinishresult.slice(tm + tn, tm + tno)[i].list.length + 1;
	      } // 从 2 开始
	      tfinishtotal.push({
	        abs: Math.abs(tfinishmath - tf) + Math.abs(tfinishmath - ts) + Math.abs(tfinishmath - tt),
	        res: [tfinishresult.slice(0, tm), tfinishresult.slice(tm, tn + tm), tfinishresult.slice(tm + tn, tm + tno)]
	      });
	    }
	  }
	  return tfinishtotal.sort(function (a, b) {
	    return a.abs - b.abs;
	  })[0];
	}

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.sensorCheck = sensorCheck;
	exports.sensorGoCreator = sensorGoCreator;
	function sensorCheck() {
	  return typeof window !== 'undefined' && (typeof sensorsDataAnalytic201505 === "undefined" ? "undefined" : _typeof(sensorsDataAnalytic201505)) === "object" && typeof sensorsDataAnalytic201505.track === "function";
	}
	
	function sensorGoCreator() {
	  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'track';
	
	  if (sensorCheck()) return window.sa[key];
	  return null;
	}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * Producer -- Alvin
	                                                                                                                                                                                                                                                                               * Time -- 2018/7/6
	                                                                                                                                                                                                                                                                               * Function -- Entry for creating wrappered sensor
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               */
	
	
	exports.default = initialize;
	
	var _sensorFieldsIntegrationCreator = __webpack_require__(207);
	
	var _sensorFieldsIntegrationCreator2 = _interopRequireDefault(_sensorFieldsIntegrationCreator);
	
	var _globalSensorHandler = __webpack_require__(205);
	
	var _typeofUtil = __webpack_require__(128);
	
	var _warning = __webpack_require__(90);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function paramsCheck(param, paramName, type) {
	    var typeCheck = {
	        object: _typeofUtil.typeofObject,
	        array: _typeofUtil.typeofArray
	    };
	    if (!typeCheck[type](param)) {
	        (0, _warning2.default)('Sensor Warning: Argument \'' + paramName + '\' required to function \'WrappedSensor\' must be \'' + type + '\' ' + ('but got a ' + (typeof param === 'undefined' ? 'undefined' : _typeof(param))));
	        return false;
	    }
	    return true;
	}
	
	function initialize(eventFieldsMap, fields) {
	    var autoCompleteEnhancer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    if (!(paramsCheck(eventFieldsMap, 'eventFieldsMap', 'object') && paramsCheck(fields, 'fields', 'array') && paramsCheck(autoCompleteEnhancer, 'autoCompleteEnhancer', 'object'))) return {};
	
	    var _sensorFieldsIntegrat = (0, _sensorFieldsIntegrationCreator2.default)({ eventFieldsMap: eventFieldsMap, fields: fields, autoCompleteEnhancer: autoCompleteEnhancer, options: options }),
	        sensorIntegrator = _sensorFieldsIntegrat.sensorIntegrator,
	        SensorIntegration = _sensorFieldsIntegrat.SensorIntegration,
	        fieldsConvertion = _sensorFieldsIntegrat.fieldsConvertion;
	
	    var _sensorStatus = 'notInitialized';
	    return {
	        Integration: SensorIntegration,
	        integrator: sensorIntegrator,
	        go: function go(eventKey, value, sensorKey) {
	            var combinedValue = sensorIntegrator(eventKey, value);
	            if (!combinedValue) return;
	            var sensorGo = (0, _globalSensorHandler.sensorGoCreator)(sensorKey);
	            if (typeof sensorGo === 'function') {
	                sensorGo(eventKey, combinedValue);
	            }
	        },
	        test: function test() {
	            Object.keys(eventFieldsMap).forEach(function (event) {
	                sensorIntegrator(event, {});
	            });
	        },
	        push: function push(sensorKey, value, type) {
	            var sensorGo = (0, _globalSensorHandler.sensorGoCreator)(sensorKey);
	            var combinedValue = value && fieldsConvertion(value, type);
	            if (typeof sensorGo === 'function') {
	                sensorGo(combinedValue);
	            }
	        },
	        other: function other(sensorKey, value) {
	            var sensorGo = (0, _globalSensorHandler.sensorGoCreator)(sensorKey);
	            if (typeof sensorGo === 'function') {
	                sensorGo(value);
	            }
	        },
	        initial: function initial() {
	            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            if (_sensorStatus === 'notInitialized') {
	
	                var sensorGo = (0, _globalSensorHandler.sensorGoCreator)('registerPage');
	                if (typeof sensorGo !== 'function') return;
	
	                var combinedValue = sensorIntegrator('registerPage', value);
	
	                if (!combinedValue) return;
	
	                sensorGo(combinedValue);
	                // sensorGoCreator 
	                // sensorGoCreator('quick')('autoTrack')
	                sensorGo && (_sensorStatus = 'initialized');
	            }
	        }
	    };
	}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = initialize;
	
	var _typeConvertion = __webpack_require__(208);
	
	var _typeofUtil = __webpack_require__(128);
	
	var _warning = __webpack_require__(90);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getEventKeys(eventFieldsMap) {
	    return Object.keys(eventFieldsMap);
	}
	
	function filterfields(eventFieldsMapArray, fields) {
	    return fields.filter(function (field) {
	        if (!field.fieldKey) (0, _warning2.default)('Sensor Warning: Can not find \'filedKey\' in \'fields\'');
	        return eventFieldsMapArray.indexOf(field.fieldKey) > -1;
	    });
	}
	
	function fieldsConvertion(value) {
	    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
	
	    return (0, _typeConvertion.basicTypeConvertion)(type, value);
	}
	
	/**
	 * Pass the origin value to integrator function to create final value.
	 * Automatic complete enhancer will be executed here.
	 */
	function combineFilteredParams(originSensorValue, filteredfields, autoCompleteEnhancer) {
	    var combinedValue = {};
	    filteredfields.forEach(function (_ref) {
	        var fieldKey = _ref.fieldKey,
	            type = _ref.type,
	            autoComplete = _ref.autoComplete;
	
	        var value = originSensorValue[fieldKey];
	        var enhancer = autoCompleteEnhancer[autoComplete];
	        if (autoComplete) {
	            try {
	                value = enhancer ? enhancer(value) : autoComplete;
	            } catch (e) {
	                (0, _warning2.default)('Sensor Warning: Can not excute enhancer \'' + autoComplete + '\' in \'combineFilteredParams\'. ' + ('Detailed error: ' + e));
	            }
	        }
	        combinedValue[fieldKey] = (0, _typeConvertion.basicTypeConvertion)(type, value);
	    });
	    return combinedValue;
	}
	
	/**
	 * Create sensorIntegrator
	 */
	function sensorIntegratorFactory(key, filteredfields, autoCompleteEnhancer) {
	    if (!(0, _typeofUtil.typeofString)(key)) {
	        (0, _warning2.default)('Sensor Warning: Argument \'key\' required to function \'sensorEventFactory\' must be string');
	        return function () {};
	    }
	    return function () {
	        var originSensorValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return combineFilteredParams(originSensorValue, filteredfields, autoCompleteEnhancer);
	    };
	}
	
	/**
	 * Cycle and filter the eventFieldsMap of specify event and
	 * register the integrator function to SensorIntegration object.
	 */
	function sensorIntegrationCreator(eventFieldsMap, fields, autoCompleteEnhancer) {
	    var SensorIntegration = {};
	    getEventKeys(eventFieldsMap).forEach(function (eventKey) {
	        var filteredfields = filterfields(eventFieldsMap[eventKey], fields);
	        SensorIntegration[eventKey] = sensorIntegratorFactory(eventKey, filteredfields, autoCompleteEnhancer);
	    });
	    return SensorIntegration;
	}
	
	/**
	 * Creates a sensor fields store that integrate sensor fields.
	 *
	 * @param {Object} [eventFieldsMap] All sensor event and fields for specify sensor 
	 * event should be configured here with a format of key and value.
	 *
	 * @param {Array} [fields] All sensor fields with its type and automatic complete 
	 * function key as a default value enhancer need to be configured here
	 *
	 * @param {Object} [autoCompleteEnhancer] Sensor field aotumatic complete function container
	 * Object
	 * 
	 * @returns {Object} sensorIntegrator, SensorIntegration
	 */
	function initialize(_ref2) {
	    var _ref2$eventFieldsMap = _ref2.eventFieldsMap,
	        eventFieldsMap = _ref2$eventFieldsMap === undefined ? eventFieldsMap : _ref2$eventFieldsMap,
	        _ref2$fields = _ref2.fields,
	        fields = _ref2$fields === undefined ? fields : _ref2$fields,
	        _ref2$autoCompleteEnh = _ref2.autoCompleteEnhancer,
	        autoCompleteEnhancer = _ref2$autoCompleteEnh === undefined ? {} : _ref2$autoCompleteEnh,
	        options = _ref2.options;
	    var debug = options.debug;
	
	
	    var SensorIntegration = sensorIntegrationCreator(eventFieldsMap, fields, autoCompleteEnhancer);
	    return {
	        sensorIntegrator: function sensorIntegrator(sensorEventKey, value) {
	            var sensorEvent = SensorIntegration[sensorEventKey];
	            if (sensorEvent) {
	                var integratedValue = sensorEvent(value);
	
	                try {
	                    if (debug && typeof console !== 'undefined' && typeof console.table === 'function' && typeof console.group === 'function' && typeof window !== 'undefined' && window.__INITIAL_ENV__ && window.__INITIAL_ENV__.restfulEnv && window.__INITIAL_ENV__.restfulEnv != 'production') {
	                        console.group('Sensor event \'' + sensorEventKey + '\'');
	                        console.table(value);
	                        console.table(integratedValue);
	                        console.groupEnd();
	                    }
	                } catch (e) {
	                    (0, _warning2.default)('Sensor Error: Debug log can not convert JSON, detailed error infomation is : ' + e);
	                }
	                return integratedValue;
	            } else {
	                (0, _warning2.default)('Sensor Warning: Can not find event key \'' + sensorEventKey + '\' in \'eventFieldsMap\'. ' + ('check if \'' + sensorEventKey + '\' is setted in config'));
	                return {};
	            }
	        },
	        SensorIntegration: SensorIntegration,
	        fieldsConvertion: fieldsConvertion
	    };
	}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.basicTypeConvertion = exports.checkValueExsit = undefined;
	
	var _warning = __webpack_require__(90);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkValueExsit = exports.checkValueExsit = function checkValueExsit(v) {
	    return !(v === null || v === undefined);
	}; /*
	    *
	    * Producer -- Alvin
	    * Time -- 2018/7/5
	    * Function -- Transform type
	    *
	    */
	var basicTypeConvertion = exports.basicTypeConvertion = function basicTypeConvertion(basicType, v) {
	    var typeContainer = {
	        string: String,
	        number: Number,
	        boolean: Boolean
	    };
	    var convertion = typeContainer[basicType];
	    if (!convertion) {
	        (0, _warning2.default)('Argument \'basicType\' required to function \'basicTypeConvertion\' must be \'string\', \'number\' or \'boolean\'');
	        return v;
	    }
	    return convertion(v || '');
	};

/***/ }),
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AjaxOptions = undefined;
	exports.AjaxOptionsHeaders = AjaxOptionsHeaders;
	exports.AjaxOptionsHeadersCookies = AjaxOptionsHeadersCookies;
	exports.AJAX = AJAX;
	exports.jQueryFormat = jQueryFormat;
	exports.outJson = outJson;
	exports.jQueryAjax = jQueryAjax;
	exports.fetchAjax = fetchAjax;
	
	var _Tools = __webpack_require__(24);
	
	var _Utils = __webpack_require__(55);
	
	var _configAuth = __webpack_require__(170);
	
	var _configAuth2 = _interopRequireDefault(_configAuth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalAjax = [];
	var AjaxOptions = exports.AjaxOptions = {
	  type: "GET",
	  dataType: "json",
	  cache: true
	};
	
	function AjaxOptionsHeaders(WD, cb) {
	  AjaxOptionsHeadersCookies(WD, function (UserId, Token) {
	    cb({
	      UID: UserId,
	      Token: Token,
	      NDFingerPrint: _Tools.isClient ? window.black_box || (window._fmOpt && window._fmOpt.getinfo ? window._fmOpt.getinfo() || '' : '') : ""
	    }); //NDFingerPrint: _dealSmDeviceId,
	  });
	}
	
	function AjaxOptionsHeadersCookies(params, callback) {
	  var relCookieID = null;
	  var relCookieToken = null;
	
	  if (!params.cookie) {
	    // NO Cookie Callback Ghost
	    return callback(relCookieID, relCookieToken);
	  }
	
	  if ((0, _Tools.GetSingleCookie)(params.cookie, "Token")) {
	    relCookieToken = (0, _Tools.GetSingleCookie)(params.cookie, "Token");
	  }
	
	  if ((0, _Tools.GetSingleCookie)(params.cookie, "UID")) {
	    relCookieID = (0, _Tools.GetSingleCookie)(params.cookie, "UID");
	  }
	
	  // NO match Callback Ghost
	  return callback(relCookieID, relCookieToken);
	}
	
	function AJAX(params, callback) {
	  (0, _Tools.RecordOrderChannel)();
	  var _AuthList = _configAuth2.default.url,
	      _PathName = window.location.pathname,
	      _Token = (0, _Tools.GetSingleCookie)(window.document.cookie, "Token");
	
	  /**
	   * No Token
	   */
	  var Black = false; // True Match False No PDP NO
	  _AuthList.map(function (data, index) {
	    if (_PathName.match(new RegExp(data))) {
	      Black = true;
	    }
	  });
	  var options = {};
	  if (!params) {
	    callback({ status: 1, message: "error total params Url" });
	    return;
	  }
	  // OBJECT_ASSIGN
	  Object.assign(options, AjaxOptions);
	
	  // URL
	  options.url = "https://" + (0, _Tools.GetEnvValue)(process.title, "api") + params.url;
	
	  // DATA
	  options.data = params.processData === false ? params.data : JSON.stringify(params.data);
	
	  // METHOD
	  if (params.type) options.type = params.type;
	
	  // DATA_TYPE
	  if (params.dataType) options.method = params.dataType;
	
	  // HEADERS
	  if (!params["headers"]) params["headers"] = {};
	
	  // CONTENT_TYPE
	  options.contentType = params.contentType === false ? false : "application/json; charset=utf-8";
	
	  // processData
	  options.processData = params.processData === false ? false : true;
	
	  // AJAX Abort
	  if (params.abort) options.abort = params.abort;
	
	  // AJAX Post Cookie
	  options.xhrFields = { withCredentials: true };
	
	  //console.log('getOrderStatus', "FETCH")
	
	  // Get Headers UID Token
	  AjaxOptionsHeaders(window.document, function (cbHeader) {
	    //console.log('getOrderStatus', "GETHEADER")
	
	    options["headers"] = Object.assign({}, params.headers || {}, cbHeader);
	
	    if (!options.headers.UID) delete options.headers.UID;
	    if (!options.headers.Token) delete options.headers.Token;
	
	    // IE(11) Not supported Fetch
	    if ($ && $.ajax) {
	      jQueryAjax(options, function (ajaxCallback) {
	        callback(ajaxCallback);
	      });
	    }
	  });
	}
	
	function jQueryFormat(responseText) {
	  var jQueryFormatWrap = ["jQueryStatus", "results", "status", "errorCode", "errorMessage", "dataResult" //为了返回错误信息
	  ];
	  // let deepCopyResponse = $.extend( true, responseText )
	  for (var i in responseText) {
	    if (jQueryFormatWrap.indexOf(i) < 0) {
	      delete responseText[i];
	    }
	  }
	  return responseText;
	}
	
	function outJson(object) {
	  if ((0, _Utils.typeofString)(object)) {
	    return JSON.parse(object);
	  }
	  return object;
	}
	
	// ajax - abort + responseCatch
	function jQueryAjax(jQueryOptions, jQueryCallback) {
	  if (jQueryOptions["abort"]) {
	    if (globalAjax[jQueryOptions["abort"]]) globalAjax[jQueryOptions["abort"]].abort();
	    globalAjax[jQueryOptions["abort"]] = $.ajax(Object.assign({}, jQueryOptions, {
	      success: function success(json) {
	        json.jQueryStatus = {};
	        // json.jQueryStatus.status = tmpAjax.status;
	        json.jQueryStatus.status = globalAjax[jQueryOptions["abort"]].status;
	        json.ajaxOptions = jQueryOptions;
	        jQueryCallback((0, _Tools.GetConfirmation)(jQueryFormat(json)));
	      },
	      error: function error(err) {
	        var json = (0, _Utils.typeofObject)(err.responseText) ? JSON.parse(err.responseText) : { errResponseText: err.responseText || "" };
	        json.jQueryStatus = {};
	        // json.jQueryStatus.status = tmpAjax.status;
	        json.jQueryStatus.status = globalAjax[jQueryOptions["abort"]].status;
	        json.ajaxOptions = jQueryOptions;
	        jQueryCallback((0, _Tools.GetConfirmation)(jQueryFormat(json)));
	      }
	    }));
	  } else {
	    var tmpAjax = null;
	    tmpAjax = $.ajax(Object.assign({}, jQueryOptions, {
	      success: function success(json) {
	        json.jQueryStatus = {};
	        // json.jQueryStatus.status = tmpAjax.status;
	        json.jQueryStatus.status = tmpAjax.status;
	        json.ajaxOptions = jQueryOptions;
	        jQueryCallback((0, _Tools.GetConfirmation)(jQueryFormat(json)));
	      },
	      error: function error(err) {
	        var json = (0, _Utils.typeofObject)(err.responseText) ? JSON.parse(err.responseText) : { errResponseText: err.responseText || "" }; //这段逻辑有点看不懂，暂时先不动
	        json.jQueryStatus = {};
	        // json.jQueryStatus.status = tmpAjax.status;
	        json.jQueryStatus.status = tmpAjax && tmpAjax.status ? tmpAjax.status : null;
	        json.ajaxOptions = jQueryOptions;
	        json.dataResult = (0, _Utils.typeofString)(err.responseText) && JSON.parse(err.responseText); //这段为了返回错误信息
	        jQueryCallback((0, _Tools.GetConfirmation)(jQueryFormat(json)));
	      }
	    }));
	  }
	}
	
	function fetchAjax(params) {
	  return "IE 6 - 11 NO supported Fetch";
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = globalToast;
	function globalToast(_ref) {
	    var message = _ref.message;
	
	    window.ifShow = true;
	    if (window.ifShow) {
	        var html = document.createElement('div');
	        html.className = 'homePopUp';
	        html.innerHTML = '<div class="bg"></div>><div class="centerText" style=>' + message + '</div>';
	        document.getElementById('root').appendChild(html);
	        window.ifShow = false;
	        setTimeout(function () {
	            document.getElementById('root').removeChild(html);
	        }, 3000);
	    }
	}

/***/ }),
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case types.MY_COUPON.MY_COUPON_RESULTS:
	            return Object.assign({}, state, { couponResults: action.data });
	        case types.MY_COUPON.MY_COUPON_LISTS:
	            return Object.assign({}, state, { depositCouponResults: action.data });
	
	        default:
	            return state;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = {
	    couponResults: {},
	    depositCouponResults: []
	};

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        default:
	            return state;
	    }
	};
	
	var initialState = {};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialLocationsState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var GET_POPUP_PROVINCE_PROTOTYPE = action.GET_POPUP_PROVINCE_PROTOTYPE;
	    var OPEN_POPUP = action.OPEN_POPUP;
	
	    switch (action.type) {
	        case _ActionTypes.ADDRESSPOPUP.OPEN_ADDRESS_LIST:
	            return Object.assign({}, state, {
	                OPEN_ADDRESS_LIST: 1,
	                OPEN_POPUP_STATUS: 1
	            });
	            break;
	        case _ActionTypes.ADDRESSPOPUP.CLOSE_POPUP:
	            return Object.assign({}, state, {
	                OPEN_POPUP: null,
	                OPEN_ADDRESS_LIST: null,
	                OPEN_POPUP_STATUS: null
	            });
	            break;
	        case _ActionTypes.ADDRESSPOPUP.OPEN_POPUP:
	            return Object.assign({}, state, {
	                OPEN_ADDRESS_LIST: null,
	                OPEN_POPUP: OPEN_POPUP,
	                OPEN_POPUP_STATUS: 1
	
	            });
	            break;
	        case _ActionTypes.ADDRESSPOPUP.GET_POPUP_PROVINCE_PROTOTYPE:
	            return Object.assign({}, state, {
	                GET_POPUP_PROVINCE_PROTOTYPE: GET_POPUP_PROVINCE_PROTOTYPE
	            });
	            break;
	        default:
	            return state;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initialLocationsState = {
	    GET_POPUP_PROVINCE_PROTOTYPE: null,
	    OPEN_POPUP_STATUS: null,
	    OPEN_POPUP: null,
	    OPEN_ADDRESS_LIST: null
	
	};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : asyncInitialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _ActionTypes.ASYNC.GET_SEARCH_PLACEHOLDER:
	            return Object.assign({}, state, {
	                searchPlaceHolder: action.GET_SEARCH_PLACEHOLDER
	            });
	            break;
	        case _ActionTypes.ASYNC.GET_SEARCH_HOT_WORLD:
	            return Object.assign({}, state, {
	                searchHotWords: action.GET_SEARCH_HOT_WORLD
	            });
	            break;
	        case _ActionTypes.ASYNC.GET_NAVIGATION_GROUP:
	            return Object.assign({}, state, {
	                navigationGroup: action.GET_NAVIGATION_GROUP
	            });
	            break;
	        case _ActionTypes.ASYNC.GET_NAVIGATION_BRAND_GROUP:
	            return Object.assign({}, state, {
	                navigationBrandGroup: action.GET_NAVIGATION_BRAND_GROUP
	            });
	            break;
	        default:
	            return state;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var asyncInitialState = {};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * @Author: Hallie Liu 
	 * @Date:
	 * @Last Modified by: Hallie Liu
	 * @Last Modified time: 2019-05-27 15:43:47
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var SET_OFFSETTOP = action.SET_OFFSETTOP;
	    var SET_HOT_BRAND_OFFSETTOP = action.SET_HOT_BRAND_OFFSETTOP;
	    switch (action.type) {
	
	        case _ActionTypes.BRANDWALL.GET_BRAND_WALL_INFO:
	            return Object.assign({}, state, {
	                GET_BRAND_WALL_INFO: action.BRAND_WALL_INFO
	            });
	            break;
	
	        case _ActionTypes.BRANDWALL.SET_OFFSETTOP:
	            return Object.assign({}, state, {
	                SET_OFFSETTOP: [].concat(_toConsumableArray(state.SET_OFFSETTOP), [SET_OFFSETTOP])
	            });
	            break;
	
	        case _ActionTypes.BRANDWALL.SET_HOT_BRAND_OFFSETTOP:
	            return Object.assign({}, state, {
	                SET_OFFSETTOP: [SET_HOT_BRAND_OFFSETTOP].concat(_toConsumableArray(state.SET_OFFSETTOP))
	            });
	            break;
	
	        case _ActionTypes.BRANDWALL.SET_TOP:
	            return Object.assign({}, state, {
	                SET_TOP: action.val
	            });
	            break;
	
	        case _ActionTypes.BRANDWALL.CHANGE_CURRENT_LETTER_BG:
	            return Object.assign({}, state, {
	                CHANGE_CURRENT_LETTER_BG: action.val
	            });
	            break;
	
	        case _ActionTypes.BRANDWALL.GET_AD_IMG:
	            return Object.assign({}, state, {
	                AD_IMG: action.AD_IMG
	            });
	            break;
	
	        case _ActionTypes.BRANDWALL.GET_AD_TEXT:
	            return Object.assign({}, state, {
	                AD_TEXT: action.AD_TEXT
	            });
	            break;
	
	        // case BRANDWALL.BRAND_STORY_LINK :
	        //     return Object.assign({},state,{
	        //         BRAND_STORY_LINK : action.BRAND_STORY_LINK
	        //     });
	        // break;
	
	        default:
	            return state;break;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initState = {
	    GET_BRAND_WALL_INFO: null,
	    SET_OFFSETTOP: [],
	    SET_TOP: null,
	    CHANGE_CURRENT_LETTER_BG: '',
	    AD_IMG: null,
	    AD_TEXT: null
	    // BRAND_STORY_LINK : null
	};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * @Author: Rowe 
	 * @Date: 2019-05-09 17:34:52 
	 * @Last Modified by: Rowe
	 * @Last Modified time: 2019-05-09 17:42:27
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	        case _ActionTypes.CATEGORY.SAVE_VALUE:
	            // not modified
	            return Object.assign({}, state, {
	                SAVE_VALUE: action.value
	            });
	            break;
	        case _ActionTypes.CATEGORY.SHOW_SUCCESS:
	            // v 修改后
	            return Object.assign({}, state, {
	                SHOW_SUCCESS: action.num
	            });
	            break;
	        case _ActionTypes.CATEGORY.GETADBANNER:
	            // v 修改后
	            return Object.assign({}, state, {
	                GETADBANNER: action.data
	            });
	            break;
	
	        case _ActionTypes.CATEGORY.LACK_INV:
	            // v 修改后
	            return Object.assign({}, state, {
	                LACK_INV: action.value
	            });
	            break;
	
	        case _ActionTypes.CATEGORY.GET_BRANDS:
	            // v 修改后
	            return Object.assign({}, state, {
	                GET_BRANDS: action.json
	            });
	            break;
	
	        case _ActionTypes.CATEGORY.CONTROL_BOTTOM:
	            // v 修改后
	            return Object.assign({}, state, {
	                BOTTOM: action.Boolean
	            });
	            break;
	
	        case _ActionTypes.CATEGORY.TOGGLE_SHOW_ALL:
	            // v 修改后
	            return Object.assign({}, state, {
	                SHOW_ALL: action.Boolean
	            });
	            break;
	
	        case _ActionTypes.CATEGORY.POPUP_REQUEST:
	            // v 修改后
	            return Object.assign({}, state, {
	                POPUP_REQUEST: action.POPUP_REQUEST,
	                POPUP_ORDER_NUM: 1
	            });
	            break;
	
	        case _ActionTypes.CATEGORY.CATEGORY_POPUP:
	            // v 修改后
	            return Object.assign({}, state, {
	                CATEGORY_POPUP: action.show
	            });
	            break;
	
	        case _ActionTypes.CATEGORY.POPUP_ORDER_NUM:
	            // v 修改后
	            return Object.assign({}, state, {
	                POPUP_ORDER_NUM: action.num
	            });
	            break;
	
	        case _ActionTypes.CATEGORY.FILTER_STATUS:
	            // v 修改后
	            return Object.assign({}, state, {
	                FILTER_STATUS: action.params
	            });
	            break;
	
	        case _ActionTypes.CATEGORY.HIDE_FIXED_TOP:
	            // v 修改后
	            return Object.assign({}, state, {
	                FIXEDTOP_SHOW: action.num
	            });
	            break;
	        case _ActionTypes.CATEGORY.SET_OFFSETTOP:
	            return Object.assign({}, state, {
	                SET_OFFSETTOP: action.value
	            });
	            break;
	
	        case _ActionTypes.CATEGORY.IFSHOW:
	            return Object.assign({}, state, {
	                IFSHOW: action.value
	            });
	            break;
	
	        case _ActionTypes.CATEGORY.SORT_PRODUCT:
	            return Object.assign({}, state, {
	                SORT_PRODUCT: action.param
	            });
	            break;
	
	        default:
	            return state;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initState = {
	
	    POPUP_REQUEST: null, // v修改后
	    CATEGORY_POPUP: null, // v修改后
	    POPUP_ORDER_NUM: 1, // v修改后
	    FILTER_STATUS: null, // v修改后
	    SHOW_ALL: false, // v修改后 
	    FIXEDTOP_SHOW: 1, // v修改后
	    BOTTOM: false, // v修改后
	    GET_BRANDS: null, // v修改后
	    SAVE_VALUE: null, // v修改后
	    LACK_INV: null, // v修改后
	    SHOW_SUCCESS: 0, // v修改后
	    GETADBANNER: null, // v修改后
	
	    SORT_PRODUCT: null,
	    SET_OFFSETTOP: null,
	    IFSHOW: true
	};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	
	        case _ActionTypes.CATEGORYONELEVEL.GET_AD_IMG:
	            return Object.assign({}, state, {
	                AD_IMG: action.AD_IMG
	            });
	            break;
	        case _ActionTypes.CATEGORYONELEVEL.GET_CRUMBS:
	            return Object.assign({}, state, {
	                GET_CRUMBS: action.GET_CRUMBS
	            });
	            break;
	        case _ActionTypes.CATEGORYONELEVEL.GET_PATH:
	            return Object.assign({}, state, {
	                GET_PATH: action.param
	            });
	            break;
	        case _ActionTypes.CATEGORYONELEVEL.GET_CONTENTS:
	            return Object.assign({}, state, {
	                GET_CONTENTS: action.GET_CONTENTS
	
	            });
	            break;
	        default:
	            return state;break;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initState = {
	    AD_IMG: null,
	    GET_CRUMBS: null,
	    GET_PATH: null,
	    GET_CONTENTS: null
	};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _initialCheckoutState;
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialCheckoutState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var CHECKOUT_SAVE_PARAMETER = action.CHECKOUT_SAVE_PARAMETER;
	    var CHECKOUT_KEEP_PARAMETER = action.CHECKOUT_KEEP_PARAMETER;
	    var CHECKOUT_REMEMBER_CHOOSE = action.CHECKOUT_REMEMBER_CHOOSE;
	    var CHECKOUT_TIMEING_CHECKED = action.CHECKOUT_TIMEING_CHECKED;
	    var CHECKOUT_CART_TIME_STAMP = action.CHECKOUT_CART_TIME_STAMP;
	    var CHECKOUT_CHANGE_TAB_SORT = action.CHECKOUT_CHANGE_TAB_SORT;
	    var CHECKOUT_ATTR_STATUS = action.CHECKOUT_ATTR_STATUS;
	    var CHECKOUT_CUR_TYPE = action.CHECKOUT_CUR_TYPE;
	    var CHECKOUT_CUR_STATUS = action.CHECKOUT_CUR_STATUS;
	    var CHECKOUT_PHONE_STATUS = action.CHECKOUT_PHONE_STATUS;
	    var CHECKOUT_ADDRESS_LIST = action.CHECKOUT_ADDRESS_LIST;
	    var CHECKOUT_MISS_SKUID_BOOKING = action.CHECKOUT_MISS_SKUID_BOOKING;
	    var CHECKOUT_ORDER_DETAILS = action.CHECKOUT_ORDER_DETAILS;
	    var CHECKOUT_ALL_GIFT = action.CHECKOUT_ALL_GIFT;
	    var CHECKOUT_ALL_GIFT_BOOKING = action.CHECKOUT_ALL_GIFT_BOOKING;
	    var CHECKOUT_INPUTCOUPONS = action.CHECKOUT_INPUTCOUPONS;
	    var CHECKOUT_PHONE_DATA = action.CHECKOUT_PHONE_DATA;
	    var CHECKOUT_CHANGE_STATE = action.CHECKOUT_CHANGE_STATE;
	    var SATISFYGIFTCOMMENTS = action.SATISFYGIFTCOMMENTS;
	    var CHECKOUT_ORDER_TYPE = action.CHECKOUT_ORDER_TYPE;
	    var CHECKOUT_PUBLIC_DATA = action.CHECKOUT_GET;
	    var CHECKOUT_DEFAULT_ADDRESS = action.CHECKOUT_DEFAULT_ADDRESS;
	    var CHECKOUT_ORDER_ID = action.CHECKOUT_ORDER_ID;
	    var CHECKOUT_INFORMATION = action.CHECKOUT_INFORMATION;
	    var CHECKOUT_CHANGE_PAYMENT = action.CHECKOUT_CHANGE_PAYMENT;
	    var CHECKOUT_CHANGE_RECEIVING = action.CHECKOUT_CHANGE_RECEIVING;
	    var CHECKOUT_PAY_LINK = action.CHECKOUT_PAY_LINK;
	    var CHECKOUT_TAB_GUESSYOULIKE = action.CHECKOUT_TAB_GUESSYOULIKE;
	    var CHECKOUT_TAB_MYFAVORITE = action.CHECKOUT_TAB_MYFAVORITE;
	    var CHECKOUT_TAB_MYBROWSERHISTORY = action.CHECKOUT_TAB_MYBROWSERHISTORY;
	    var CHECKOUT_TAB_ACTIVE = action.CHECKOUT_TAB_ACTIVE;
	    var CHECKOUT_DELETE_POSITION_FIRST = action.CHECKOUT_DELETE_POSITION_FIRST;
	    var CHECKOUT_DELETE_POSITION_SECOND = action.CHECKOUT_DELETE_POSITION_SECOND;
	    var CHECKOUT_DELETE_POSITION_THIRD = action.CHECKOUT_DELETE_POSITION_THIRD;
	    var CHECKOUT_DELIVERY_INFO = action.CHECKOUT_DELIVERY_INFO;
	    var CHECKOUT_ADDRESS_COD = action.CHECKOUT_ADDRESS_COD;
	    var CHECKOUT_ADDRESS_EXPRESS = action.CHECKOUT_ADDRESS_EXPRESS;
	    var CHECKOUT_PURCHASED = action.CHECKOUT_PURCHASED;
	    var SET_CHECKOUT_GIFT = action.SET_CHECKOUT_GIFT;
	
	    var CHECKOUT_SAVE_ALERT_DATA_ID = action.CHECKOUT_SAVE_ALERT_DATA_ID;
	    var CHECKOUT_SAVE_ALERT_DATA_TYPE = action.CHECKOUT_SAVE_ALERT_DATA_TYPE;
	    var CHECKOUT_SAVE_ALERT_DATA_TEXT = action.CHECKOUT_SAVE_ALERT_DATA_TEXT;
	    var CHECKOUT_SAVE_ALERT_DATA_NAME = action.CHECKOUT_SAVE_ALERT_DATA_NAME;
	    var CHECKOUT_SAVE_ALERT_DATA_PRODUCT_TYPE = action.CHECKOUT_SAVE_ALERT_DATA_PRODUCT_TYPE;
	    var CHECKOUT_SAVE_ALERT_DATA_QUANTITY = action.CHECKOUT_SAVE_ALERT_DATA_QUANTITY;
	    var CHECKOUT_SAVE_ALERT_DATA_ACTIONTYPE = action.CHECKOUT_SAVE_ALERT_DATA_ACTIONTYPE;
	
	    var CHECKOUT_NOTICE_ID = action.CHECKOUT_NOTICE_ID;
	
	    var CHECKOUT_ADD_REMOVE_ID = action.CHECKOUT_ADD_REMOVE_ID;
	    var CHECKOUT_ADD_REMOVE_NAME = action.CHECKOUT_ADD_REMOVE_NAME;
	    var CHECKOUT_ADD_REMOVE_TYPE = action.CHECKOUT_ADD_REMOVE_TYPE;
	    var CHECKOUT_ADD_REMOVE_QUANTITY = action.CHECKOUT_ADD_REMOVE_QUANTITY;
	    var CHECKOUT_ADD_REMOVE_STATUS = action.CHECKOUT_ADD_REMOVE_STATUS;
	    var CHECKOUT_ADD_REMOVE_INVENTORY = action.CHECKOUT_ADD_REMOVE_INVENTORY;
	    var CHECKOUT_ADD_REMOVE_PRODUCTID = action.CHECKOUT_ADD_REMOVE_PRODUCTID;
	    var CHECKOUT_ADD_REMOVE_OFFERPRICE = action.CHECKOUT_ADD_REMOVE_OFFERPRICE;
	    var CHECKOUT_ADD_REMOVE_SKUCODE = action.CHECKOUT_ADD_REMOVE_SKUCODE;
	    var CHECKOUT_ADD_REMOVE_PRODUCTNAMEEN = action.CHECKOUT_ADD_REMOVE_PRODUCTNAMEEN;
	    var CHECKOUT_ADD_REMOVE_DELETEPRODUCTTYPE = action.CHECKOUT_ADD_REMOVE_DELETEPRODUCTTYPE;
	    var CHECKOUT_GET_SKU_STANDARD = action.CHECKOUT_GET_SKU_STANDARD;
	
	    var CHECKOUT_SAVE_ALL_SKU_TEXT = action.CHECKOUT_SAVE_ALL_SKU_TEXT;
	    var CHECKOUT_SAVE_ALL_SKU_LIST = action.CHECKOUT_SAVE_ALL_SKU_LIST;
	
	    var CHECKOUT_COLLECT_ITEM_ALL_TEXT = action.CHECKOUT_COLLECT_ITEM_ALL_TEXT;
	    var CHECKOUT_COLLECT_ITEM_ALL_LIST = action.CHECKOUT_COLLECT_ITEM_ALL_LIST;
	
	    var CHECKOUT_SAVE_TOTAL_DELETE = action.CHECKOUT_SAVE_TOTAL_DELETE;
	
	    //let CHECKOUT_CLEAR_LOSE_SKU = action.CHECKOUT_CLEAR_LOSE_SKU;
	
	    //购物车第二布订单数据
	    var CHECKOUT_ORDER_INFORMATION = action.CHECKOUT_ORDER_INFORMATION;
	    var PXCOUPONS = action.PXCOUPONS;
	    var PROMOTIONCODEMAP = action.PROMOTIONCODEMAP;
	    //购物车数据
	    var CHECKOUT_CARTINFO = action.CHECKOUT_CARTINFO;
	    //定金预售数据
	    var CHECKOUT_CARTINFO_BOOKING = action.CHECKOUT_CARTINFO_BOOKING;
	    //third
	    var CHECKOUT_GET_ORDER_STATUS = action.CHECKOUT_GET_ORDER_STATUS;
	
	    //orderdetail
	    var ORDER_DETAIL = action.ORDER_DETAIL;
	
	    var CHECKOUT_TAB_LIST = void 0,
	        CHECKOUT_TAB_LIST_OBJECT = void 0,
	        CHECKOUT_TAB_ACTIVE_OBJECT = void 0;
	    //取前台传来的数据
	    var CHECKOUT_SAVE_ALL_SKU_LOSE_LIST = action.CHECKOUT_SAVE_ALL_SKU_LOSE;
	    //控制清除失效商品按钮
	    var CHECKOUT_MISS_SKUID = action.CHECKOUT_MISS_SKUID;
	    //商品关联对应赠品数据(组增) 向接口发送的入参数据
	    var CHECKOUT_CORRESPOND_SKUID = action.CHECKOUT_CORRESPOND_SKUID;
	
	    var CHECKOUT_CORRESPOND_SKUID_BOOKING = action.CHECKOUT_CORRESPOND_SKUID_BOOKING;
	    //储存组增接口返回数据
	    var CHECKOUT_RESERVE_DATA = action.CHECKOUT_RESERVE_DATA;
	    //商品关联对应赠品数据(单赠) 向接口发送的入参数据
	    var CHECKOUT_SINGLE_SKUID = action.CHECKOUT_SINGLE_SKUID;
	    var CHECKOUT_SINGLE_SKUID_BOOKING = action.CHECKOUT_SINGLE_SKUID_BOOKING;
	    //储存单增接口返回数据
	    var CHECKOUT_RESERVE_SINGLE_DATA = action.CHECKOUT_RESERVE_SINGLE_DATA;
	    //储存订单级别接口返回数据
	    var CHECKOUT_RESERVE_PROMOTION_DATA = action.CHECKOUT_RESERVE_PROMOTION_DATA;
	    //记录定金预商品状态
	    var CHECKOUT_GOODS_STATUS = action.CHECKOUT_GOODS_STATUS;
	    //存储丝享卡列表信息
	    var CHECKOUT_SILK_CARD_LIST = action.CHECKOUT_SILK_CARD_LIST;
	    //丝享卡支付入参
	    var CHECKOUT_URL_PARMTER = action.CHECKOUT_URL_PARMTER;
	    //silk on off
	    var CHECKOUT_SILK_PAY_ONOFF = action.CHECKOUT_SILK_PAY_ONOFF;
	
	    // 组赠自选数据
	    var GETOPTIONALGIFT = action.GETOPTIONALGIFT;
	
	    // 是否开具电子发票
	    var CHECKOUT_INVOICE_STATUS = action.CHECKOUT_INVOICE_STATUS;
	    // 保存个人抬头信息
	    var CHECKOUT_INVOICE_INDIVIDUAL_SAVE = action.CHECKOUT_INVOICE_INDIVIDUAL_SAVE;
	    // 保存企业抬头信息
	    var CHECKOUT_INVOICE_ENTERPRISE_SAVE = action.CHECKOUT_INVOICE_ENTERPRISE_SAVE;
	    // 展开选填
	    var CHECKOUT_INVOICE_ENTERPRISE_OPEN = action.CHECKOUT_INVOICE_ENTERPRISE_OPEN;
	    // 默认抬头信息 
	    var CHECKOUT_INVOICE_DEFAULTTITLE = action.CHECKOUT_INVOICE_DEFAULTTITLE;
	    // 抬头id
	    var CHECKOUT_INVOICE_TITLEID = action.CHECKOUT_INVOICE_TITLEID;
	    // 输入的抬头信息
	    var CHECKOUT_INVOICE_DATA = action.CHECKOUT_INVOICE_DATA;
	    var DEPOSIT_COMMENT = action.DEPOSIT_COMMENT; //定金预售 付定金备注
	    var CANCEL_ORDER_TIME_LEFT = action.CANCEL_ORDER_TIME_LEFT;
	    var EXTRABUYACTID = action.EXTRABUYACTID;
	    var CART_TIPSMSG = action.CART_TIPSMSG;
	    var EXTRABUYTITLE = action.EXTRABUYTITLE;
	    var EXTRALBUYSHOWSTATUS = action.EXTRALBUYSHOWSTATUS;
	    var EXCHANGEPRODUCTLIST = action.EXCHANGEPRODUCTLIST;
	    var SHOULDPAY = action.SHOULDPAY;
	    var DELETEPRODUCTTYPE = action.DELETEPRODUCTTYPE;
	    switch (action.type) {
	        case _ActionTypes.CHECKOUT.CHECKOUT_SAVE_PARAMETER:
	            return Object.assign({}, state, {
	                CHECKOUT_SAVE_PARAMETER: CHECKOUT_SAVE_PARAMETER
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_KEEP_PARAMETER:
	            return Object.assign({}, state, {
	                CHECKOUT_KEEP_PARAMETER: CHECKOUT_KEEP_PARAMETER
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_REMEMBER_CHOOSE:
	            return Object.assign({}, state, {
	                CHECKOUT_REMEMBER_CHOOSE: CHECKOUT_REMEMBER_CHOOSE
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_TIMEING_CHECKED:
	            return Object.assign({}, state, {
	                CHECKOUT_TIMEING_CHECKED: CHECKOUT_TIMEING_CHECKED
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_CART_TIME_STAMP:
	            return Object.assign({}, state, {
	                CHECKOUT_CART_TIME_STAMP: CHECKOUT_CART_TIME_STAMP
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_CHANGE_TAB_SORT:
	            return Object.assign({}, state, {
	                CHECKOUT_CHANGE_TAB_SORT: CHECKOUT_CHANGE_TAB_SORT
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_SILK_PAY_ONOFF:
	            return Object.assign({}, state, {
	                CHECKOUT_SILK_PAY_ONOFF: CHECKOUT_SILK_PAY_ONOFF
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_GOODS_STATUS:
	            return Object.assign({}, state, {
	                CHECKOUT_GOODS_STATUS: CHECKOUT_GOODS_STATUS
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_ATTR_STATUS:
	            return Object.assign({}, state, {
	                CHECKOUT_ATTR_STATUS: CHECKOUT_ATTR_STATUS
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_CUR_STATUS:
	            return Object.assign({}, state, {
	                CHECKOUT_CUR_STATUS: CHECKOUT_CUR_STATUS,
	                CHECKOUT_CUR_TYPE: CHECKOUT_CUR_TYPE
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_PHONE_STATUS:
	            return Object.assign({}, state, {
	                CHECKOUT_PHONE_STATUS: CHECKOUT_PHONE_STATUS
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_ADDRESS_LIST:
	            return Object.assign({}, state, {
	                CHECKOUT_ADDRESS_LIST: CHECKOUT_ADDRESS_LIST
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_RESERVE_PROMOTION_DATA:
	            return Object.assign({}, state, {
	                CHECKOUT_RESERVE_PROMOTION_DATA: CHECKOUT_RESERVE_PROMOTION_DATA
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_MISS_SKUID_BOOKING:
	            return Object.assign({}, state, {
	                CHECKOUT_MISS_SKUID_BOOKING: CHECKOUT_MISS_SKUID_BOOKING
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_ORDER_DETAILS:
	            return Object.assign({}, state, {
	                CHECKOUT_ORDER_DETAILS: CHECKOUT_ORDER_DETAILS
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_ALL_GIFT:
	            return Object.assign({}, state, {
	                CHECKOUT_ALL_GIFT: CHECKOUT_ALL_GIFT
	            });
	            break;
	
	        case _ActionTypes.CHECKOUT.CHECKOUT_ALL_GIFT_BOOKING:
	            return Object.assign({}, state, {
	                CHECKOUT_ALL_GIFT_BOOKING: CHECKOUT_ALL_GIFT_BOOKING
	            });
	            break;
	
	        case _ActionTypes.CHECKOUT.CHECKOUT_INPUTCOUPONS:
	            return Object.assign({}, state, {
	                CHECKOUT_INPUTCOUPONS: CHECKOUT_INPUTCOUPONS
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_PHONE_DATA:
	            return Object.assign({}, state, {
	                CHECKOUT_PHONE_DATA: CHECKOUT_PHONE_DATA
	            });
	            break;
	        case _ActionTypes.CHECKOUT.DEPOSIT_COMMENT:
	            return Object.assign({}, state, {
	                DEPOSIT_COMMENT: DEPOSIT_COMMENT
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CANCEL_ORDER_TIME_LEFT:
	            return Object.assign({}, state, {
	                CANCEL_ORDER_TIME_LEFT: CANCEL_ORDER_TIME_LEFT
	            });
	            break;
	        case _ActionTypes.CHECKOUT.SHOULDPAY:
	            return Object.assign({}, state, {
	                SHOULDPAY: SHOULDPAY
	            });
	            break;
	
	        case _ActionTypes.CHECKOUT.CHECKOUT_CHANGE_STATE_AGREEMENT:
	            return Object.assign({}, state, {
	                CHECKOUT_CHANGE_STATE_AGREEMENT: action.CHECKOUT_CHANGE_STATE_AGREEMENT
	            });
	            break;
	        case _ActionTypes.CHECKOUT.SATISFYGIFTCOMMENTS:
	            return Object.assign({}, state, {
	                SATISFYGIFTCOMMENTS: action.SATISFYGIFTCOMMENTS
	            });
	            break;
	
	        case _ActionTypes.CHECKOUT.CHECKOUT_CHANGE_STATE:
	            return Object.assign({}, state, {
	                CHECKOUT_CHANGE_STATE: CHECKOUT_CHANGE_STATE
	            });
	            break;
	
	        case _ActionTypes.CHECKOUT.CHECKOUT_ORDER_TYPE:
	            return Object.assign({}, state, {
	                CHECKOUT_ORDER_TYPE: CHECKOUT_ORDER_TYPE
	            });
	            break;
	
	        case _ActionTypes.CHECKOUT.CHECKOUT_RESERVE_SINGLE_DATA:
	            return Object.assign({}, state, {
	                CHECKOUT_RESERVE_SINGLE_DATA: CHECKOUT_RESERVE_SINGLE_DATA
	            });
	            break;
	
	        case _ActionTypes.CHECKOUT.CHECKOUT_SINGLE_SKUID:
	            return Object.assign({}, state, {
	                CHECKOUT_SINGLE_SKUID: CHECKOUT_SINGLE_SKUID
	            });
	            break;
	
	        case _ActionTypes.CHECKOUT.CHECKOUT_SINGLE_SKUID_BOOKING:
	            return Object.assign({}, state, {
	                CHECKOUT_SINGLE_SKUID_BOOKING: CHECKOUT_SINGLE_SKUID_BOOKING
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_RESERVE_DATA:
	            return Object.assign({}, state, {
	                CHECKOUT_RESERVE_DATA: CHECKOUT_RESERVE_DATA
	            });
	            break;
	
	        case _ActionTypes.CHECKOUT.CHECKOUT_MISS_SKUID:
	            return Object.assign({}, state, {
	                CHECKOUT_MISS_SKUID: CHECKOUT_MISS_SKUID
	            });
	            break;
	
	        case _ActionTypes.CHECKOUT.CHECKOUT_CORRESPOND_SKUID:
	            return Object.assign({}, state, {
	                CHECKOUT_CORRESPOND_SKUID: CHECKOUT_CORRESPOND_SKUID
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_CORRESPOND_SKUID_BOOKING:
	            return Object.assign({}, state, {
	                CHECKOUT_CORRESPOND_SKUID_BOOKING: CHECKOUT_CORRESPOND_SKUID_BOOKING
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CONTROL:
	            return Object.assign({}, state, {
	                CONTROL: action.item
	            });
	            break;
	
	        case _ActionTypes.CHECKOUT.CHECKOUT_SELECT_TAB:
	            return Object.assign({}, state, {
	                CHECKOUT_SELECT_TAB: action.value
	            });
	            break;
	        case _ActionTypes.CHECKOUT.ORDER_DETAIL:
	            return Object.assign({}, state, {
	                ORDER_DETAIL: ORDER_DETAIL
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_CLEAR_POSITION_DELETE:
	            return Object.assign({}, state, {
	                CHECKOUT_POSITION_DELETE: null
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_GET_ORDER_STATUS:
	            return Object.assign({}, state, {
	                CHECKOUT_ORDER_STATUS: CHECKOUT_GET_ORDER_STATUS
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_CLOSE_THIRD_ALERT_PAY:
	            return Object.assign({}, state, {
	                CHECKOUT_THIRD_ALERT_PAY: null
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_OPEN_THIRD_ALERT_PAY:
	            return Object.assign({}, state, {
	                CHECKOUT_THIRD_ALERT_PAY: 1
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_ORDER_INFORMATION:
	            return Object.assign({}, state, {
	                CHECKOUT_ORDER_INFORMATION: CHECKOUT_ORDER_INFORMATION
	            });
	            break;
	        case _ActionTypes.CHECKOUT.PXCOUPONS:
	            return Object.assign({}, state, {
	                PXCOUPONS: PXCOUPONS
	            });
	            break;
	        case _ActionTypes.CHECKOUT.PROMOTIONCODEMAP:
	            return Object.assign({}, state, {
	                PROMOTIONCODEMAP: PROMOTIONCODEMAP
	            });
	            break;
	
	        case _ActionTypes.CHECKOUT.CHECKOUT_SAVE_ALL_SKU_LOSE:
	            /*let clearAllItem = {
	                status:'3',
	                text : CHECKOUT_CLEAR_LOSE_SKU
	            };
	            return Object.assign({},state,{
	                CHECKOUT_ALERT:clearAllItem
	            }); */
	            return Object.assign({}, state, {
	                CHECKOUT_ALERT: action.param,
	                CHECKOUT_SAVE_ALL_SKU_LOSE: CHECKOUT_SAVE_ALL_SKU_LOSE_LIST
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_COLLECT_ITEM_ALL:
	            var collectItem = {
	                status: '2',
	                text: CHECKOUT_COLLECT_ITEM_ALL_TEXT
	            };
	            return Object.assign({}, state, {
	                CHECKOUT_ALERT: collectItem,
	                CHECKOUT_COLLECT_ITEM_ALL_LIST: CHECKOUT_COLLECT_ITEM_ALL_LIST
	
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_SAVE_TOTAL_DELETE:
	            return Object.assign({}, state, {
	                CHECKOUT_SAVE_TOTAL_DELETE: CHECKOUT_SAVE_TOTAL_DELETE,
	                CHECKOUT_POSITION_DELETE: 1
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_SAVE_ALL_SKU:
	            /*let removeAllSkuAlert = {
	                status:'1',
	                text : CHECKOUT_SAVE_ALL_SKU_TEXT
	            };*/
	            /*return Object.assign({},state,{
	                CHECKOUT_ALERT: removeAllSkuAlert,
	                CHECKOUT_SAVE_ALL_SKU: CHECKOUT_SAVE_ALL_SKU_LIST
	            });*/
	            return Object.assign({}, state, {
	                CHECKOUT_ALERT: action.param,
	                CHECKOUT_SAVE_ALL_SKU: CHECKOUT_SAVE_ALL_SKU_LIST
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_GET_SKU_STANDARD:
	            return Object.assign({}, state, {
	                CHECKOUT_GET_SKU_STANDARD: CHECKOUT_GET_SKU_STANDARD
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_CLEAR_SKU_STANDARD:
	            return Object.assign({}, state, {
	                CHECKOUT_GET_SKU_STANDARD: null
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_CLOSE_DELETE:
	            return Object.assign({}, state, {
	                CHECKOUT_DELETE_ITEM: null,
	                CHECKOUT_SAVE_TOTAL_DELETE: null,
	                CHECKOUT_POSITION_DELETE: null
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_ADD_REMOVE:
	            var checkoutFirstDeleteItem = {};
	            checkoutFirstDeleteItem = {
	                channel: 'PC',
	                skuId: CHECKOUT_ADD_REMOVE_ID,
	                productName: CHECKOUT_ADD_REMOVE_NAME,
	                type: CHECKOUT_ADD_REMOVE_TYPE,
	                quantity: CHECKOUT_ADD_REMOVE_QUANTITY,
	                status: CHECKOUT_ADD_REMOVE_STATUS,
	                inventory: CHECKOUT_ADD_REMOVE_INVENTORY,
	                productId: CHECKOUT_ADD_REMOVE_PRODUCTID,
	                offerPrice: CHECKOUT_ADD_REMOVE_OFFERPRICE,
	                skuCode: CHECKOUT_ADD_REMOVE_SKUCODE,
	                productNameEN: CHECKOUT_ADD_REMOVE_PRODUCTNAMEEN,
	                deleteProductType: CHECKOUT_ADD_REMOVE_DELETEPRODUCTTYPE
	            };
	            return Object.assign({}, state, {
	                CHECKOUT_DELETE_ITEM: checkoutFirstDeleteItem,
	                CHECKOUT_POSITION_DELETE: 1
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_NOTICE_OPEN_SUCCESS:
	            var noticeStatus = state.CHECKOUT_NOTICE;
	            noticeStatus.status = 2;
	            return Object.assign({}, state, {
	                CHECKOUT_NOTICE: noticeStatus
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_NOTICE_CLOSE:
	            return Object.assign({}, state, {
	                CHECKOUT_NOTICE: null
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_NOTICE:
	            var CheckoutNotice = {
	                id: CHECKOUT_NOTICE_ID,
	                status: 1
	            };
	            return Object.assign({}, state, {
	                CHECKOUT_NOTICE: CheckoutNotice
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_SAVE_ALERT_DATA:
	            var saveAlert = {
	                status: '0',
	                id: CHECKOUT_SAVE_ALERT_DATA_ID,
	                type: CHECKOUT_SAVE_ALERT_DATA_TYPE,
	                text: CHECKOUT_SAVE_ALERT_DATA_TEXT,
	                productName: CHECKOUT_SAVE_ALERT_DATA_NAME,
	                productType: CHECKOUT_SAVE_ALERT_DATA_PRODUCT_TYPE,
	                quantity: CHECKOUT_SAVE_ALERT_DATA_QUANTITY,
	                actionType: CHECKOUT_SAVE_ALERT_DATA_ACTIONTYPE
	            };
	            return Object.assign({}, state, {
	                CHECKOUT_ALERT: saveAlert
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_CLOSE_ALERT:
	            return Object.assign({}, state, {
	                CHECKOUT_ALERT: null
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_CARTINFO:
	            return Object.assign({}, state, {
	                CHECKOUT_CARTINFO: CHECKOUT_CARTINFO
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_CARTINFO_BOOKING:
	            return Object.assign({}, state, {
	                CHECKOUT_CARTINFO_BOOKING: CHECKOUT_CARTINFO_BOOKING
	            });
	            break;
	        case _ActionTypes.CHECKOUT.SET_CHECKOUT_GIFT:
	            return Object.assign({}, state, {
	                SET_CHECKOUT_GIFT: SET_CHECKOUT_GIFT
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_PURCHASED:
	            return Object.assign({}, state, {
	                CHECKOUT_PURCHASED: CHECKOUT_PURCHASED
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_ADDRESS_EXPRESS:
	            return Object.assign({}, state, {
	                CHECKOUT_ADDRESS_EXPRESS: CHECKOUT_ADDRESS_EXPRESS
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_ADDRESS_COD:
	            return Object.assign({}, state, {
	                CHECKOUT_ADDRESS_COD: CHECKOUT_ADDRESS_COD
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_DELIVERY_INFO:
	            return Object.assign({}, state, {
	                CHECKOUT_DELIVERY_INFO: CHECKOUT_DELIVERY_INFO
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_DELETE_POSITION_FIRST:
	            return Object.assign({}, state, {
	                CHECKOUT_DELETE_POSITION_FIRST: CHECKOUT_DELETE_POSITION_FIRST
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_DELETE_POSITION_SECOND:
	            return Object.assign({}, state, {
	                CHECKOUT_DELETE_POSITION_SECOND: CHECKOUT_DELETE_POSITION_SECOND
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_DELETE_POSITION_THIRD:
	            return Object.assign({}, state, {
	                CHECKOUT_DELETE_POSITION_THIRD: CHECKOUT_DELETE_POSITION_THIRD
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_TAB_ACTIVE:
	            CHECKOUT_TAB_ACTIVE_OBJECT = state.CHECKOUT_TAB_LIST;
	            CHECKOUT_TAB_ACTIVE_OBJECT.map(function (data, index) {
	                data.Active = 0;
	                if (data.Content == CHECKOUT_TAB_ACTIVE.Content) {
	                    data.Active = 1;
	                }
	            });
	            return Object.assign({}, state, {
	                CHECKOUT_TAB_LIST: CHECKOUT_TAB_ACTIVE_OBJECT
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_TAB_GUESSYOULIKE:
	            CHECKOUT_TAB_LIST_OBJECT = { ID: "GuessYouLike", Content: "猜你喜欢", Position: 0, Active: 1 };
	            CHECKOUT_TAB_LIST = [].concat(_toConsumableArray(state.CHECKOUT_TAB_LIST), [CHECKOUT_TAB_LIST_OBJECT]);
	            return Object.assign({}, state, {
	                CHECKOUT_TAB_GUESSYOULIKE: CHECKOUT_TAB_GUESSYOULIKE,
	                CHECKOUT_TAB_LIST: CHECKOUT_TAB_LIST
	            });
	            break;
	
	        case _ActionTypes.CHECKOUT.CHECKOUT_TAB_MYFAVORITE:
	            CHECKOUT_TAB_LIST_OBJECT = { ID: "MyFavorite", Content: "我的收藏", Position: 1, Active: 0 };
	            CHECKOUT_TAB_LIST = [].concat(_toConsumableArray(state.CHECKOUT_TAB_LIST), [CHECKOUT_TAB_LIST_OBJECT]);
	            return Object.assign({}, state, {
	                CHECKOUT_TAB_MYFAVORITE: CHECKOUT_TAB_MYFAVORITE,
	                CHECKOUT_TAB_LIST: CHECKOUT_TAB_LIST
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_TAB_MYBROWSERHISTORY:
	            CHECKOUT_TAB_LIST_OBJECT = { ID: "MyBrowserHistory", Content: "浏览记录", Position: 2, Active: 0 };
	            CHECKOUT_TAB_LIST = [].concat(_toConsumableArray(state.CHECKOUT_TAB_LIST), [CHECKOUT_TAB_LIST_OBJECT]);
	            return Object.assign({}, state, {
	                CHECKOUT_TAB_MYBROWSERHISTORY: CHECKOUT_TAB_MYBROWSERHISTORY,
	                CHECKOUT_TAB_LIST: CHECKOUT_TAB_LIST
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_GET:
	            return Object.assign({}, state, {
	                CHECKOUT_PUBLIC_DATA: CHECKOUT_PUBLIC_DATA
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_DEFAULT_ADDRESS:
	            return Object.assign({}, state, {
	                CHECKOUT_DEFAULT_ADDRESS: CHECKOUT_DEFAULT_ADDRESS
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_ORDER_ID:
	            return Object.assign({}, state, {
	                CHECKOUT_ORDER_ID: CHECKOUT_ORDER_ID
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_INFORMATION:
	            return Object.assign({}, state, {
	                CHECKOUT_INFORMATION: CHECKOUT_INFORMATION
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_CHANGE_PAYMENT:
	            return Object.assign({}, state, {
	                CHECKOUT_CHANGE_PAYMENT: CHECKOUT_CHANGE_PAYMENT
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_CHANGE_RECEIVING:
	            return Object.assign({}, state, {
	                CHECKOUT_CHANGE_RECEIVING: CHECKOUT_CHANGE_RECEIVING
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_PAY_LINK:
	            return Object.assign({}, state, {
	                CHECKOUT_PAY_LINK: CHECKOUT_PAY_LINK
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_SILK_CARD_LIST:
	            return Object.assign({}, state, {
	                CHECKOUT_SILK_CARD_LIST: CHECKOUT_SILK_CARD_LIST
	            });
	            break;
	        case _ActionTypes.CHECKOUT.CHECKOUT_URL_PARMTER:
	            return Object.assign({}, state, {
	                CHECKOUT_URL_PARMTER: CHECKOUT_URL_PARMTER
	            });
	            break;
	        case _ActionTypes.CHECKOUT.GETOPTIONALGIFT:
	            return Object.assign({}, state, {
	                GETOPTIONALGIFT: GETOPTIONALGIFT
	            });
	        case _ActionTypes.CHECKOUT.CHECKOUT_INVOICE_STATUS:
	            return Object.assign({}, state, {
	                CHECKOUT_INVOICE_STATUS: CHECKOUT_INVOICE_STATUS
	            });
	        case _ActionTypes.CHECKOUT.CHECKOUT_INVOICE_DEFAULTTITLE:
	            return Object.assign({}, state, {
	                CHECKOUT_INVOICE_DEFAULTTITLE: CHECKOUT_INVOICE_DEFAULTTITLE
	            });
	        case _ActionTypes.CHECKOUT.CHECKOUT_INVOICE_INDIVIDUAL_SAVE:
	            return Object.assign({}, state, {
	                CHECKOUT_INVOICE_INDIVIDUAL_SAVE: CHECKOUT_INVOICE_INDIVIDUAL_SAVE
	            });
	        case _ActionTypes.CHECKOUT.CHECKOUT_INVOICE_ENTERPRISE_SAVE:
	            return Object.assign({}, state, {
	                CHECKOUT_INVOICE_ENTERPRISE_SAVE: CHECKOUT_INVOICE_ENTERPRISE_SAVE
	            });
	        case _ActionTypes.CHECKOUT.CHECKOUT_INVOICE_ENTERPRISE_OPEN:
	            return Object.assign({}, state, {
	                CHECKOUT_INVOICE_ENTERPRISE_OPEN: CHECKOUT_INVOICE_ENTERPRISE_OPEN
	            });
	        case _ActionTypes.CHECKOUT.CHECKOUT_INVOICE_TITLEID:
	            return Object.assign({}, state, {
	                CHECKOUT_INVOICE_TITLEID: CHECKOUT_INVOICE_TITLEID
	            });
	        case _ActionTypes.CHECKOUT.CHECKOUT_INVOICE_DATA:
	            return Object.assign({}, state, {
	                CHECKOUT_INVOICE_DATA: CHECKOUT_INVOICE_DATA
	            });
	        case _ActionTypes.CHECKOUT.EXTRABUYACTID:
	            return Object.assign({}, state, {
	                EXTRABUYACTID: EXTRABUYACTID
	            });
	        case _ActionTypes.CHECKOUT.EXTRALBUYSHOWSTATUS:
	            return Object.assign({}, state, {
	                EXTRALBUYSHOWSTATUS: EXTRALBUYSHOWSTATUS
	            });
	        case _ActionTypes.CHECKOUT.EXTRABUYTITLE:
	            return Object.assign({}, state, {
	                EXTRABUYTITLE: EXTRABUYTITLE
	            });
	        case _ActionTypes.CHECKOUT.EXCHANGEPRODUCTLIST:
	            return Object.assign({}, state, {
	                EXCHANGEPRODUCTLIST: EXCHANGEPRODUCTLIST
	            });
	        case _ActionTypes.CHECKOUT.CART_TIPSMSG:
	            return Object.assign({}, state, {
	                CART_TIPSMSG: CART_TIPSMSG
	            });
	            break;
	        case _ActionTypes.CHECKOUT.DELETEPRODUCTTYPE:
	            return Object.assign({}, state, {
	                DELETEPRODUCTTYPE: DELETEPRODUCTTYPE
	            });
	            break;
	
	        default:
	            return state;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialCheckoutState = (_initialCheckoutState = {
	    CHECKOUT_PUBLIC_DATA: null,
	    CHECKOUT_DEFAULT_ADDRESS: null,
	    CHECKOUT_ORDER_ID: null,
	    CHECKOUT_INFORMATION: null,
	    CHECKOUT_CHANGE_PAYMENT: null,
	    CHECKOUT_CHANGE_RECEIVING: null,
	    CHECKOUT_TAB_GUESSYOULIKE: null,
	    CHECKOUT_TAB_MYFAVORITE: null,
	    CHECKOUT_TAB_MYBROWSERHISTORY: null,
	    CHECKOUT_TAB_LIST: [],
	    CHECKOUT_DELETE_POSITION_FIRST: null,
	    CHECKOUT_DELETE_POSITION_SECOND: null,
	    CHECKOUT_DELETE_POSITION_THIRD: null,
	    CHECKOUT_ORDER_TYPE: null,
	    CHECKOUT_DELIVERY_INFO: 1,
	    CHECKOUT_ADDRESS_COD: null,
	    CHECKOUT_ADDRESS_EXPRESS: null,
	    CHECKOUT_PURCHASED: null,
	    SET_CHECKOUT_GIFT: null,
	    CHECKOUT_CARTINFO: null,
	    CHECKOUT_ALERT: null,
	    CHECKOUT_NOTICE: null,
	    CHECKOUT_DELETE_ITEM: null,
	    CHECKOUT_GET_SKU_STANDARD: null,
	    CHECKOUT_SAVE_ALL_SKU: null,
	    CHECKOUT_SAVE_TOTAL_DELETE: null,
	    CHECKOUT_COLLECT_ITEM_ALL_LIST: null,
	    CHECKOUT_ORDER_INFORMATION: null,
	    PXCOUPONS: null,
	    PROMOTIONCODEMAP: null,
	    CHECKOUT_PAY_LINK: null,
	    CHECKOUT_THIRD_ALERT_PAY: null,
	    CHECKOUT_ORDER_STATUS: null,
	    CHECKOUT_POSITION_DELETE: null,
	    ORDER_DETAIL: null,
	    CHECKOUT_SELECT_TAB: null,
	    CHECKOUT_SAVE_ALL_SKU_LOSE: null,
	    CONTROL: 'none',
	    CHECKOUT_MISS_SKUID: [],
	    CHECKOUT_CORRESPOND_SKUID: [],
	    CHECKOUT_CORRESPOND_SKUID_BOOKING: [],
	    CHECKOUT_RESERVE_DATA: null,
	    CHECKOUT_SINGLE_SKUID: [],
	    CHECKOUT_SINGLE_SKUID_BOOKING: [],
	    CHECKOUT_RESERVE_SINGLE_DATA: null,
	    CHECKOUT_CARTINFO_BOOKING: null,
	    CHECKOUT_CHANGE_STATE: 0,
	    CHECKOUT_CHANGE_STATE_AGREEMENT: 0,
	    SATISFYGIFTCOMMENTS: "",
	    CHECKOUT_PHONE_DATA: null,
	    CHECKOUT_INPUTCOUPONS: null,
	    CHECKOUT_ALL_GIFT: null,
	    CHECKOUT_ALL_GIFT_BOOKING: null,
	    CHECKOUT_ORDER_DETAILS: null,
	    CHECKOUT_MISS_SKUID_BOOKING: [],
	    CHECKOUT_RESERVE_PROMOTION_DATA: null,
	    CHECKOUT_ADDRESS_LIST: null,
	    CHECKOUT_PHONE_STATUS: null,
	    CHECKOUT_CUR_STATUS: null,
	    CHECKOUT_CUR_TYPE: null,
	    CHECKOUT_ATTR_STATUS: null,
	    CHECKOUT_GOODS_STATUS: false,
	    CHECKOUT_SILK_CARD_LIST: null,
	    CHECKOUT_URL_PARMTER: null,
	    CHECKOUT_GET_ORDER_STATUS: null,
	    CHECKOUT_SILK_PAY_ONOFF: null,
	    CHECKOUT_CHANGE_TAB_SORT: false,
	    CHECKOUT_CART_TIME_STAMP: false,
	    CHECKOUT_TIMEING_CHECKED: 0,
	    CHECKOUT_REMEMBER_CHOOSE: null,
	    CHECKOUT_KEEP_PARAMETER: null,
	    CHECKOUT_SAVE_PARAMETER: null,
	    GETOPTIONALGIFT: [],
	    CHECKOUT_INVOICE_STATUS: 'N',
	    CHECKOUT_INVOICE_INDIVIDUAL_SAVE: false,
	    CHECKOUT_INVOICE_ENTERPRISE_SAVE: false,
	    CHECKOUT_INVOICE_ENTERPRISE_OPEN: false,
	    CHECKOUT_INVOICE_DEFAULTTITLE: {},
	    CHECKOUT_INVOICE_TITLEID: 0,
	    CHECKOUT_INVOICE_DATA: {}
	}, _defineProperty(_initialCheckoutState, 'CHECKOUT_GOODS_STATUS', ""), _defineProperty(_initialCheckoutState, 'DEPOSIT_COMMENT', ""), _defineProperty(_initialCheckoutState, 'CANCEL_ORDER_TIME_LEFT', ""), _defineProperty(_initialCheckoutState, 'SHOULDPAY', ""), _defineProperty(_initialCheckoutState, 'EXTRABUYACTID', ""), _defineProperty(_initialCheckoutState, 'EXTRABUYTITLE', ""), _defineProperty(_initialCheckoutState, 'EXCHANGEPRODUCTLIST', []), _defineProperty(_initialCheckoutState, 'CART_TIPSMSG', ""), _defineProperty(_initialCheckoutState, 'DELETEPRODUCTTYPE', ""), _initialCheckoutState);

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialDataState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var DATA_ADDRESS_PROVINCE = action.DATA_ADDRESS_PROVINCE;
	    switch (action.type) {
	        case _ActionTypes.DATA.DATA_ADDRESS_PROVINCE:
	            return Object.assign({}, state, {
	                DATA_ADDRESS_PROVINCE: DATA_ADDRESS_PROVINCE
	            });
	            break;
	        default:
	            return state;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	/**
	 *
	 * @type {{POPUP_STATE: 0:off 1: on, POPUP_MODULE: 'module_name'}}
	 */
	var initialDataState = {
	    DATA_ADDRESS_PROVINCE: null
	};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialGAState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _ActionTypes.GA.GA_DATA:
	            return Object.assign({}, state, _defineProperty({}, action.GA_EVENT_NAME, action.GA_DATA_CONTENT));
	        case _ActionTypes.GA.GA_DATA_PAGE:
	            return Object.assign({}, state, {
	                GA_DATA_EVENT: action.GA_DATA_CONTENT_PAGE
	            });
	        case _ActionTypes.GA.USER:
	            return Object.assign({}, state, {
	                USER: action.USER
	            });
	        case _ActionTypes.EMARSYS.SAVE_DATA_STATUS:
	            return Object.assign({}, state, {
	                SAVE_DATA_STATUS: action.SAVE_DATA_STATUS
	            });
	        default:
	            return state;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialGAState = {
	    GA_DATA: null,
	    GA_EVENT_NAME: 'empty',
	    GA_DATA_EVENT: null,
	    USER: false,
	
	    emarsysParamsQueue: [],
	    SAVE_DATA_STATUS: false
	};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var GOOGLE_ANALYTICS = action.GOOGLE_ANALYTICS;
	    var SENSOR = action.SENSOR;
	    switch (action.type) {
	        case _ActionTypes.DEPENDENCY.GOOGLE_ANALYTICS:
	            return Object.assign({}, state, {
	                GOOGLE_ANALYTICS: GOOGLE_ANALYTICS
	            });
	        case _ActionTypes.DEPENDENCY.SENSOR:
	            return Object.assign({}, state, {
	                SENSOR: SENSOR
	            });
	        default:
	            return state;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initialState = {
	    GOOGLE_ANALYTICS: false,
	    SENSOR: false
	};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialGlobalState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var HEIGHT = action.HEIGHT;
	    var WIDTH = action.WIDTH;
	    var SCROLL_TOP = action.SCROLL_TOP;
	    var SCROLL_BOTTOM = action.SCROLL_BOTTOM;
	    var PAGESHOW = action.PAGESHOW;
	    var CENTERMODEL = action.CENTERMODEL;
	    var BEAUTYHREF = action.BEAUTYHREF;
	    var TOPRIGHTMODEL = action.TOPRIGHTMODEL;
	    switch (action.type) {
	        case _ActionTypes.GLOBAL.SCROLL_BOTTOM:
	            return Object.assign({}, state, {
	                SCROLL_BOTTOM: SCROLL_BOTTOM
	            });
	            break;
	        case _ActionTypes.GLOBAL.HEIGHT:
	            return Object.assign({}, state, {
	                HEIGHT: HEIGHT
	            });
	            break;
	        case _ActionTypes.GLOBAL.WIDTH:
	            return Object.assign({}, state, {
	                WIDTH: WIDTH
	            });
	            break;
	        case _ActionTypes.GLOBAL.SCROLL_TOP:
	            return Object.assign({}, state, {
	                SCROLL_TOP: SCROLL_TOP
	            });
	            break;
	        case _ActionTypes.GLOBAL.PAGESHOW:
	            return Object.assign({}, state, {
	                PAGESHOW: PAGESHOW
	            });
	            break;
	        case _ActionTypes.GLOBAL.CENTERMODEL:
	            return Object.assign({}, state, {
	                CENTERMODEL: CENTERMODEL
	            });
	            break;
	        case _ActionTypes.GLOBAL.BEAUTYHREF:
	            return Object.assign({}, state, {
	                BEAUTYHREF: BEAUTYHREF
	            });
	            break;
	        case _ActionTypes.GLOBAL.TOPRIGHTMODEL:
	            return Object.assign({}, state, {
	                TOPRIGHTMODEL: TOPRIGHTMODEL
	            });
	            break;
	        default:
	            return state;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initialGlobalState = {
	    HEIGHT: null,
	    WIDTH: null,
	    SCROLL_TOP: null,
	    FIXED_TOP_SHOW: 700,
	    SCROLL_BOTTOM: 0,
	    PAGESHOW: false,
	    CENTERMODEL: {},
	    BEAUTYHREF: {},
	    TOPRIGHTMODEL: {}
	};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialHomeState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var BrandList = action.BrandIndex;
	    var SearchTrim = action.SEARCH_TRIM;
	    var TopCarousel = action.TOP_CAROUSEL;
	    var CategoryId = action.CATEGORY_ID;
	    var CategoryResponse = action.CATEGORY_RESPONSE;
	    var CategoryHover = action.CATEGORY_HOVER;
	    var CategoryHoverNickName = action.CATEGORY_NICKNAME;
	    var FixedRightTop = action.FIXED_RIGHT_TOP;
	    var FixedRightBottom = action.FIXED_RIGHT_BOTTOM;
	    var TopMenu = action.TOP_MENU;
	    var NavigationAlphabet = action.NAVIGATION_ALPHABET;
	    var FixedLeftCategory = action.FIXED_LEFT_CATEGORY;
	    var FirstOrderGift = action.FirstOrderGift;
	
	    var CategoryResponseRule = action.CATEGORY_RESPONSE_RULE;
	
	    var CategoryObject = void 0,
	        Category = void 0,
	        CategoryScrollTopObject = void 0,
	        CategoryScrollTop = void 0;
	
	    switch (action.type) {
	        case _ActionTypes.HOME.PRESS_UP_DOWN_STATIC:
	            return Object.assign({}, state, {
	                UpDownKeyCodeStatic: action.keyCode
	            });
	            break;
	        case _ActionTypes.HOME.PRESS_UP_DOWN_FIXED:
	            return Object.assign({}, state, {
	                UpDownKeyCodeFixed: action.keyCode
	            });
	            break;
	        case _ActionTypes.HOME.SEARCHHISTORY:
	            return Object.assign({}, state, {
	                SearchHistory: action.SearchHistory
	            });
	            break;
	        case _ActionTypes.HOME.SWITCHPRODUCTS:
	            return Object.assign({}, state, {
	                SwitchProducts: action.SwitchProducts
	            });
	            break;
	        // case HOME.SEARCH_BORDER: 
	        //     return Object.assign({},state,{
	        //         SearchResults:Object.assign({},state.SearchResults,{
	        //             border: action.border
	        //         })
	        //     })
	        // break;
	        // case HOME.DEFAULTMODULE: 
	        //     return Object.assign({},state,{
	        //         DefaultModule: action.DefaultModule
	        //     })
	        // break;
	        case _ActionTypes.HOME.DEFAULTPRODUCTS:
	            return Object.assign({}, state, {
	                DefaultProducts: action.DefaultProducts
	            });
	        // break;
	        // case HOME.SEARCH_RESULTS_DOWN: 
	        //     return Object.assign({},state,{
	        //         SearchResults:Object.assign({},state.SearchResults,{
	        //             down: action.down,
	        //             DefaultModule: action.DefaultModule,
	        //         })
	        //     })
	        // break;
	        case _ActionTypes.HOME.SEARCH_RESULTS_STATIC:
	            return Object.assign({}, state, {
	                SearchResultsStatic: Object.assign({}, state.SearchResultsStatic, {
	                    down: action.down,
	                    results: action.results, // 原数据
	                    suggestList: action.suggestList, // 处理后的数据
	                    suggestProductList: action.suggestProductList, // 处理后的数据
	                    DefaultModule: action.DefaultModule
	                    // DefaultProducts: action.DefaultProducts
	                })
	            });
	            break;
	        case _ActionTypes.HOME.SEARCH_RESULTS_FIXED:
	            return Object.assign({}, state, {
	                SearchResultsFixed: Object.assign({}, state.SearchResultsFixed, {
	                    down: action.down,
	                    results: action.results, // 原数据
	                    suggestList: action.suggestList, // 处理后的数据
	                    suggestProductList: action.suggestProductList, // 处理后的数据
	                    DefaultModule: action.DefaultModule
	                    // DefaultProducts: action.DefaultProducts
	                })
	            });
	            break;
	        case _ActionTypes.HOME.SEARCH_MYTIMER_STATIC:
	            return Object.assign({}, state, {
	                SearchInnerStatic: Object.assign({}, state.SearchInnerStatic, {
	                    myTimer: action.myTimer
	                })
	            });
	            break;
	        case _ActionTypes.HOME.SEARCH_MYTIMER_FIXED:
	            return Object.assign({}, state, {
	                SearchInnerFixed: Object.assign({}, state.SearchInnerFixed, {
	                    myTimer: action.myTimer
	                })
	            });
	            break;
	        case _ActionTypes.HOME.SEARCH_INNER_PLACEHOLDER_STATIC:
	            return Object.assign({}, state, {
	                SearchInnerStatic: Object.assign({}, state.SearchInnerStatic, {
	                    placeholder: action.placeholder
	                })
	            });
	            break;
	        case _ActionTypes.HOME.SEARCH_INNER_PLACEHOLDER_FIXED:
	            return Object.assign({}, state, {
	                SearchInnerFixed: Object.assign({}, state.SearchInnerFixed, {
	                    placeholder: action.placeholder
	                })
	            });
	            break;
	        case _ActionTypes.HOME.SEARCH_INNER_PLACEHOLDERS_STATIC:
	            return Object.assign({}, state, {
	                SearchInnerStatic: Object.assign({}, state.SearchInnerStatic, {
	                    placeholders: action.placeholders
	                })
	            });
	            break;
	        case _ActionTypes.HOME.SEARCH_INNER_PLACEHOLDERS_FIXED:
	            return Object.assign({}, state, {
	                SearchInnerFixed: Object.assign({}, state.SearchInnerFixed, {
	                    placeholders: action.placeholders
	                })
	            });
	            break;
	        // case HOME.SEARCH_INNER_VALUE:
	        // return Object.assign({},state,{
	        //         SearchInner:Object.assign({},state.SearchInner,{
	        //             value: action.value
	        //         })
	        //     })
	        // break;
	        case _ActionTypes.HOME.FIXED_LEFT_CATEGORY:
	            return Object.assign({}, state, {
	                FixedLeftCategory: FixedLeftCategory
	            });
	            break;
	        case _ActionTypes.HOME.CATEGORY_SCROLL_TOP:
	            CategoryScrollTopObject = { ID: action.NODES_NAME, scrollTop: action.SCROLL_TOP, content: action.CONTENT };
	            CategoryScrollTop = [].concat(_toConsumableArray(state.CategoryScrollTop), [CategoryScrollTopObject]);
	            return Object.assign({}, state, {
	                CategoryScrollTop: CategoryScrollTop
	            });
	            break;
	        case _ActionTypes.HOME.NAVIGATION_ALPHABET:
	            return Object.assign({}, state, {
	                NavigationAlphabet: NavigationAlphabet
	            });
	            break;
	        case _ActionTypes.HOME.TOP_MENU:
	            return Object.assign({}, state, {
	                TopMenu: TopMenu
	            });
	            break;
	        case _ActionTypes.HOME.FIXED_RIGHT_TOP:
	            return Object.assign({}, state, {
	                FixedRightTop: FixedRightTop
	            });
	            break;
	        case _ActionTypes.HOME.FIXED_RIGHT_BOTTOM:
	            return Object.assign({}, state, {
	                FixedRightBottom: FixedRightBottom
	            });
	            break;
	        case _ActionTypes.HOME.SEARCH_TRIM:
	            return Object.assign({}, state, {
	                SearchTrim: SearchTrim
	            });
	            break;
	        case _ActionTypes.HOME.BRAND:
	            return Object.assign({}, state, {
	                BrandList: BrandList
	            });
	            break;
	        case _ActionTypes.HOME.TOP_CAROUSEL:
	            return Object.assign({}, state, {
	                TopCarousel: TopCarousel
	            });
	            break;
	        case _ActionTypes.HOME.CATEGORY:
	            CategoryObject = {
	                ID: CategoryId,
	                Response: CategoryResponse,
	                Rule: CategoryResponseRule
	            };
	            Category = [].concat(_toConsumableArray(state.Category), [CategoryObject]);
	            return Object.assign({}, state, {
	                Category: Category
	            });
	            break;
	        case _ActionTypes.HOME.CATEGORY_HOVER:
	            return Object.assign({}, state, {
	                CategoryHover: CategoryHover,
	                CategoryHoverNickName: CategoryHoverNickName
	            });
	            break;
	        case _ActionTypes.HOME.FIRSTORDERGIFT:
	            return Object.assign({}, state, {
	                FirstOrderGift: FirstOrderGift
	            });
	            break;
	        default:
	            return state;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialHomeState = {
	    BrandList: null,
	    SearchTrim: "",
	    TopCarousel: [],
	    Category: [],
	    CategoryHover: null,
	    CategoryHoverNickName: null,
	    FixedRightTop: null,
	    FixedRightBottom: null,
	    FixedLeft: null,
	    TopMenu: null,
	    TopMenuHover: [{ content: "我的订单", link: "/myOrderList" }],
	    NavigationAlphabet: null,
	    CategoryScrollTop: [],
	    FixedLeftCategory: null,
	    SearchInnerFixed: {
	        // value: '',
	        myTimer: null,
	        placeholders: [],
	        placeholder: '请输入您要搜索的关键词'
	    },
	    SearchInnerStatic: {
	        // value: '',
	        myTimer: null,
	        placeholders: [],
	        placeholder: '请输入您要搜索的关键词'
	    },
	    SearchResultsStatic: {
	        down: 0, // 联想词展开层
	        results: null, // 联想词原数据
	        suggestList: null, // 联想词处理后的数据
	        suggestProductList: null, // 联想词处理后的数据
	        DefaultModule: 0 // 默认无词展开层
	        // DefaultProducts: null, // 默认无词数据
	    },
	    SearchResultsFixed: {
	        down: 0, // 联想词展开层
	        results: null, // 联想词原数据
	        suggestList: null, // 联想词处理后的数据
	        suggestProductList: null, // 联想词处理后的数据
	        DefaultModule: 0 // 默认无词展开层
	        // DefaultProducts: null, // 默认无词数据
	    },
	    // DefaultModule: 0,
	    DefaultProducts: null,
	    SearchHistory: null,
	    SwitchProducts: 0,
	    UpDownKeyCodeStatic: null,
	    UpDownKeyCodeFixed: null,
	    FirstOrderGift: {}
	};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        default:
	            return state;break;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initState = {
	    IMAGES: "https://sslstage1.sephorastatic.cn/soa/public/images/public_images45.gif",
	    PLACEHOLDER: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAAtJREFUCB1jYAACAAAFAAGNu5vzAAAAAElFTkSuQmCC"
	};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case _ActionTypes.INVOICELIST.INVOICELIST_DATASOURCE:
	      return Object.assign({}, state, {
	        INVOICELIST_DATASOURCE: action.INVOICELIST_DATASOURCE
	      });
	
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initialState = {
	  INVOICELIST_DATASOURCE: []
	};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case _ActionTypes.ISSUEINVOICE.DEFAULTTITLEDATA:
	      return Object.assign({}, state, {
	        DEFAULTTITLEDATA: action.DEFAULTTITLEDATA
	      });
	    case _ActionTypes.ISSUEINVOICE.INVOICEDATA:
	      return Object.assign({}, state, {
	        INVOICEDATA: action.INVOICEDATA
	      });
	    case _ActionTypes.ISSUEINVOICE.INVOICEMSG:
	      return Object.assign({}, state, {
	        INVOICEMSG: action.INVOICEMSG
	      });
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initialState = {
	  DEFAULTTITLEDATA: {},
	  INVOICEDATA: {},
	  INVOICEMSG: ''
	};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	
	        //订单详情接口数据
	        case _ActionTypes.LOCATIONS.ORDER_DETAIL:
	            return Object.assign({}, state, {
	                ORDER_DETAIL: action.ORDER_DETAIL
	            });
	            break;
	
	        //存入的orderId
	        case _ActionTypes.LOCATIONS.LOCATIONS_PARAMS:
	            return Object.assign({}, state, {
	                params: action.LOCATIONS_PARAMS
	            });
	            break;
	
	        //调取物流信息接口数据
	        case _ActionTypes.LOCATIONS.LOGISTIC_INFO:
	            return Object.assign({}, state, {
	                LOGISTIC_INFO: action.LOGISTIC_INFO
	            });
	            break;
	
	        //是否为拆单
	        case _ActionTypes.LOCATIONS.IS_SPLIT_PACKAGE:
	            return Object.assign({}, state, {
	                IS_SPLIT_PACKAGE: action.IS_SPLIT_PACKAGE
	            });
	            break;
	
	        // 广告位信息
	        case _ActionTypes.LOCATIONS.AD_TEXT:
	            return Object.assign({}, state, {
	                AD_TEXT: action.AD_TEXT
	            });
	            break;
	
	        default:
	            return state;break;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initState = {
	    params: null,
	    ORDER_DETAIL: null,
	    LOGISTIC_INFO: null,
	    IS_SPLIT_PACKAGE: null,
	    AD_TEXT: null
	};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialGAState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _ActionTypes.LOGIN_MEMBER.LOGIN_MEMBER_RESULTS:
	            return Object.assign({}, state, {
	                results: [].concat(_toConsumableArray(state.results), [action.data])
	            });
	        case _ActionTypes.LOGIN_MEMBER.LOGIN_MEMBER_UI:
	            return Object.assign({}, state, {
	                UIdata: [].concat(_toConsumableArray(state.UIdata), [action.data])
	            });
	        default:
	            return state;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialGAState = {
	    results: {},
	    UIdata: {}
	};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case actions.MESSAGECENTER.MESSAGECENTER_TYPE:
	      return Object.assign({}, state, {
	        MESSAGECENTER_TYPE: action.MESSAGECENTER_TYPE
	      });
	    case actions.MESSAGECENTER.PAGINATION_TOTAL:
	      return Object.assign({}, state, {
	        PAGINATION_TOTAL: action.PAGINATION_TOTAL
	      });
	    case actions.MESSAGECENTER.PAGINATION_CURRENT:
	      return Object.assign({}, state, {
	        PAGINATION_CURRENT: action.PAGINATION_CURRENT
	      });
	    case actions.MESSAGECENTER.MYMESSAGE_DATASOURCE:
	      return Object.assign({}, state, {
	        MYMESSAGE_DATASOURCE: action.MYMESSAGE_DATASOURCE
	      });
	    case actions.MESSAGECENTER.INFO_DATASOURCE:
	      return Object.assign({}, state, {
	        INFO_DATASOURCE: action.INFO_DATASOURCE
	      });
	    case actions.MESSAGECENTER.HASNEWMESSAGE:
	      return Object.assign({}, state, {
	        HASNEWMESSAGE: action.HASNEWMESSAGE
	      });
	    case actions.MESSAGECENTER.HASNEWINFO:
	      return Object.assign({}, state, {
	        HASNEWINFO: action.HASNEWINFO
	      });
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var actions = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = {
	  MESSAGECENTER_TYPE: '1',
	  PAGINATION_CURRENT: 1,
	  PAGINATION_TOTAL: 0,
	  MYMESSAGE_DATASOURCE: [],
	  INFO_DATASOURCE: [],
	  HASNEWMESSAGE: 0,
	  HASNEWINFO: 0
	};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialADState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    //查询收货地址列表
	    case _ActionTypes.MY_AD.MY_AD_LISTS:
	      return Object.assign({}, state, {
	        MY_AD_LISTS: action.MY_AD_LISTS
	      });
	    //设置默认地址
	    case _ActionTypes.MY_AD.MY_AD_DEFAULT:
	      return Object.assign({}, state, {
	        MY_AD_DEFAULT: action.MY_AD_DEFAULT
	      });
	
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initialADState = {
	  MY_AD_LISTS: null
	};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialMyAccountOnlineReturnState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_STATUS_TYPE_MODULE:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_STATUS_TYPE_MODULE: action.MY_ONLINE_RETURN_STATUS_TYPE_MODULE
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_NOW_YEAR:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_NOW_YEAR: action.MY_ONLINE_RETURN_NOW_YEAR
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_LIST_MODULE:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_LIST_MODULE: action.MY_ONLINE_RETURN_LIST_MODULE,
	                MY_ONLINE_RETURN_PAGE_TOTAL: action.MY_ONLINE_RETURN_PAGE_TOTAL,
	                MY_ONLINE_RETURN_SHOW_COMMENTS: action.MY_ONLINE_RETURN_SHOW_COMMENTS
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_HISTORY:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_PAGE_CURRENT: action.MY_ONLINE_RETURN_PAGE_CURRENT,
	                MY_ONLINE_RETURN_NOW_TIME_VALUE: action.MY_ONLINE_RETURN_NOW_TIME_VALUE,
	                MY_ONLINE_RETURN_NOW_TIME_VALUE_CODE: action.MY_ONLINE_RETURN_NOW_TIME_VALUE_CODE,
	                MY_ONLINE_RETURN_NOW_STATUS_VALUE: action.MY_ONLINE_RETURN_NOW_STATUS_VALUE,
	                MY_ONLINE_RETURN_NOW_STATUS_CODE: action.MY_ONLINE_RETURN_NOW_STATUS_CODE,
	                MY_ONLINE_RETURN_STATUS_TYPE: action.MY_ONLINE_RETURN_STATUS_TYPE
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_NEW_TIME:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_PAGE_CURRENT: action.MY_ONLINE_RETURN_PAGE_CURRENT,
	                MY_ONLINE_RETURN_NOW_TIME_VALUE: action.MY_ONLINE_RETURN_NOW_TIME_VALUE,
	                MY_ONLINE_RETURN_NOW_TIME_VALUE_CODE: action.MY_ONLINE_RETURN_NOW_TIME_VALUE_CODE,
	                MY_ONLINE_RETURN_TIME_MODULE_SHOW: action.MY_ONLINE_RETURN_TIME_MODULE_SHOW
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_TIME_MODULE_SHOW:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_TIME_MODULE_SHOW: action.MY_ONLINE_RETURN_TIME_MODULE_SHOW
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_STATUS_TYPE:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_STATUS_TYPE: action.MY_ONLINE_RETURN_STATUS_TYPE
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_NEW_STATUS:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_PAGE_CURRENT: action.MY_ONLINE_RETURN_PAGE_CURRENT,
	                MY_ONLINE_RETURN_NOW_STATUS_VALUE: action.MY_ONLINE_RETURN_NOW_STATUS_VALUE,
	                MY_ONLINE_RETURN_NOW_STATUS_CODE: action.MY_ONLINE_RETURN_NOW_STATUS_CODE,
	                MY_ONLINE_RETURN_STATUS_MODULE_SHOW: action.MY_ONLINE_RETURN_STATUS_MODULE_SHOW
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_STATUS_MODULE_SHOW:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_STATUS_MODULE_SHOW: action.MY_ONLINE_RETURN_STATUS_MODULE_SHOW
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_NEW_TAB:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_PAGE_CURRENT: action.MY_ONLINE_RETURN_PAGE_CURRENT,
	                MY_ONLINE_RETURN_NOW_STATUS_VALUE: action.MY_ONLINE_RETURN_NOW_STATUS_VALUE,
	                MY_ONLINE_RETURN_NOW_STATUS_CODE: action.MY_ONLINE_RETURN_NOW_STATUS_CODE,
	                MY_ONLINE_RETURN_STATUS_TYPE: action.MY_ONLINE_RETURN_STATUS_TYPE
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_PAGE_CURRENT:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_PAGE_CURRENT: action.MY_ONLINE_RETURN_PAGE_CURRENT
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_SHOW_COMMENTS:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_SHOW_COMMENTS: action.MY_ONLINE_RETURN_SHOW_COMMENTS
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_COMMENTS_NOW_OP:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_COMMENTS_NOW_OP: action.MY_ONLINE_RETURN_COMMENTS_NOW_OP,
	                MY_ONLINE_RETURN_COMMENTS_NOW_ORDER_ID: action.MY_ONLINE_RETURN_COMMENTS_NOW_ORDER_ID,
	                MY_ONLINE_RETURN_COMMENTS_NOW_SKUID: action.MY_ONLINE_RETURN_COMMENTS_NOW_SKUID,
	                MY_ONLINE_RETURN_SHOW_COMMENTS: action.MY_ONLINE_RETURN_SHOW_COMMENTS
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_DOWN_PAY_BOX_SHOW:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_DOWN_PAY_BOX_SHOW: action.MY_ONLINE_RETURN_DOWN_PAY_BOX_SHOW,
	                MY_ONLINE_RETURN_NOW_PAY_ORDER_ID: action.MY_ONLINE_RETURN_NOW_PAY_ORDER_ID,
	                MY_ONLINE_RETURN_NOW_PAY_MONEY: action.MY_ONLINE_RETURN_NOW_PAY_MONEY
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_CANCEL_REASON_SHOW:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_CANCEL_REASON_SHOW: action.MY_ONLINE_RETURN_CANCEL_REASON_SHOW
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_ORDER_ID:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_CANCEL_REASON_SHOW: action.MY_ONLINE_RETURN_CANCEL_REASON_SHOW,
	                MY_ONLINE_RETURN_ORDER_ID: action.MY_ONLINE_RETURN_ORDER_ID,
	                MY_ONLINE_RETURN_CANCEL_REASON_STATUS: action.MY_ONLINE_RETURN_CANCEL_REASON_STATUS
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_LOGISTIC_SHOW:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_LOGISTIC_SHOW: action.MY_ONLINE_RETURN_LOGISTIC_SHOW,
	                MY_ONLINE_RETURN_LOGISTIC_MODEL: action.MY_ONLINE_RETURN_LOGISTIC_MODEL,
	                MY_ONLINE_RETURN_LOGISTIC_INDEX: action.MY_ONLINE_RETURN_LOGISTIC_INDEX
	            });
	            break;
	
	        case _ActionTypes.MY_ONLINE_RETURN.MY_ONLINE_RETURN_USER_PROFILE:
	            return Object.assign({}, state, {
	                MY_ONLINE_RETURN_USER_PROFILE: action.MY_ONLINE_RETURN_USER_PROFILE
	            });
	            break;
	
	        default:
	            return state;
	            break;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initialMyAccountOnlineReturnState = {
	    MY_ONLINE_RETURN_NOW_YEAR: 2010,
	    MY_ONLINE_RETURN_STATUS_TYPE_MODULE: '',
	    MY_ONLINE_RETURN_STATUS_TYPE: [1, 0, 0],
	    MY_ONLINE_RETURN_TIME_MODULE_SHOW: false,
	    MY_ONLINE_RETURN_NOW_TIME_VALUE: '最近三个月订单',
	    MY_ONLINE_RETURN_NOW_TIME_VALUE_CODE: 'Q',
	    MY_ONLINE_RETURN_NOW_STATUS_CODE: '',
	    MY_ONLINE_RETURN_PAGE_CURRENT: 1,
	    MY_ONLINE_RETURN_PAGE_TOTAL: 0,
	    MY_ONLINE_RETURN_LIST_MODULE: [],
	    MY_ONLINE_RETURN_SHOW_COMMENTS: false,
	    MY_ONLINE_RETURN_STATUS_MODULE_SHOW: false,
	    MY_ONLINE_RETURN_NOW_STATUS_VALUE: '全部状态',
	    MY_ONLINE_RETURN_COMMENTS_NOW_OP: '',
	    MY_ONLINE_RETURN_COMMENTS_NOW_ORDER_ID: '',
	    MY_ONLINE_RETURN_COMMENTS_NOW_SKUID: '',
	    MY_ONLINE_RETURN_NOW_PAY_ORDER_ID: '',
	    MY_ONLINE_RETURN_NOW_PAY_MONEY: '',
	    MY_ONLINE_RETURN_DOWN_PAY_BOX_SHOW: false,
	    MY_ONLINE_RETURN_CANCEL_REASON_SHOW: false,
	    MY_ONLINE_RETURN_ORDER_ID: '',
	    MY_ONLINE_RETURN_LOGISTIC_SHOW: false,
	    MY_ONLINE_RETURN_LOGISTIC_MODEL: '',
	    MY_ONLINE_RETURN_LOGISTIC_INDEX: null,
	    MY_ONLINE_RETURN_CANCEL_REASON_STATUS: null,
	    MY_ONLINE_RETURN_USER_PROFILE: null
	};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialMyAccountOrderState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_STATUS_TYPE_MODULE:
	            return Object.assign({}, state, {
	                MY_ORDER_STATUS_TYPE_MODULE: action.MY_ORDER_STATUS_TYPE_MODULE
	            });
	            break;
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_NOW_YEAR:
	            return Object.assign({}, state, {
	                MY_ORDER_NOW_YEAR: action.MY_ORDER_NOW_YEAR
	            });
	            break;
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_LIST_MODULE:
	            return Object.assign({}, state, {
	                MY_ORDER_LIST_MODULE: action.MY_ORDER_LIST_MODULE,
	                MY_ORDER_PAGE_TOTAL: action.MY_ORDER_PAGE_TOTAL,
	                MY_ORDER_SHOW_COMMENTS: action.MY_ORDER_SHOW_COMMENTS
	            });
	            break;
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_HISTORY:
	            return Object.assign({}, state, {
	                MY_ORDER_PAGE_CURRENT: action.MY_ORDER_PAGE_CURRENT,
	                MY_ORDER_NOW_TIME_VALUE: action.MY_ORDER_NOW_TIME_VALUE,
	                MY_ORDER_NOW_TIME_VALUE_CODE: action.MY_ORDER_NOW_TIME_VALUE_CODE,
	                MY_ORDER_NOW_STATUS_VALUE: action.MY_ORDER_NOW_STATUS_VALUE,
	                MY_ORDER_NOW_STATUS_CODE: action.MY_ORDER_NOW_STATUS_CODE,
	                MY_ORDER_STATUS_TYPE: action.MY_ORDER_STATUS_TYPE
	            });
	            break;
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_NEW_TIME:
	            return Object.assign({}, state, {
	                MY_ORDER_PAGE_CURRENT: action.MY_ORDER_PAGE_CURRENT,
	                MY_ORDER_NOW_TIME_VALUE: action.MY_ORDER_NOW_TIME_VALUE,
	                MY_ORDER_NOW_TIME_VALUE_CODE: action.MY_ORDER_NOW_TIME_VALUE_CODE,
	                MY_ORDER_TIME_MODULE_SHOW: action.MY_ORDER_TIME_MODULE_SHOW
	            });
	            break;
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_TIME_MODULE_SHOW:
	            return Object.assign({}, state, {
	                MY_ORDER_TIME_MODULE_SHOW: action.MY_ORDER_TIME_MODULE_SHOW
	            });
	            break;
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_STATUS_TYPE:
	            return Object.assign({}, state, {
	                MY_ORDER_STATUS_TYPE: action.MY_ORDER_STATUS_TYPE
	            });
	            break;
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_NEW_STATUS:
	            return Object.assign({}, state, {
	                MY_ORDER_PAGE_CURRENT: action.MY_ORDER_PAGE_CURRENT,
	                MY_ORDER_NOW_STATUS_VALUE: action.MY_ORDER_NOW_STATUS_VALUE,
	                MY_ORDER_NOW_STATUS_CODE: action.MY_ORDER_NOW_STATUS_CODE,
	                MY_ORDER_STATUS_MODULE_SHOW: action.MY_ORDER_STATUS_MODULE_SHOW
	            });
	            break;
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_STATUS_MODULE_SHOW:
	            return Object.assign({}, state, {
	                MY_ORDER_STATUS_MODULE_SHOW: action.MY_ORDER_STATUS_MODULE_SHOW
	            });
	            break;
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_NEW_TAB:
	            return Object.assign({}, state, {
	                MY_ORDER_PAGE_CURRENT: action.MY_ORDER_PAGE_CURRENT,
	                MY_ORDER_NOW_STATUS_VALUE: action.MY_ORDER_NOW_STATUS_VALUE,
	                MY_ORDER_NOW_STATUS_CODE: action.MY_ORDER_NOW_STATUS_CODE,
	                MY_ORDER_STATUS_TYPE: action.MY_ORDER_STATUS_TYPE
	            });
	            break;
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_PAGE_CURRENT:
	            return Object.assign({}, state, {
	                MY_ORDER_PAGE_CURRENT: action.MY_ORDER_PAGE_CURRENT
	            });
	            break;
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_SHOW_COMMENTS:
	            return Object.assign({}, state, {
	                MY_ORDER_SHOW_COMMENTS: action.MY_ORDER_SHOW_COMMENTS
	            });
	            break;
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_COMMENTS_NOW_OP:
	            return Object.assign({}, state, {
	                MY_ORDER_COMMENTS_NOW_OP: action.MY_ORDER_COMMENTS_NOW_OP,
	                MY_ORDER_COMMENTS_NOW_ORDER_ID: action.MY_ORDER_COMMENTS_NOW_ORDER_ID,
	                MY_ORDER_COMMENTS_NOW_SKUID: action.MY_ORDER_COMMENTS_NOW_SKUID,
	                MY_ORDER_SHOW_COMMENTS: action.MY_ORDER_SHOW_COMMENTS
	            });
	            break;
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_DOWN_PAY_BOX_SHOW:
	            return Object.assign({}, state, {
	                MY_ORDER_DOWN_PAY_BOX_SHOW: action.MY_ORDER_DOWN_PAY_BOX_SHOW,
	                MY_ORDER_NOW_PAY_ORDER_ID: action.MY_ORDER_NOW_PAY_ORDER_ID,
	                MY_ORDER_NOW_PAY_MONEY: action.MY_ORDER_NOW_PAY_MONEY
	            });
	            break;
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_CANCEL_REASON_SHOW:
	            return Object.assign({}, state, {
	                MY_ORDER_CANCEL_REASON_SHOW: action.MY_ORDER_CANCEL_REASON_SHOW
	            });
	            break;
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_ORDER_ID:
	            return Object.assign({}, state, {
	                MY_ORDER_CANCEL_REASON_SHOW: action.MY_ORDER_CANCEL_REASON_SHOW,
	                MY_ORDER_ORDER_ID: action.MY_ORDER_ORDER_ID,
	                MY_ORDER_CANCEL_REASON_LIST: action.MY_ORDER_CANCEL_REASON_LIST,
	                MY_ORDER_CANCEL_REASON_STATUS: action.MY_ORDER_CANCEL_REASON_STATUS,
	                MY_ORDER_CANCEL_REASON_TYPE: action.MY_ORDER_CANCEL_REASON_TYPE
	            });
	            break;
	
	        case _ActionTypes.MY_ORDER.MY_ORDER_LOGISTIC_SHOW:
	            return Object.assign({}, state, {
	                MY_ORDER_LOGISTIC_SHOW: action.MY_ORDER_LOGISTIC_SHOW,
	                MY_ORDER_LOGISTIC_MODEL: action.MY_ORDER_LOGISTIC_MODEL,
	                MY_ORDER_LOGISTIC_INDEX: action.MY_ORDER_LOGISTIC_INDEX
	            });
	            break;
	        case _ActionTypes.MY_ORDER.PAY_TOGETHER_POPUP_TOOGLE:
	            return Object.assign({}, state, {
	                PAY_TOGETHER_POPUP_TOOGLE: action.PAY_TOGETHER_POPUP_TOOGLE,
	                MERGE_ORDERS: action.MERGE_ORDERS
	            });
	            break;
	        case _ActionTypes.MY_ORDER.MY_ORDER_ORDER_CHECK:
	            return Object.assign({}, state, {
	                MY_ORDER_ORDER_CHECK: action.MY_ORDER_ORDER_CHECK
	            });
	            break;
	        case _ActionTypes.MY_ORDER.DEPOSIT_COMMENT:
	            return Object.assign({}, state, {
	                DEPOSIT_COMMENT: action.DEPOSIT_COMMENT
	            });
	            break;
	
	        default:
	            return state;
	            break;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initialMyAccountOrderState = {
	    MY_ORDER_NOW_YEAR: 2010,
	    MY_ORDER_STATUS_TYPE_MODULE: '',
	    MY_ORDER_STATUS_TYPE: [1, 0, 0, 0, 0],
	    MY_ORDER_TIME_MODULE_SHOW: false,
	    MY_ORDER_NOW_TIME_VALUE: '最近三个月订单',
	    MY_ORDER_NOW_TIME_VALUE_CODE: 'Q',
	    MY_ORDER_NOW_STATUS_CODE: '',
	    MY_ORDER_PAGE_CURRENT: 1,
	    MY_ORDER_PAGE_TOTAL: 0,
	    MY_ORDER_LIST_MODULE: [],
	    MY_ORDER_SHOW_COMMENTS: false,
	    MY_ORDER_STATUS_MODULE_SHOW: false,
	    MY_ORDER_NOW_STATUS_VALUE: '全部状态',
	    MY_ORDER_COMMENTS_NOW_OP: '',
	    MY_ORDER_COMMENTS_NOW_ORDER_ID: '',
	    MY_ORDER_COMMENTS_NOW_SKUID: '',
	    MY_ORDER_NOW_PAY_ORDER_ID: '',
	    MY_ORDER_NOW_PAY_MONEY: '',
	    MY_ORDER_DOWN_PAY_BOX_SHOW: false,
	    MY_ORDER_CANCEL_REASON_SHOW: false,
	    MY_ORDER_CANCEL_REASON_LIST: ["更换或添加新商品", "错过促销活动", "重复下单", "现在不想购买", "去门店购买", "支付不成功", "等待时间过长", "更换支付方式", "其他"],
	    MY_ORDER_ORDER_ID: '',
	    MY_ORDER_LOGISTIC_SHOW: false,
	    MY_ORDER_LOGISTIC_MODEL: '',
	    MY_ORDER_LOGISTIC_INDEX: null,
	    MY_ORDER_CANCEL_REASON_STATUS: null,
	    PAY_TOGETHER_POPUP_TOOGLE: false,
	    MY_ORDER_ORDER_CHECK: []
	};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialQAState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	        //列表页码
	        case _ActionTypes.MY_QA.MY_QA_LIST_PAGE:
	            return Object.assign({}, state, {
	                MY_QA_LIST_PAGE: action.MY_QA_LIST_PAGE
	            });
	            break;
	
	        default:
	            return state;break;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initialQAState = {
	    MY_QA_LIST_PAGE: null
	};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * @Author: Hallie Liu 
	 * @Date: 2019-04-07 20:12:04 
	 * @Last Modified by:   Hallie Liu 
	 * @Last Modified time: 2019-04-07 20:12:04 
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _ActionTypes.NICHEFRAGRANCE.SCENESTATUS:
	            return Object.assign({}, state, {
	                SCENESTATUS: action.SCENESTATUS
	            });
	            break;
	        case _ActionTypes.NICHEFRAGRANCE.PRELOADSTATUS:
	            return Object.assign({}, state, {
	                PRELOADSTATUS: action.PRELOADSTATUS
	            });
	            break;
	        // case NICHEFRAGRANCE.CAROUSEL_ORDER :
	        //     return Object.assign({},state,{
	        //         CAROUSEL_ORDER:action.CAROUSEL_ORDER
	        //     });
	        // break;
	        // case NICHEFRAGRANCE.CURRENT_SCENE :
	        //     return Object.assign({},state,{
	        //         CURRENT_SCENE:action.CURRENT_SCENE
	        //     });
	        // break;
	        // case NICHEFRAGRANCE.ENTRANCPRELOADED :
	        // return Object.assign({},state,{
	        //     ENTRANCPRELOADED:action.ENTRANCPRELOADED
	        // });
	        // break;
	        // case NICHEFRAGRANCE.CURRENTBRANDPRELOADED :
	        // return Object.assign({},state,{
	        //     CURRENTBRANDPRELOADED:action.CURRENTBRANDPRELOADED
	        // });
	        // break;
	        case _ActionTypes.NICHEFRAGRANCE.MORE_PRODUCTS:
	            return Object.assign({}, state, {
	                MORE_PRODUCTS: action.MORE_PRODUCTS
	            });
	            break;
	        case _ActionTypes.NICHEFRAGRANCE.MYVIDEO:
	            return Object.assign({}, state, {
	                MYVIDEO: action.MYVIDEO
	            });
	            break;
	        case _ActionTypes.NICHEFRAGRANCE.DRAWER:
	            return Object.assign({}, state, {
	                DRAWER: action.DRAWER
	            });
	            break;
	        case _ActionTypes.NICHEFRAGRANCE.MYSOURCEDATA:
	            return Object.assign({}, state, {
	                MYSOURCEDATA: action.MYSOURCEDATA
	            });
	            break;
	        case _ActionTypes.NICHEFRAGRANCE.PAGINATION:
	            return Object.assign({}, state, {
	                PAGINATION: action.PAGINATION
	            });
	            break;
	
	        default:
	            return state;break;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initState = {
	    // CAROUSEL_ORDER: 1,
	    // CURRENT_SCENE: 0,
	    // ENTRANCPRELOADED: false,
	    // CURRENTBRANDPRELOADED: false,
	    MORE_PRODUCTS: false,
	    MYSOURCEDATA: {},
	    DRAWER: false,
	    MYVIDEO: '',
	    PAGINATION: null,
	    SCENESTATUS: {
	        CAROUSEL_ORDER: 1,
	        CURRENT_SCENE: 0
	    },
	    PRELOADSTATUS: {
	        ENTRANCPRELOADED: false,
	        CURRENTBRANDPRELOADED: false
	    }
	};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case _ActionTypes.ONLINERETURN.RETURN_APPLY:
	      return Object.assign({}, state, {
	        RETURN_APPLY: action.params
	      });
	    case _ActionTypes.ONLINERETURN.RETURN_INFO:
	      return Object.assign({}, state, {
	        RETURN_INFO: action.params
	      });
	    case _ActionTypes.ONLINERETURN.RETURN_PAY_INFO:
	      return Object.assign({}, state, {
	        RETURN_PAY_INFO: action.params
	      });
	    case _ActionTypes.ONLINERETURN.ORDER_PRD_DETAIL:
	      return Object.assign({}, state, {
	        ORDER_PRD_DETAIL: action.params
	      });
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initState = {
	  RETURN_APPLY: null,
	  RETURN_INFO: null,
	  RETURN_PAY_INFO: null,
	  ORDER_PRD_DETAIL: null
	};

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialPopupState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case "POPUP_LIMITION_BUY_DATA":
	            return Object.assign({}, state, {
	                DATA_LIST: action.DATA_LIST
	            });
	
	        case "POPUP_LIMITION_BUY_SHOW":
	            return Object.assign({}, state, {
	                NOW_STEP: action.NOW_STEP,
	                BOX_SHOW: action.BOX_SHOW,
	                SUCCESS_HANDLE: action.SUCCESS_HANDLE
	            });
	
	        case "POPUP_LIMITION_BUY_TIP_SHOW":
	            return Object.assign({}, state, {
	                TIP_SHOW: action.TIP_SHOW
	            });
	
	        default:
	            return state;
	    }
	};
	
	var initialPopupState = {
	    DATA_LIST: null,
	
	    TIP_SHOW: false,
	
	    NOW_STEP: 1,
	    BOX_SHOW: false,
	    SUCCESS_HANDLE: null
	};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialPopupState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var POPUP_STATE = action.POPUP_STATE,
	      POPUP_MODULE = action.POPUP_MODULE,
	      POPUP_PARAMETERS = action.POPUP_PARAMETERS,
	      POPUP_CALLBACK_KEY = action.POPUP_CALLBACK_KEY,
	      POPUP_CALLBACK_VALUE = action.POPUP_CALLBACK_VALUE;
	  switch (action.type) {
	    case _ActionTypes.POPUP_ADDRESS.POPUP_STATE:
	      return Object.assign({}, state, {
	        POPUP_STATE: POPUP_STATE,
	        POPUP_MODULE: POPUP_MODULE,
	        POPUP_PARAMETERS: POPUP_PARAMETERS,
	        POPUP_CALLBACK_KEY: POPUP_CALLBACK_KEY,
	        POPUP_CALLBACK_VALUE: POPUP_CALLBACK_VALUE
	      });
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	/**
	 *
	 * @POPUP_STATE: 0:off 1: on
	 * @POPUP_MODULE: module_name
	 * @POPUP_PARAMETERS: parameters
	 * @POPUP_CALLBACK_KEY: callback(key)
	 * @POPUP_CALLBACK_VALUE: callback(value)
	 */
	var initialPopupState = {
	  POPUP_STATE: 0,
	  POPUP_MODULE: null,
	  POPUP_PARAMETERS: null,
	  POPUP_CALLBACK_KEY: null,
	  POPUP_CALLBACK_VALUE: null
	};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialPopupState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var POPUP_STATE = action.POPUP_STATE;
	    var POPUP_MODULE = action.POPUP_MODULE;
	    var POPUP_PARAMETERS = action.POPUP_PARAMETERS;
	    var POPUP_CALLBACK_KEY = action.POPUP_CALLBACK_KEY;
	    var POPUP_CALLBACK_VALUE = action.POPUP_CALLBACK_VALUE;
	    switch (action.type) {
	        case _ActionTypes.POPUP_ALERT.POPUP_STATE:
	            return Object.assign({}, state, {
	                POPUP_STATE: POPUP_STATE,
	                POPUP_MODULE: POPUP_MODULE,
	                POPUP_PARAMETERS: POPUP_PARAMETERS,
	                POPUP_CALLBACK_KEY: POPUP_CALLBACK_KEY,
	                POPUP_CALLBACK_VALUE: POPUP_CALLBACK_VALUE
	            });
	            break;
	        default:
	            return state;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	/**
	 *
	 * @type {{POPUP_STATE: 0:off 1: on, POPUP_MODULE: 'module_name'}}
	 */
	var initialPopupState = {
	    POPUP_STATE: 0,
	    POPUP_MODULE: null,
	    POPUP_PARAMETERS: null,
	    POPUP_CALLBACK_KEY: null,
	    POPUP_CALLBACK_VALUE: null
	};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialPopupState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var POPUP_STATE = action.POPUP_STATE;
	    var POPUP_MODULE = action.POPUP_MODULE;
	    var POPUP_PARAMETERS = action.POPUP_PARAMETERS;
	    var POPUP_CALLBACK_KEY = action.POPUP_CALLBACK_KEY;
	    var POPUP_CALLBACK_VALUE = action.POPUP_CALLBACK_VALUE;
	
	    var POPUP_PUBLIC_STEP = action.POPUP_PUBLIC_STEP;
	    var POPUP_PUBLIC_KEY = action.POPUP_PUBLIC_KEY;
	    var POPUP_PUBLIC_CALLBACK = action.POPUP_PUBLIC_CALLBACK;
	
	    switch (action.type) {
	
	        case _ActionTypes.POPUP_COMPONENT.POPUP_STATE:
	            return Object.assign({}, state, {
	                POPUP_STATE: POPUP_STATE,
	                POPUP_MODULE: POPUP_MODULE,
	                POPUP_PARAMETERS: POPUP_PARAMETERS,
	                POPUP_CALLBACK_KEY: POPUP_CALLBACK_KEY,
	                POPUP_CALLBACK_VALUE: POPUP_CALLBACK_VALUE
	            });
	
	        /*公共的弹层*/
	        case _ActionTypes.POPUP_COMPONENT.POPUP_PUBLIC_STEP:
	            return Object.assign({}, state, {
	                POPUP_PUBLIC_STEP: POPUP_PUBLIC_STEP,
	                POPUP_PUBLIC_KEY: POPUP_PUBLIC_KEY,
	                POPUP_PUBLIC_CALLBACK: POPUP_PUBLIC_CALLBACK
	            });
	
	        default:
	            return state;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	/**
	 *
	 * @POPUP_STATE: 0:off 1: on
	 * @POPUP_MODULE: module_name
	 * @POPUP_PARAMETERS: parameters
	 * @POPUP_CALLBACK_KEY: callback(key)
	 * @POPUP_CALLBACK_VALUE: callback(value)
	 */
	var initialPopupState = {
	    POPUP_STATE: 0,
	    POPUP_MODULE: null,
	    POPUP_PARAMETERS: null,
	    POPUP_CALLBACK_KEY: null,
	    POPUP_CALLBACK_VALUE: null,
	
	    POPUP_PUBLIC_STEP: 0,
	    POPUP_PUBLIC_KEY: null,
	    POPUP_PUBLIC_CALLBACK: null
	};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialPDPState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    //产品失效或者接口有问题跳转至404模块
	    case _ActionTypes.PDP.PRODUCT_DETAIL_ERROR:
	      return Object.assign({}, state, {
	        PRODUCT_DETAIL_ERROR: action.PRODUCT_DETAIL_ERROR
	      });
	
	    //主数据
	    case _ActionTypes.PDP.PRODUCT_DETAIL_MAIN:
	      return Object.assign({}, state, {
	        PRODUCT_DETAIL_MAIN: action.PRODUCT_DETAIL_MAIN
	      });
	
	    //产品主数据
	    case _ActionTypes.PDP.PRODUCT_SKU_DETAIL_INFO:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_DETAIL_INFO: action.PRODUCT_SKU_DETAIL_INFO
	      });
	
	    //产品主数据html
	    case _ActionTypes.PDP.PRODUCT_SKU_HTML:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_HTML: action.PRODUCT_SKU_HTML,
	        PRODUCT_SKU_DETAIL_INFO: action.PRODUCT_SKU_DETAIL_INFO
	      });
	
	    //产品图片
	    case _ActionTypes.PDP.PRODUCT_DETAIL_IMAGE:
	      // if(action.PRODUCT_DETAIL_IMAGE[0] && action.PRODUCT_DETAIL_IMAGE[0].skuImagePath){
	      return Object.assign({}, state, {
	        PRODUCT_DETAIL_IMAGE: action.PRODUCT_DETAIL_IMAGE,
	        PRODUCT_DETAIL_IMAGE_NOW: action.PRODUCT_DETAIL_IMAGE[0] && action.PRODUCT_DETAIL_IMAGE[0].skuImagePath || null,
	        PRODUCT_DETAIL_IMAGE_NOW_TAG: action.PRODUCT_DETAIL_IMAGE[0] && action.PRODUCT_DETAIL_IMAGE[0].activityLabelImageUrl || null,
	        PRODUCT_DETAIL_IMAGE_NOW_INDEX: 0
	      });
	    // }else{
	    //     return Object.assign({},state,{
	    //         PRODUCT_DETAIL_IMAGE : action.PRODUCT_DETAIL_IMAGE,
	    //         PRODUCT_DETAIL_IMAGE_NOW : null,
	    //         PRODUCT_DETAIL_IMAGE_NOW_TAG:action.PRODUCT_DETAIL_IMAGE[0].activityLabelImageUrl,
	    //         PRODUCT_DETAIL_IMAGE_NOW_INDEX : 0
	    //     });
	    // }
	    //当前的产品图片
	    case _ActionTypes.PDP.PRODUCT_DETAIL_IMAGE_NOW:
	      return Object.assign({}, state, {
	        PRODUCT_DETAIL_IMAGE_NOW: action.PRODUCT_DETAIL_IMAGE_NOW,
	        PRODUCT_DETAIL_IMAGE_NOW_TAG: action.PRODUCT_DETAIL_IMAGE_NOW_TAG,
	        PRODUCT_DETAIL_IMAGE_NOW_INDEX: action.PRODUCT_DETAIL_IMAGE_NOW_INDEX
	      });
	    //当前的产品图片位置
	    case _ActionTypes.PDP.PRODUCT_DETAIL_IMAGE_NOW_INDEX:
	      return Object.assign({}, state, {
	        PRODUCT_DETAIL_IMAGE_NOW_INDEX: action.PRODUCT_DETAIL_IMAGE_NOW_INDEX
	      });
	
	    //面包削
	    case _ActionTypes.PDP.PRODUCT_BREADCRUMB:
	      return Object.assign({}, state, {
	        PRODUCT_BREADCRUMB: action.PRODUCT_BREADCRUMB
	      });
	
	    //获取评论列表
	    case _ActionTypes.PDP.PRODUCT_COMMENTS_LIST:
	      return Object.assign({}, state, {
	        PRODUCT_COMMENTS_LIST: action.PRODUCT_COMMENTS_LIST
	      });
	    //获取评论列表--页码
	    case _ActionTypes.PDP.PRODUCT_COMMENTS_LIST_PAGE:
	      return Object.assign({}, state, {
	        PRODUCT_COMMENTS_LIST_PAGE: action.PRODUCT_COMMENTS_LIST_PAGE
	      });
	
	    //获取QA列表
	    case _ActionTypes.PDP.PRODUCT_QA_LIST:
	      return Object.assign({}, state, {
	        PRODUCT_QA_LIST: action.PRODUCT_QA_LIST
	      });
	    //获取QA列表--页码
	    case _ActionTypes.PDP.PRODUCT_QA_LIST_PAGE:
	      return Object.assign({}, state, {
	        PRODUCT_QA_LIST_PAGE: action.PRODUCT_QA_LIST_PAGE
	      });
	    //校验用户一年内是否有购买记录
	    case _ActionTypes.PDP.PRODUCT_USER_BUY_ONE_YEAR:
	      return Object.assign({}, state, {
	        PRODUCT_USER_BUY_ONE_YEAR: action.PRODUCT_USER_BUY_ONE_YEAR
	      });
	
	    //搭配推荐
	    case _ActionTypes.PDP.PRODUCT_COLLOCATION:
	      return Object.assign({}, state, {
	        PRODUCT_COLLOCATION: action.PRODUCT_COLLOCATION
	      });
	
	    //sku促销信息
	    case _ActionTypes.PDP.PRODUCT_SKU_PROMOTION_INFO:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_PROMOTION_INFO: action.PRODUCT_SKU_PROMOTION_INFO,
	        PRODUCT_SKU_PROMOTION_INFO_SHOW_MORE: false,
	        PRODUCT_SKU_PROMOTION_COLOR_SHOW_MORE: false,
	        PRODUCT_SKU_PROMOTION_COLOR_SELECTOR_SHOW_MORE: false
	      });
	    //是否展示所有的sku促销信息
	    case _ActionTypes.PDP.PRODUCT_SKU_PROMOTION_INFO_SHOW_MORE:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_PROMOTION_INFO_SHOW_MORE: action.PRODUCT_SKU_PROMOTION_INFO_SHOW_MORE
	      });
	    //是否展示所有颜色
	    case _ActionTypes.PDP.PRODUCT_SKU_PROMOTION_COLOR_SHOW_MORE:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_PROMOTION_COLOR_SHOW_MORE: action.PRODUCT_SKU_PROMOTION_COLOR_SHOW_MORE
	      });
	    //是否展示所有颜色列表
	    case _ActionTypes.PDP.PRODUCT_SKU_PROMOTION_COLOR_SELECTOR_SHOW_MORE:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_PROMOTION_COLOR_SELECTOR_SHOW_MORE: action.PRODUCT_SKU_PROMOTION_COLOR_SELECTOR_SHOW_MORE
	      });
	    //猜你喜欢广告位
	    case _ActionTypes.PDP.PRODUCT_AD_GUESS:
	      return Object.assign({}, state, {
	        PRODUCT_AD_GUESS: action.PRODUCT_AD_GUESS
	      });
	    //主广告位
	    case _ActionTypes.PDP.PRODUCT_AD_MAIN:
	      return Object.assign({}, state, {
	        PRODUCT_AD_MAIN: action.PRODUCT_AD_MAIN
	      });
	    //库存
	    case _ActionTypes.PDP.PRODUCT_INVENTORY:
	      return Object.assign({}, state, {
	        PRODUCT_INVENTORY: action.PRODUCT_INVENTORY
	      });
	    //猜你喜欢
	    case _ActionTypes.PDP.PRODUCT_GUESS_LIKE:
	      return Object.assign({}, state, {
	        PRODUCT_GUESS_LIKE: action.PRODUCT_GUESS_LIKE
	      });
	    //html是否执行了延迟加载
	    case _ActionTypes.PDP.PRODUCT_HTML_DOM:
	      return Object.assign({}, state, {
	        PRODUCT_HTML_DOM: action.PRODUCT_HTML_DOM
	      });
	    //点击色卡筛选系统，存储返回色系列表
	    case _ActionTypes.PDP.PRODUCT_COLOR_ITEM:
	      return Object.assign({}, state, {
	        PRODUCT_COLOR_ITEM: action.PRODUCT_COLOR_ITEM
	      });
	    case _ActionTypes.PDP.PRODUCT_COLOR_GATHER:
	      return Object.assign({}, state, {
	        PRODUCT_COLOR_GATHER: action.PRODUCT_COLOR_GATHER
	      });
	    case _ActionTypes.PDP.PRODUCT_COLOR_NESTED_INFO:
	      return Object.assign({}, state, {
	        PRODUCT_COLOR_NESTED_INFO: action.PRODUCT_COLOR_NESTED_INFO
	      });
	    case _ActionTypes.PDP.PRODUCT_CHARACTER_ITEM:
	      return Object.assign({}, state, {
	        PRODUCT_CHARACTER_ITEM: action.PRODUCT_CHARACTER_ITEM
	      });
	    case _ActionTypes.PDP.PRODUCT_SAVE_DATA:
	      return Object.assign({}, state, {
	        PRODUCT_SAVE_DATA: action.PRODUCT_SAVE_DATA
	      });
	    case _ActionTypes.PDP.PRODUCT_SAVE_DEFULT_SKUID:
	      return Object.assign({}, state, {
	        PRODUCT_SAVE_DEFULT_SKUID: action.PRODUCT_SAVE_DEFULT_SKUID
	      });
	    case _ActionTypes.PDP.PRODUCT_CHARACTER_LIST:
	      return Object.assign({}, state, {
	        PRODUCT_CHARACTER_LIST: action.PRODUCT_CHARACTER_LIST
	      });
	    case _ActionTypes.PDP.PRODUCT_SAVE_END_DATA:
	      return Object.assign({}, state, {
	        PRODUCT_SAVE_END_DATA: action.PRODUCT_SAVE_END_DATA
	      });
	    case _ActionTypes.PDP.PRODUCT_FILTER_CONDITION_DATA:
	      return Object.assign({}, state, {
	        PRODUCT_FILTER_CONDITION_DATA: action.PRODUCT_FILTER_CONDITION_DATA
	      });
	    case _ActionTypes.PDP.PRODUCT_FILTER_CONDITION_CHARACTER_DATA:
	      return Object.assign({}, state, {
	        PRODUCT_FILTER_CONDITION_CHARACTER_DATA: action.PRODUCT_FILTER_CONDITION_CHARACTER_DATA
	      });
	    case _ActionTypes.PDP.PRODUCT_STORAGE_COUNT:
	      return Object.assign({}, state, {
	        PRODUCT_STORAGE_COUNT: action.PRODUCT_STORAGE_COUNT
	      });
	    case _ActionTypes.PDP.PRODUCT_BOOKING_STAUTUS:
	      return Object.assign({}, state, {
	        PRODUCT_BOOKING_STAUTUS: action.PRODUCT_BOOKING_STAUTUS
	      });
	    case _ActionTypes.PDP.PRODUCT_SKU_PROMOTION_INFO_HANDLE_CLICK:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_PROMOTION_INFO_HANDLE_CLICK: action.PRODUCT_SKU_PROMOTION_INFO_HANDLE_CLICK
	      });
	    case _ActionTypes.PDP.PRODUCT_SKU_PROMOTION_INFO_GIFTS_DATA:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_PROMOTION_INFO_GIFTS_DATA: action.PRODUCT_SKU_PROMOTION_INFO_GIFTS_DATA
	      });
	    case _ActionTypes.PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_ID:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_PROMOTION_INFO_GIFT_ID: action.PRODUCT_SKU_PROMOTION_INFO_GIFT_ID
	      });
	    case _ActionTypes.PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_FIRST_PX:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_PROMOTION_INFO_GIFT_FIRST_PX: action.PRODUCT_SKU_PROMOTION_INFO_GIFT_FIRST_PX + state.PRODUCT_SKU_PROMOTION_INFO_GIFT_FIRST_PX
	      });
	    case _ActionTypes.PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_SECOND_PX:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_PROMOTION_INFO_GIFT_SECOND_PX: action.PRODUCT_SKU_PROMOTION_INFO_GIFT_SECOND_PX + state.PRODUCT_SKU_PROMOTION_INFO_GIFT_SECOND_PX
	      });
	    case _ActionTypes.PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_THIRD_PX:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_PROMOTION_INFO_GIFT_THIRD_PX: action.PRODUCT_SKU_PROMOTION_INFO_GIFT_THIRD_PX + state.PRODUCT_SKU_PROMOTION_INFO_GIFT_THIRD_PX
	      });
	    case _ActionTypes.PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_FOUR_PX:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_PROMOTION_INFO_GIFT_FOUR_PX: action.PRODUCT_SKU_PROMOTION_INFO_GIFT_FOUR_PX + state.PRODUCT_SKU_PROMOTION_INFO_GIFT_FOUR_PX
	      });
	    case _ActionTypes.PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_FIFTH_PX:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_PROMOTION_INFO_GIFT_FIFTH_PX: action.PRODUCT_SKU_PROMOTION_INFO_GIFT_FIFTH_PX + state.PRODUCT_SKU_PROMOTION_INFO_GIFT_FIFTH_PX
	      });
	    case _ActionTypes.PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_PX_EMPTY:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_PROMOTION_INFO_GIFT_FIRST_PX: action.PRODUCT_SKU_PROMOTION_INFO_GIFT_PX_EMPTY,
	        PRODUCT_SKU_PROMOTION_INFO_GIFT_SECOND_PX: action.PRODUCT_SKU_PROMOTION_INFO_GIFT_PX_EMPTY,
	        PRODUCT_SKU_PROMOTION_INFO_GIFT_THIRD_PX: action.PRODUCT_SKU_PROMOTION_INFO_GIFT_PX_EMPTY
	      });
	    case _ActionTypes.PDP.PRODUCT_SKU_PROMOTION_INFO_RECORD_TIME:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_PROMOTION_INFO_RECORD_TIME: action.PRODUCT_SKU_PROMOTION_INFO_RECORD_TIME
	      });
	    case _ActionTypes.PDP.PRODUCT_GUERLAIN_ROUGE_OFFSET:
	      return Object.assign({}, state, {
	        PRODUCT_GUERLAIN_ROUGE_OFFSET: action.PRODUCT_GUERLAIN_ROUGE_OFFSET + state.PRODUCT_GUERLAIN_ROUGE_OFFSET
	      });
	    case _ActionTypes.PDP.PRODUCT_GUERLAIN_ENTER:
	      return Object.assign({}, state, {
	        PRODUCT_GUERLAIN_ENTER: action.PRODUCT_GUERLAIN_ENTER
	      });
	    case _ActionTypes.PDP.PRODUCT_MIUMIU_ENTER:
	      return Object.assign({}, state, {
	        PRODUCT_MIUMIU_ENTER: action.PRODUCT_MIUMIU_ENTER
	      });
	
	    case _ActionTypes.PDP.PRODUCT_GUERLAIN_INFO:
	      return Object.assign({}, state, {
	        PRODUCT_GUERLAIN_INFO: action.PRODUCT_GUERLAIN_INFO
	      });
	    case _ActionTypes.PDP.PRODUCT_GUERLAIN_INFO_URL:
	      return Object.assign({}, state, {
	        PRODUCT_GUERLAIN_INFO_URL: action.PRODUCT_GUERLAIN_INFO_URL
	      });
	    case _ActionTypes.PDP.PRODUCT_MIUMIU_INFO_URL:
	      return Object.assign({}, state, {
	        PRODUCT_MIUMIU_INFO_URL: action.PRODUCT_MIUMIU_INFO_URL
	      });
	    case _ActionTypes.PDP.PRODUCT_MIUMIU_INFO:
	      return Object.assign({}, state, {
	        PRODUCT_MIUMIU_INFO: action.PRODUCT_MIUMIU_INFO
	      });
	    case _ActionTypes.PDP.PRODUCT_MIUMIU_INFO_ODOR_PITCH_ON:
	      return Object.assign({}, state, {
	        PRODUCT_MIUMIU_INFO_ODOR_PITCH_ON: action.PRODUCT_MIUMIU_INFO_ODOR_PITCH_ON
	      });
	
	    case _ActionTypes.PDP.PRODUCT_GUERLAIN_INFO_CAP:
	      return Object.assign({}, state, {
	        PRODUCT_GUERLAIN_INFO_CAP: action.PRODUCT_GUERLAIN_INFO_CAP
	      });
	    case _ActionTypes.PDP.PRODUCT_MIUMIU_INFO_TWO:
	      return Object.assign({}, state, {
	        PRODUCT_MIUMIU_INFO_TWO: action.PRODUCT_MIUMIU_INFO_TWO
	      });
	    case _ActionTypes.PDP.PRODUCT_MIUMIU_INFO_THREE:
	      return Object.assign({}, state, {
	        PRODUCT_MIUMIU_INFO_THREE: action.PRODUCT_MIUMIU_INFO_THREE
	      });
	    case _ActionTypes.PDP.PRODUCT_MIUMIU_INFO_LID_ON:
	      return Object.assign({}, state, {
	        PRODUCT_MIUMIU_INFO_LID_ON: action.PRODUCT_MIUMIU_INFO_LID_ON
	      });
	    case _ActionTypes.PDP.PRODUCT_MIUMIU_INFO_BODY_ON:
	      return Object.assign({}, state, {
	        PRODUCT_MIUMIU_INFO_BODY_ON: action.PRODUCT_MIUMIU_INFO_BODY_ON
	      });
	    case _ActionTypes.PDP.PRODUCT_GUERLAIN_INFO_COLOR_PITCH_ON:
	      return Object.assign({}, state, {
	        PRODUCT_GUERLAIN_INFO_COLOR_PITCH_ON: action.PRODUCT_GUERLAIN_INFO_COLOR_PITCH_ON
	      });
	    case _ActionTypes.PDP.PRODUCT_GUERLAIN_INFO_CAP_PITCH_ON:
	      return Object.assign({}, state, {
	        PRODUCT_GUERLAIN_INFO_CAP_PITCH_ON: action.PRODUCT_GUERLAIN_INFO_CAP_PITCH_ON
	      });
	    case _ActionTypes.PDP.PRODUCT_MIUMIU_INFO_CAP_PITCH_ON:
	      return Object.assign({}, state, {
	        PRODUCT_MIUMIU_INFO_CAP_PITCH_ON: action.PRODUCT_MIUMIU_INFO_CAP_PITCH_ON
	      });
	    case _ActionTypes.PDP.PRODUCT_SKU_PROMOTION_INFO_GWP:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_PROMOTION_INFO_GWP: action.PRODUCT_SKU_PROMOTION_INFO_GWP + state.PRODUCT_SKU_PROMOTION_INFO_GWP
	      });
	    case _ActionTypes.PDP.PRODUCT_VB_ISHIDE:
	      return Object.assign({}, state, {
	        PRODUCT_VB_ISHIDE: action.PRODUCT_VB_ISHIDE
	      });
	    case _ActionTypes.PDP.PRODUCT_VB_GIFT_LIST:
	      return Object.assign({}, state, {
	        PRODUCT_VB_GIFT_LIST: action.PRODUCT_VB_GIFT_LIST
	      });
	    case _ActionTypes.PDP.PRODUCT_SKU_PROMOTION_INFO_THE_POSTS:
	      return Object.assign({}, state, {
	        PRODUCT_SKU_PROMOTION_INFO_THE_POSTS: action.PRODUCT_SKU_PROMOTION_INFO_THE_POSTS + state.PRODUCT_SKU_PROMOTION_INFO_THE_POSTS
	      });
	    case _ActionTypes.PDP.PRODUCT_POSTS_LIST:
	      return Object.assign({}, state, {
	        PRODUCT_POSTS_LIST: action.PRODUCT_POSTS_LIST,
	        PRODUCT_POSTS_LIST_PAGE: action.PRODUCT_POSTS_LIST_PAGE
	      });
	    case _ActionTypes.PDP.PRODUCT_COMMENTS_REASON:
	      return Object.assign({}, state, {
	        PRODUCT_COMMENTS_REASON: action.PRODUCT_COMMENTS_REASON
	      });
	    case _ActionTypes.PDP.PRODUCT_COMMENTS_SWITCH:
	      return Object.assign({}, state, {
	        PRODUCT_COMMENTS_SWITCH: action.PRODUCT_COMMENTS_SWITCH,
	        PRODUCT_COMMENTS_USE_OPID: action.PRODUCT_COMMENTS_USE_OPID
	      });
	    case _ActionTypes.PDP.PRODUCT_GET_STANDING:
	      return Object.assign({}, state, {
	        PRODUCT_GET_STANDING: action.PRODUCT_GET_STANDING
	      });
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initialPDPState = {
	  PRODUCT_DETAIL_ERROR: null,
	  PRODUCT_DETAIL_MAIN: null,
	  PRODUCT_SKU_DETAIL_INFO: null,
	  PRODUCT_SKU_HTML: null,
	  PRODUCT_DETAIL_IMAGE: null,
	  PRODUCT_DETAIL_IMAGE_NOW: null,
	  PRODUCT_DETAIL_IMAGE_NOW_TAG: null,
	  PRODUCT_DETAIL_IMAGE_NOW_INDEX: null,
	  PRODUCT_BREADCRUMB: null,
	  PRODUCT_QA_LIST: null,
	  PRODUCT_QA_LIST_PAGE: null,
	  PRODUCT_COLLOCATION: null,
	  PRODUCT_COMMENTS_LIST: null,
	  PRODUCT_COMMENTS_LIST_PAGE: null,
	  PRODUCT_SKU_PROMOTION_INFO: null,
	  PRODUCT_SKU_PROMOTION_INFO_SHOW_MORE: false,
	  PRODUCT_SKU_PROMOTION_COLOR_SHOW_MORE: false,
	  PRODUCT_SKU_PROMOTION_COLOR_SELECTOR_SHOW_MORE: false,
	  PRODUCT_USER_BUY_ONE_YEAR: false,
	  PRODUCT_AD_GUESS: null,
	  PRODUCT_AD_MAIN: null,
	  PRODUCT_INVENTORY: 1,
	  PRODUCT_GUESS_LIKE: null,
	  PRODUCT_HTML_DOM: false,
	  PRODUCT_COLOR_ITEM: null,
	  PRODUCT_COLOR_GATHER: null,
	  PRODUCT_COLOR_NESTED_INFO: null,
	  PRODUCT_CHARACTER_ITEM: false,
	  PRODUCT_SAVE_DATA: null,
	  PRODUCT_SAVE_DEFULT_SKUID: null,
	  PRODUCT_CHARACTER_LIST: null,
	  PRODUCT_SAVE_END_DATA: null,
	  PRODUCT_FILTER_CONDITION_DATA: null,
	  PRODUCT_FILTER_CONDITION_CHARACTER_DATA: null,
	  PRODUCT_STORAGE_COUNT: true,
	  PRODUCT_BOOKING_STAUTUS: false,
	  PRODUCT_SKU_PROMOTION_INFO_HANDLE_CLICK: false,
	  PRODUCT_SKU_PROMOTION_INFO_GIFTS_DATA: null,
	  PRODUCT_SKU_PROMOTION_INFO_GIFT_ID: "",
	  PRODUCT_SKU_PROMOTION_INFO_GIFT_FIRST_PX: 1,
	  PRODUCT_SKU_PROMOTION_INFO_GIFT_SECOND_PX: 1,
	  PRODUCT_SKU_PROMOTION_INFO_GIFT_THIRD_PX: 1,
	  PRODUCT_SKU_PROMOTION_INFO_GIFT_FOUR_PX: 1,
	  PRODUCT_SKU_PROMOTION_INFO_GIFT_FIFTH_PX: 1,
	  PRODUCT_SKU_PROMOTION_INFO_RECORD_TIME: false,
	  PRODUCT_GUERLAIN_ROUGE_OFFSET: null,
	  PRODUCT_GUERLAIN_ENTER: null,
	  PRODUCT_GUERLAIN_INFO: null,
	  PRODUCT_GUERLAIN_INFO_URL: null,
	  PRODUCT_GUERLAIN_INFO_CAP: null,
	  PRODUCT_GUERLAIN_INFO_COLOR_PITCH_ON: null,
	  PRODUCT_GUERLAIN_INFO_CAP_PITCH_ON: null,
	  //miumiu
	  PRODUCT_MIUMIU_INFO_URL: null,
	  PRODUCT_MIUMIU_INFO: null,
	  PRODUCT_MIUMIU_INFO_ODOR_PITCH_ON: null,
	  PRODUCT_MIUMIU_INFO_CAP_PITCH_ON: null,
	  PRODUCT_MIUMIU_INFO_TWO: null,
	  PRODUCT_MIUMIU_INFO_THREE: null,
	  PRODUCT_MIUMIU_INFO_LID_ON: null,
	  PRODUCT_MIUMIU_INFO_BODY_ON: null,
	  PRODUCT_MIUMIU_ENTER: null,
	
	  PRODUCT_SKU_PROMOTION_INFO_GWP: 1,
	  PRODUCT_VB_GIFT_LIST: null,
	  PRODUCT_SKU_PROMOTION_INFO_THE_POSTS: 1,
	  PRODUCT_POSTS_LIST: null,
	  PRODUCT_POSTS_LIST_PAGE: 1,
	  PRODUCT_COMMENTS_REASON: "",
	  PRODUCT_COMMENTS_SWITCH: null,
	  PRODUCT_COMMENTS_USE_OPID: null
	};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	
	        case _ActionTypes.PURCHASERECORD.PURCHASERECORD:
	            return Object.assign({}, state, {
	                purchaseRecord: action.data
	            });
	            break;
	        default:
	            return state;break;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initState = {
	    purchaseRecord: null
	};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        default:
	            return state;
	    }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initialState = {};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialGlobalState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var MINI_CART = action.MINI_CART;
	  var MINI_CART_NUM = action.MINI_CART_NUM;
	  var ErrorCode = action.ERROR_CODE;
	  var USER_SHIPPING_ADDRESS_LIST = action.USER_SHIPPING_ADDRESS_LIST;
	  var USER_POINT = action.USER_POINT;
	
	  var USER_TOKEN = action.USER_TOKEN;
	  var USER_NICKNAME = action.USER_NICKNAME;
	  var USER_CARDTYPE = action.USER_CARDTYPE;
	  var USER_CARDPOINTS = action.USER_CARDPOINTS;
	  var USER_CARDNUMBER = action.USER_CARDNUMBER;
	  var USER_PAYPOINTS = action.USER_PAYPOINTS;
	  var USER_TYPE = action.USER_TYPE;
	
	  switch (action.type) {
	    case _ActionTypes.USER.USER_TOKEN:
	      return Object.assign({}, state, {
	        USER_TOKEN: USER_TOKEN
	      });
	    case _ActionTypes.USER.USER_NICKNAME:
	      return Object.assign({}, state, {
	        USER_NICKNAME: USER_NICKNAME
	      });
	    case _ActionTypes.USER.USER_CARDTYPE:
	      return Object.assign({}, state, {
	        USER_CARDTYPE: USER_CARDTYPE
	      });
	    case _ActionTypes.USER.USER_CARDPOINTS:
	      return Object.assign({}, state, {
	        USER_CARDPOINTS: USER_CARDPOINTS
	      });
	    case _ActionTypes.USER.USER_CARDNUMBER:
	      return Object.assign({}, state, {
	        USER_CARDNUMBER: USER_CARDNUMBER
	      });
	    case _ActionTypes.USER.USER_PAYPOINTS:
	      return Object.assign({}, state, {
	        USER_PAYPOINTS: USER_PAYPOINTS
	      });
	    case _ActionTypes.USER.USER_ID:
	      return Object.assign({}, state, {
	        USER_TYPE: USER_TYPE,
	        USER_POINT: USER_POINT
	      });
	    case _ActionTypes.USER.ERROR_CODE:
	      return Object.assign({}, state, {
	        ErrorCode: ErrorCode
	      });
	    case _ActionTypes.USER.MINI_CART:
	      return Object.assign({}, state, {
	        MINI_CART: MINI_CART
	      });
	    case _ActionTypes.USER.MINI_CART_NUM:
	      return Object.assign({}, state, {
	        MINI_CART_NUM: MINI_CART_NUM
	      });
	    case _ActionTypes.USER.USER_SHIPPING_ADDRESS_LIST:
	      return Object.assign({}, state, {
	        USER_SHIPPING_ADDRESS_LIST: USER_SHIPPING_ADDRESS_LIST
	      });
	    default:
	      return state;
	  }
	};
	
	var _ActionTypes = __webpack_require__(3);
	
	var initialGlobalState = {
	  MINI_CART: false,
	  MINI_CART_NUM: null,
	  ErrorCode: false,
	  USER_SHIPPING_ADDRESS_LIST: false,
	  USER_TYPE: false,
	  USER_POINT: false,
	
	  USER_TOKEN: false,
	  USER_NICKNAME: false,
	  USER_CARDTYPE: false,
	  USER_CARDPOINTS: false,
	  USER_CARDNUMBER: false,
	  USER_PAYPOINTS: false
	};

/***/ }),
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(173);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 490 */
/***/ (function(module, exports) {

	module.exports = {"registerPage":["current_url","current_page_type","platform_type","system_type","environment_type","referrer","vip_card","vip_card_type"],"clickSignUp":["$lib_detail"],"clickSignUpByStoreVip":["$lib_detail"],"signUpResult":["sign_up_method","if_success","failure_reason","is_member_from_store","$lib_detail","userID"],"loginResult":["login_channel","if_success","failure_reason","$lib_detail","userID"],"choose_existing_vip_card":["$lib_detail"],"record_vip_card":["vip_card","vip_card_type","if_choose_existing_vip_card","$lib_detail"],"clickBanner_web":["$lib_detail","banner_type","banner_content","banner_current_url","banner_current_page_type","banner_belong_area","banner_to_url","banner_to_page_type","banner_ranking","belong_team","campaign_code","key_word_tpye","key_word_tpye_details"],"startBuyNow":["$lib_detail","commodity_sku","OP_code"],"buyNow":["$lib_detail","commodity_sku","OP_code","commodity_number"],"viewCommodityDetail":["$lib_detail","commodity_sku","OP_code","referrer"],"addToShoppingcart":["$lib_detail","commodity_sku","OP_code","commodity_number"],"submitOrder":["page_id","action_id","orderID","userID","totalAmount","discount","coupons","freight","orderPrice"],"PDPClick":["OP_code","button_name"],"myAccountClick":["button_name"],"clickCommodityInform":["$lib_detail","commodity_sku","OP_code"],"MsgCenterExposure":["msg_type"],"TopRankingListClick":["OP_code","commodity_sku","current_url","topRankinglist_name"],"confirmOrder_deleteCommodityClick":["button_name"],"myAccount_CouponClick":["button_name","current_url"],"CustomerServiceClick":["platform_type","button_location"],"confirmOrder_ productClick":["OP_code","commodity_sku","current_url"],"ListClick":["page_id","action_id","$element_target_url","categoryId","button_name","brand_cn","brand_id","key_words","commodity_sku"],"ListProductClick":["page_id","action_id","OP_code","banner_ranking","commodity_sku"],"pointMall_rewardspoint_click":["page_id","action_id","button_name","commodity_sku","OP_code"],"$WebClick":["page_id","action_id","$element_content","button_name"],"$pageview":["page_id","action_id"],"orderComfirmConfig":["page_id","action_id","$element_content","commodity_sku","OP_code"],"submitOrderBySku":["page_id","action_id","orderID","userID","commodity_sku","OP_code","totalAmount"],"phoneAuthFail":["page_id","action_id"],"imageAuth":["page_id","action_id"],"imageAuthSuccess":["page_id","action_id"],"sendVerCode":["page_id","action_id"],"sendVerCodeSuccess":["page_id","action_id"],"phoneAuth":["page_id","action_id"],"phoneAuthSuccess":["page_id","action_id"],"imageAuthFail":["page_id","action_id"],"QRView_Web":["page_id","action_id","$element_content"]}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

	module.exports = [{"fieldKey":"platform_type","type":"string","autoComplete":"web"},{"fieldKey":"environment_type","type":"string","autoComplete":"get_environment_type"},{"fieldKey":"system_type","type":"string","autoComplete":"get_os"},{"fieldKey":"$lib_detail","type":"string"},{"fieldKey":"current_url","type":"string","autoComplete":"get_current_url"},{"fieldKey":"previous_url","type":"string","autoComplete":"get_previous_url"},{"fieldKey":"current_page_type","type":"string","autoComplete":"get_current_page_type"},{"fieldKey":"previous_page_type_new","type":"string","autoComplete":"get_previous_page_type_new"},{"fieldKey":"sign_up_method","type":"string","autoComplete":"get_sign_up_method"},{"fieldKey":"if_success","type":"boolean"},{"fieldKey":"failure_reason","type":"string"},{"fieldKey":"is_member_from_store","type":"boolean"},{"fieldKey":"login_channel","type":"string","autoComplete":"get_sign_up_method"},{"fieldKey":"vip_card","type":"string"},{"fieldKey":"vip_card_type","type":"string"},{"fieldKey":"if_choose_existing_vip_card","type":"boolean"},{"fieldKey":"banner_type","type":"string"},{"fieldKey":"banner_content","type":"string"},{"fieldKey":"banner_current_url","type":"string","autoComplete":"get_current_url"},{"fieldKey":"banner_current_page_type","type":"string","autoComplete":"get_current_page_type"},{"fieldKey":"banner_belong_area","type":"string"},{"fieldKey":"banner_to_url","type":"string"},{"fieldKey":"banner_to_page_type","type":"string","autoComplete":"get_banner_to_page_type"},{"fieldKey":"banner_ranking","type":"string"},{"fieldKey":"belong_team","type":"string"},{"fieldKey":"campaign_code","type":"string","autoComplete":"get_campaign_code"},{"fieldKey":"key_word_tpye","type":"string"},{"fieldKey":"key_word_tpye_details","type":"string"},{"fieldKey":"commodity_number","type":"number"},{"fieldKey":"commodity_sku","type":"string"},{"fieldKey":"OP_code","type":"string"},{"fieldKey":"orderID","type":"string"},{"fieldKey":"userID","type":"string"},{"fieldKey":"button_name","type":"string"},{"fieldKey":"referrer","type":"string","autoComplete":"get_previous_url"},{"fieldKey":"msg_type","type":"string"},{"fieldKey":"topRankinglist_name","type":"string"},{"fieldKey":"button_location","type":"string"},{"fieldKey":"topRankinglist_name","type":"string"},{"fieldKey":"$lib_detail","type":"string"},{"fieldKey":"totalAmount","type":"string"},{"fieldKey":"discount","type":"string"},{"fieldKey":"coupons","type":"string"},{"fieldKey":"freight","type":"string"},{"fieldKey":"orderPrice","type":"string"},{"fieldKey":"page_id","type":"string"},{"fieldKey":"action_id","type":"string"},{"fieldKey":"$element_content","type":"string"}]

/***/ }),
/* 492 */
/***/ (function(module, exports) {

	module.exports = {"storeId":10001,"catalogId":10052,"langId":-7}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(171),
	    getRawTag = __webpack_require__(496),
	    objectToString = __webpack_require__(497);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 494 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(498);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(171);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 497 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 498 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(494);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 500 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(502);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 502 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 503 */
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(88);
	
	var _interopRequireDefault = __webpack_require__(30);
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(124));
	
	var _react = _interopRequireWildcard(__webpack_require__(5));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(122));
	
	var _PropTypes = __webpack_require__(176);
	
	var _warning = _interopRequireDefault(__webpack_require__(123));
	
	var prefixUnsafeLifecycleMethods = typeof _react.default.forwardRef !== "undefined";
	var didWarnAboutReceivingStore = false;
	
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	
	  didWarnAboutReceivingStore = true;
	  (0, _warning.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider(storeKey) {
	  var _Provider$childContex;
	
	  if (storeKey === void 0) {
	    storeKey = 'store';
	  }
	
	  var subscriptionKey = storeKey + "Subscription";
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    (0, _inheritsLoose2.default)(Provider, _Component);
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      var _this;
	
	      _this = _Component.call(this, props, context) || this;
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    _proto.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    // Use UNSAFE_ event name where supported
	    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';
	
	    Provider.prototype[eventName] = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	  return Provider;
	}
	
	var _default = createProvider();
	
	exports.default = _default;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(30);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(87));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(89));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(174));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(513));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(506));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(507));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(508));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(509));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual.default : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual.default : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual.default : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2.default)({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = createConnect();
	
	exports.default = _default;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports.default = void 0;
	
	var _redux = __webpack_require__(13);
	
	var _wrapMapToProps = __webpack_require__(175);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports.default = _default;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports.default = void 0;
	
	var _wrapMapToProps = __webpack_require__(175);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports.default = _default;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(30);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(87));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(177));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2.default)({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports.default = _default;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(30);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(89));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(510));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(30);
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(123));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription =
	/*#__PURE__*/
	function () {
	  function Subscription(store, parentSub, onStateChange) {
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  var _proto = Subscription.prototype;
	
	  _proto.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  _proto.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  _proto.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  _proto.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  _proto.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(178);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(180);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ }),
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(183);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(184);
	
	var _isPlainObject = __webpack_require__(172);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(185);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(524);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(525)(module)))

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ })
/******/ ])));


// WEBPACK FOOTER //
// soa/bundle/vendor_aff071efbd474cf21cfc.js